export enum Unit {
  /**
   * group
   *
   * rec20
   */
  Group = "10",
  /**
   * outfit
   *
   * rec20
   */
  Outfit = "11",
  /**
   * ration
   *
   * rec20
   */
  Ration = "13",
  /**
   * shot
   *
   * rec20
   */
  Shot = "14",
  /**
   * stick, military
   *
   * rec20
   */
  StickMilitary = "15",
  /**
   * twenty foot container
   *
   * rec20
   */
  TwentyFootContainer = "20",
  /**
   * forty foot container
   *
   * rec20
   */
  FortyFootContainer = "21",
  /**
   * decilitre per gram
   *
   * rec20
   */
  DecilitrePerGram = "22",
  /**
   * gram per cubic centimetre
   *
   * rec20
   */
  GramPerCubicCentimetre = "23",
  /**
   * theoretical pound
   *
   * rec20
   */
  TheoreticalPound = "24",
  /**
   * gram per square centimetre
   *
   * rec20
   */
  GramPerSquareCentimetre = "25",
  /**
   * theoretical ton
   *
   * rec20
   */
  TheoreticalTon = "27",
  /**
   * kilogram per square metre
   *
   * rec20
   */
  KilogramPerSquareMetre = "28",
  /**
   * kilopascal square metre per gram
   *
   * rec20
   */
  KilopascalSquareMetrePerGram = "33",
  /**
   * kilopascal per millimetre
   *
   * rec20
   */
  KilopascalPerMillimetre = "34",
  /**
   * millilitre per square centimetre second
   *
   * rec20
   */
  MillilitrePerSquareCentimetreSecond = "35",
  /**
   * ounce per square foot
   *
   * rec20
   */
  OuncePerSquareFoot = "37",
  /**
   * ounce per square foot per 0,01inch
   *
   * rec20
   */
  OuncePerSquareFootPer001inch = "38",
  /**
   * millilitre per second
   *
   * rec20
   */
  MillilitrePerSecond = "40",
  /**
   * millilitre per minute
   *
   * rec20
   */
  MillilitrePerMinute = "41",
  /**
   * sitas
   *
   * rec20
   */
  Sitas = "56",
  /**
   * mesh
   *
   * rec20
   */
  Mesh = "57",
  /**
   * net kilogram
   *
   * rec20
   */
  NetKilogram = "58",
  /**
   * part per million
   *
   * rec20
   */
  PartPerMillion = "59",
  /**
   * percent weight
   *
   * rec20
   */
  PercentWeight = "60",
  /**
   * part per billion (US)
   *
   * rec20
   */
  PartPerBillionUs = "61",
  /**
   * millipascal
   *
   * rec20
   */
  Millipascal = "74",
  /**
   * milli-inch
   *
   * rec20
   */
  MilliInch = "77",
  /**
   * pound per square inch absolute
   *
   * rec20
   */
  PoundPerSquareInchAbsolute = "80",
  /**
   * henry
   *
   * rec20
   */
  Henry = "81",
  /**
   * foot pound-force
   *
   * rec20
   */
  FootPoundForce = "85",
  /**
   * pound per cubic foot
   *
   * rec20
   */
  PoundPerCubicFoot = "87",
  /**
   * poise
   *
   * rec20
   */
  Poise = "89",
  /**
   * stokes
   *
   * rec20
   */
  Stokes = "91",
  /**
   * fixed rate
   *
   * rec20
   */
  FixedRate = "1I",
  /**
   * radian per second
   *
   * rec20
   */
  RadianPerSecond = "2A",
  /**
   * radian per second squared
   *
   * rec20
   */
  RadianPerSecondSquared = "2B",
  /**
   * roentgen
   *
   * rec20
   */
  Roentgen = "2C",
  /**
   * volt AC
   *
   * rec20
   */
  VoltAc = "2G",
  /**
   * volt DC
   *
   * rec20
   */
  VoltDc = "2H",
  /**
   * British thermal unit (international table) per hour
   *
   * rec20
   */
  BritishThermalUnitInternationalTablePerHour = "2I",
  /**
   * cubic centimetre per second
   *
   * rec20
   */
  CubicCentimetrePerSecond = "2J",
  /**
   * cubic foot per hour
   *
   * rec20
   */
  CubicFootPerHour = "2K",
  /**
   * cubic foot per minute
   *
   * rec20
   */
  CubicFootPerMinute = "2L",
  /**
   * centimetre per second
   *
   * rec20
   */
  CentimetrePerSecond = "2M",
  /**
   * decibel
   *
   * rec20
   */
  Decibel = "2N",
  /**
   * kilobyte
   *
   * rec20
   */
  Kilobyte = "2P",
  /**
   * kilobecquerel
   *
   * rec20
   */
  Kilobecquerel = "2Q",
  /**
   * kilocurie
   *
   * rec20
   */
  Kilocurie = "2R",
  /**
   * megagram
   *
   * rec20
   */
  Megagram = "2U",
  /**
   * metre per minute
   *
   * rec20
   */
  MetrePerMinute = "2X",
  /**
   * milliroentgen
   *
   * rec20
   */
  Milliroentgen = "2Y",
  /**
   * millivolt
   *
   * rec20
   */
  Millivolt = "2Z",
  /**
   * megajoule
   *
   * rec20
   */
  Megajoule = "3B",
  /**
   * manmonth
   *
   * rec20
   */
  Manmonth = "3C",
  /**
   * centistokes
   *
   * rec20
   */
  Centistokes = "4C",
  /**
   * microlitre
   *
   * rec20
   */
  Microlitre = "4G",
  /**
   * micrometre (micron)
   *
   * rec20
   */
  MicrometreMicron = "4H",
  /**
   * milliampere
   *
   * rec20
   */
  Milliampere = "4K",
  /**
   * megabyte
   *
   * rec20
   */
  Megabyte = "4L",
  /**
   * milligram per hour
   *
   * rec20
   */
  MilligramPerHour = "4M",
  /**
   * megabecquerel
   *
   * rec20
   */
  Megabecquerel = "4N",
  /**
   * microfarad
   *
   * rec20
   */
  Microfarad = "4O",
  /**
   * newton per metre
   *
   * rec20
   */
  NewtonPerMetre = "4P",
  /**
   * ounce inch
   *
   * rec20
   */
  OunceInch = "4Q",
  /**
   * ounce foot
   *
   * rec20
   */
  OunceFoot = "4R",
  /**
   * picofarad
   *
   * rec20
   */
  Picofarad = "4T",
  /**
   * pound per hour
   *
   * rec20
   */
  PoundPerHour = "4U",
  /**
   * ton (US) per hour
   *
   * rec20
   */
  TonUsPerHour = "4W",
  /**
   * kilolitre per hour
   *
   * rec20
   */
  KilolitrePerHour = "4X",
  /**
   * barrel (US) per minute
   *
   * rec20
   */
  BarrelUsPerMinute = "5A",
  /**
   * batch
   *
   * rec20
   */
  Batch = "5B",
  /**
   * MMSCF/day
   *
   * rec20
   */
  MmscfDay = "5E",
  /**
   * hydraulic horse power
   *
   * rec20
   */
  HydraulicHorsePower = "5J",
  /**
   * ampere square metre per joule second
   *
   * rec20
   */
  AmpereSquareMetrePerJouleSecond = "A10",
  /**
   * angstrom
   *
   * rec20
   */
  Angstrom = "A11",
  /**
   * astronomical unit
   *
   * rec20
   */
  AstronomicalUnit = "A12",
  /**
   * attojoule
   *
   * rec20
   */
  Attojoule = "A13",
  /**
   * barn
   *
   * rec20
   */
  Barn = "A14",
  /**
   * barn per electronvolt
   *
   * rec20
   */
  BarnPerElectronvolt = "A15",
  /**
   * barn per steradian electronvolt
   *
   * rec20
   */
  BarnPerSteradianElectronvolt = "A16",
  /**
   * barn per steradian
   *
   * rec20
   */
  BarnPerSteradian = "A17",
  /**
   * becquerel per kilogram
   *
   * rec20
   */
  BecquerelPerKilogram = "A18",
  /**
   * becquerel per cubic metre
   *
   * rec20
   */
  BecquerelPerCubicMetre = "A19",
  /**
   * ampere per centimetre
   *
   * rec20
   */
  AmperePerCentimetre = "A2",
  /**
   * British thermal unit (international table) per second square foot degree Rankine
   *
   * rec20
   */
  BritishThermalUnitInternationalTablePerSecondSquareFootDegreeRankine = "A20",
  /**
   * British thermal unit (international table) per pound degree Rankine
   *
   * rec20
   */
  BritishThermalUnitInternationalTablePerPoundDegreeRankine = "A21",
  /**
   * British thermal unit (international table) per second foot degree Rankine
   *
   * rec20
   */
  BritishThermalUnitInternationalTablePerSecondFootDegreeRankine = "A22",
  /**
   * British thermal unit (international table) per hour square foot degree Rankine
   *
   * rec20
   */
  BritishThermalUnitInternationalTablePerHourSquareFootDegreeRankine = "A23",
  /**
   * candela per square metre
   *
   * rec20
   */
  CandelaPerSquareMetre = "A24",
  /**
   * coulomb metre
   *
   * rec20
   */
  CoulombMetre = "A26",
  /**
   * coulomb metre squared per volt
   *
   * rec20
   */
  CoulombMetreSquaredPerVolt = "A27",
  /**
   * coulomb per cubic centimetre
   *
   * rec20
   */
  CoulombPerCubicCentimetre = "A28",
  /**
   * coulomb per cubic metre
   *
   * rec20
   */
  CoulombPerCubicMetre = "A29",
  /**
   * ampere per millimetre
   *
   * rec20
   */
  AmperePerMillimetre = "A3",
  /**
   * coulomb per cubic millimetre
   *
   * rec20
   */
  CoulombPerCubicMillimetre = "A30",
  /**
   * coulomb per kilogram second
   *
   * rec20
   */
  CoulombPerKilogramSecond = "A31",
  /**
   * coulomb per mole
   *
   * rec20
   */
  CoulombPerMole = "A32",
  /**
   * coulomb per square centimetre
   *
   * rec20
   */
  CoulombPerSquareCentimetre = "A33",
  /**
   * coulomb per square metre
   *
   * rec20
   */
  CoulombPerSquareMetre = "A34",
  /**
   * coulomb per square millimetre
   *
   * rec20
   */
  CoulombPerSquareMillimetre = "A35",
  /**
   * cubic centimetre per mole
   *
   * rec20
   */
  CubicCentimetrePerMole = "A36",
  /**
   * cubic decimetre per mole
   *
   * rec20
   */
  CubicDecimetrePerMole = "A37",
  /**
   * cubic metre per coulomb
   *
   * rec20
   */
  CubicMetrePerCoulomb = "A38",
  /**
   * cubic metre per kilogram
   *
   * rec20
   */
  CubicMetrePerKilogram = "A39",
  /**
   * ampere per square centimetre
   *
   * rec20
   */
  AmperePerSquareCentimetre = "A4",
  /**
   * cubic metre per mole
   *
   * rec20
   */
  CubicMetrePerMole = "A40",
  /**
   * ampere per square metre
   *
   * rec20
   */
  AmperePerSquareMetre = "A41",
  /**
   * curie per kilogram
   *
   * rec20
   */
  CuriePerKilogram = "A42",
  /**
   * deadweight tonnage
   *
   * rec20
   */
  DeadweightTonnage = "A43",
  /**
   * decalitre
   *
   * rec20
   */
  Decalitre = "A44",
  /**
   * decametre
   *
   * rec20
   */
  Decametre = "A45",
  /**
   * decitex
   *
   * rec20
   */
  Decitex = "A47",
  /**
   * degree Rankine
   *
   * rec20
   */
  DegreeRankine = "A48",
  /**
   * denier
   *
   * rec20
   */
  Denier = "A49",
  /**
   * ampere square metre
   *
   * rec20
   */
  AmpereSquareMetre = "A5",
  /**
   * electronvolt
   *
   * rec20
   */
  Electronvolt = "A53",
  /**
   * electronvolt per metre
   *
   * rec20
   */
  ElectronvoltPerMetre = "A54",
  /**
   * electronvolt square metre
   *
   * rec20
   */
  ElectronvoltSquareMetre = "A55",
  /**
   * electronvolt square metre per kilogram
   *
   * rec20
   */
  ElectronvoltSquareMetrePerKilogram = "A56",
  /**
   * 8-part cloud cover
   *
   * rec20
   */
  _8PartCloudCover = "A59",
  /**
   * ampere per square metre kelvin squared
   *
   * rec20
   */
  AmperePerSquareMetreKelvinSquared = "A6",
  /**
   * exajoule
   *
   * rec20
   */
  Exajoule = "A68",
  /**
   * farad per metre
   *
   * rec20
   */
  FaradPerMetre = "A69",
  /**
   * ampere per square millimetre
   *
   * rec20
   */
  AmperePerSquareMillimetre = "A7",
  /**
   * femtojoule
   *
   * rec20
   */
  Femtojoule = "A70",
  /**
   * femtometre
   *
   * rec20
   */
  Femtometre = "A71",
  /**
   * foot per second squared
   *
   * rec20
   */
  FootPerSecondSquared = "A73",
  /**
   * foot pound-force per second
   *
   * rec20
   */
  FootPoundForcePerSecond = "A74",
  /**
   * freight ton
   *
   * rec20
   */
  FreightTon = "A75",
  /**
   * gal
   *
   * rec20
   */
  Gal = "A76",
  /**
   * ampere second
   *
   * rec20
   */
  AmpereSecond = "A8",
  /**
   * gigacoulomb per cubic metre
   *
   * rec20
   */
  GigacoulombPerCubicMetre = "A84",
  /**
   * gigaelectronvolt
   *
   * rec20
   */
  Gigaelectronvolt = "A85",
  /**
   * gigahertz
   *
   * rec20
   */
  Gigahertz = "A86",
  /**
   * gigaohm
   *
   * rec20
   */
  Gigaohm = "A87",
  /**
   * gigaohm metre
   *
   * rec20
   */
  GigaohmMetre = "A88",
  /**
   * gigapascal
   *
   * rec20
   */
  Gigapascal = "A89",
  /**
   * rate
   *
   * rec20
   */
  Rate = "A9",
  /**
   * gigawatt
   *
   * rec20
   */
  Gigawatt = "A90",
  /**
   * gon
   *
   * rec20
   */
  Gon = "A91",
  /**
   * gram per cubic metre
   *
   * rec20
   */
  GramPerCubicMetre = "A93",
  /**
   * gram per mole
   *
   * rec20
   */
  GramPerMole = "A94",
  /**
   * gray
   *
   * rec20
   */
  Gray = "A95",
  /**
   * gray per second
   *
   * rec20
   */
  GrayPerSecond = "A96",
  /**
   * hectopascal
   *
   * rec20
   */
  Hectopascal = "A97",
  /**
   * henry per metre
   *
   * rec20
   */
  HenryPerMetre = "A98",
  /**
   * bit
   *
   * rec20
   */
  Bit = "A99",
  /**
   * ball
   *
   * rec20
   */
  Ball = "AA",
  /**
   * bulk pack
   *
   * rec20
   */
  BulkPack = "AB",
  /**
   * acre
   *
   * rec20
   */
  Acre = "ACR",
  /**
   * activity
   *
   * rec20
   */
  Activity = "ACT",
  /**
   * byte
   *
   * rec20
   */
  Byte = "AD",
  /**
   * ampere per metre
   *
   * rec20
   */
  AmperePerMetre = "AE",
  /**
   * additional minute
   *
   * rec20
   */
  AdditionalMinute = "AH",
  /**
   * average minute per call
   *
   * rec20
   */
  AverageMinutePerCall = "AI",
  /**
   * fathom
   *
   * rec20
   */
  Fathom = "AK",
  /**
   * access line
   *
   * rec20
   */
  AccessLine = "AL",
  /**
   * ampere hour
   *
   * rec20
   */
  AmpereHour = "AMH",
  /**
   * ampere
   *
   * rec20
   */
  Ampere = "AMP",
  /**
   * year
   *
   * rec20
   */
  Year = "ANN",
  /**
   * troy ounce or apothecary ounce
   *
   * rec20
   */
  TroyOunceOrApothecaryOunce = "APZ",
  /**
   * anti-hemophilic factor (AHF) unit
   *
   * rec20
   */
  AntiHemophilicFactorAhfUnit = "AQ",
  /**
   * assortment
   *
   * rec20
   */
  Assortment = "AS",
  /**
   * alcoholic strength by mass
   *
   * rec20
   */
  AlcoholicStrengthByMass = "ASM",
  /**
   * alcoholic strength by volume
   *
   * rec20
   */
  AlcoholicStrengthByVolume = "ASU",
  /**
   * standard atmosphere
   *
   * rec20
   */
  StandardAtmosphere = "ATM",
  /**
   * american wire gauge
   *
   * rec20
   */
  AmericanWireGauge = "AWG",
  /**
   * assembly
   *
   * rec20
   */
  Assembly = "AY",
  /**
   * British thermal unit (international table) per pound
   *
   * rec20
   */
  BritishThermalUnitInternationalTablePerPound = "AZ",
  /**
   * barrel (US) per day
   *
   * rec20
   */
  BarrelUsPerDay = "B1",
  /**
   * bit per second
   *
   * rec20
   */
  BitPerSecond = "B10",
  /**
   * joule per kilogram kelvin
   *
   * rec20
   */
  JoulePerKilogramKelvin = "B11",
  /**
   * joule per metre
   *
   * rec20
   */
  JoulePerMetre = "B12",
  /**
   * joule per square metre
   *
   * rec20
   */
  JoulePerSquareMetre = "B13",
  /**
   * joule per metre to the fourth power
   *
   * rec20
   */
  JoulePerMetreToFourthPower = "B14",
  /**
   * joule per mole
   *
   * rec20
   */
  JoulePerMole = "B15",
  /**
   * joule per mole kelvin
   *
   * rec20
   */
  JoulePerMoleKelvin = "B16",
  /**
   * credit
   *
   * rec20
   */
  Credit = "B17",
  /**
   * joule second
   *
   * rec20
   */
  JouleSecond = "B18",
  /**
   * digit
   *
   * rec20
   */
  Digit = "B19",
  /**
   * joule square metre per kilogram
   *
   * rec20
   */
  JouleSquareMetrePerKilogram = "B20",
  /**
   * kelvin per watt
   *
   * rec20
   */
  KelvinPerWatt = "B21",
  /**
   * kiloampere
   *
   * rec20
   */
  Kiloampere = "B22",
  /**
   * kiloampere per square metre
   *
   * rec20
   */
  KiloamperePerSquareMetre = "B23",
  /**
   * kiloampere per metre
   *
   * rec20
   */
  KiloamperePerMetre = "B24",
  /**
   * kilobecquerel per kilogram
   *
   * rec20
   */
  KilobecquerelPerKilogram = "B25",
  /**
   * kilocoulomb
   *
   * rec20
   */
  Kilocoulomb = "B26",
  /**
   * kilocoulomb per cubic metre
   *
   * rec20
   */
  KilocoulombPerCubicMetre = "B27",
  /**
   * kilocoulomb per square metre
   *
   * rec20
   */
  KilocoulombPerSquareMetre = "B28",
  /**
   * kiloelectronvolt
   *
   * rec20
   */
  Kiloelectronvolt = "B29",
  /**
   * batting pound
   *
   * rec20
   */
  BattingPound = "B3",
  /**
   * gibibit
   *
   * rec20
   */
  Gibibit = "B30",
  /**
   * kilogram metre per second
   *
   * rec20
   */
  KilogramMetrePerSecond = "B31",
  /**
   * kilogram metre squared
   *
   * rec20
   */
  KilogramMetreSquared = "B32",
  /**
   * kilogram metre squared per second
   *
   * rec20
   */
  KilogramMetreSquaredPerSecond = "B33",
  /**
   * kilogram per cubic decimetre
   *
   * rec20
   */
  KilogramPerCubicDecimetre = "B34",
  /**
   * kilogram per litre
   *
   * rec20
   */
  KilogramPerLitre = "B35",
  /**
   * barrel, imperial
   *
   * rec20
   */
  BarrelImperial = "B4",
  /**
   * kilojoule per kelvin
   *
   * rec20
   */
  KilojoulePerKelvin = "B41",
  /**
   * kilojoule per kilogram
   *
   * rec20
   */
  KilojoulePerKilogram = "B42",
  /**
   * kilojoule per kilogram kelvin
   *
   * rec20
   */
  KilojoulePerKilogramKelvin = "B43",
  /**
   * kilojoule per mole
   *
   * rec20
   */
  KilojoulePerMole = "B44",
  /**
   * kilomole
   *
   * rec20
   */
  Kilomole = "B45",
  /**
   * kilomole per cubic metre
   *
   * rec20
   */
  KilomolePerCubicMetre = "B46",
  /**
   * kilonewton
   *
   * rec20
   */
  Kilonewton = "B47",
  /**
   * kilonewton metre
   *
   * rec20
   */
  KilonewtonMetre = "B48",
  /**
   * kiloohm
   *
   * rec20
   */
  Kiloohm = "B49",
  /**
   * kiloohm metre
   *
   * rec20
   */
  KiloohmMetre = "B50",
  /**
   * kilosecond
   *
   * rec20
   */
  Kilosecond = "B52",
  /**
   * kilosiemens
   *
   * rec20
   */
  Kilosiemens = "B53",
  /**
   * kilosiemens per metre
   *
   * rec20
   */
  KilosiemensPerMetre = "B54",
  /**
   * kilovolt per metre
   *
   * rec20
   */
  KilovoltPerMetre = "B55",
  /**
   * kiloweber per metre
   *
   * rec20
   */
  KiloweberPerMetre = "B56",
  /**
   * light year
   *
   * rec20
   */
  LightYear = "B57",
  /**
   * litre per mole
   *
   * rec20
   */
  LitrePerMole = "B58",
  /**
   * lumen hour
   *
   * rec20
   */
  LumenHour = "B59",
  /**
   * lumen per square metre
   *
   * rec20
   */
  LumenPerSquareMetre = "B60",
  /**
   * lumen per watt
   *
   * rec20
   */
  LumenPerWatt = "B61",
  /**
   * lumen second
   *
   * rec20
   */
  LumenSecond = "B62",
  /**
   * lux hour
   *
   * rec20
   */
  LuxHour = "B63",
  /**
   * lux second
   *
   * rec20
   */
  LuxSecond = "B64",
  /**
   * megaampere per square metre
   *
   * rec20
   */
  MegaamperePerSquareMetre = "B66",
  /**
   * megabecquerel per kilogram
   *
   * rec20
   */
  MegabecquerelPerKilogram = "B67",
  /**
   * gigabit
   *
   * rec20
   */
  Gigabit = "B68",
  /**
   * megacoulomb per cubic metre
   *
   * rec20
   */
  MegacoulombPerCubicMetre = "B69",
  /**
   * cycle
   *
   * rec20
   */
  Cycle = "B7",
  /**
   * megacoulomb per square metre
   *
   * rec20
   */
  MegacoulombPerSquareMetre = "B70",
  /**
   * megaelectronvolt
   *
   * rec20
   */
  Megaelectronvolt = "B71",
  /**
   * megagram per cubic metre
   *
   * rec20
   */
  MegagramPerCubicMetre = "B72",
  /**
   * meganewton
   *
   * rec20
   */
  Meganewton = "B73",
  /**
   * meganewton metre
   *
   * rec20
   */
  MeganewtonMetre = "B74",
  /**
   * megaohm
   *
   * rec20
   */
  Megaohm = "B75",
  /**
   * megaohm metre
   *
   * rec20
   */
  MegaohmMetre = "B76",
  /**
   * megasiemens per metre
   *
   * rec20
   */
  MegasiemensPerMetre = "B77",
  /**
   * megavolt
   *
   * rec20
   */
  Megavolt = "B78",
  /**
   * megavolt per metre
   *
   * rec20
   */
  MegavoltPerMetre = "B79",
  /**
   * joule per cubic metre
   *
   * rec20
   */
  JoulePerCubicMetre = "B8",
  /**
   * gigabit per second
   *
   * rec20
   */
  GigabitPerSecond = "B80",
  /**
   * reciprocal metre squared reciprocal second
   *
   * rec20
   */
  ReciprocalMetreSquaredReciprocalSecond = "B81",
  /**
   * inch per linear foot
   *
   * rec20
   */
  InchPerLinearFoot = "B82",
  /**
   * metre to the fourth power
   *
   * rec20
   */
  MetreToFourthPower = "B83",
  /**
   * microampere
   *
   * rec20
   */
  Microampere = "B84",
  /**
   * microbar
   *
   * rec20
   */
  Microbar = "B85",
  /**
   * microcoulomb
   *
   * rec20
   */
  Microcoulomb = "B86",
  /**
   * microcoulomb per cubic metre
   *
   * rec20
   */
  MicrocoulombPerCubicMetre = "B87",
  /**
   * microcoulomb per square metre
   *
   * rec20
   */
  MicrocoulombPerSquareMetre = "B88",
  /**
   * microfarad per metre
   *
   * rec20
   */
  MicrofaradPerMetre = "B89",
  /**
   * microhenry
   *
   * rec20
   */
  Microhenry = "B90",
  /**
   * microhenry per metre
   *
   * rec20
   */
  MicrohenryPerMetre = "B91",
  /**
   * micronewton
   *
   * rec20
   */
  Micronewton = "B92",
  /**
   * micronewton metre
   *
   * rec20
   */
  MicronewtonMetre = "B93",
  /**
   * microohm
   *
   * rec20
   */
  Microohm = "B94",
  /**
   * microohm metre
   *
   * rec20
   */
  MicroohmMetre = "B95",
  /**
   * micropascal
   *
   * rec20
   */
  Micropascal = "B96",
  /**
   * microradian
   *
   * rec20
   */
  Microradian = "B97",
  /**
   * microsecond
   *
   * rec20
   */
  Microsecond = "B98",
  /**
   * microsiemens
   *
   * rec20
   */
  Microsiemens = "B99",
  /**
   * bar [unit of pressure]
   *
   * rec20
   */
  BarUnitPressure = "BAR",
  /**
   * base box
   *
   * rec20
   */
  BaseBox = "BB",
  /**
   * board foot
   *
   * rec20
   */
  BoardFoot = "BFT",
  /**
   * brake horse power
   *
   * rec20
   */
  BrakeHorsePower = "BHP",
  /**
   * billion (EUR)
   *
   * rec20
   */
  BillionEur = "BIL",
  /**
   * dry barrel (US)
   *
   * rec20
   */
  DryBarrelUs = "BLD",
  /**
   * barrel (US)
   *
   * rec20
   */
  BarrelUs = "BLL",
  /**
   * hundred board foot
   *
   * rec20
   */
  HundredBoardFoot = "BP",
  /**
   * beats per minute
   *
   * rec20
   */
  BeatsPerMinute = "BPM",
  /**
   * becquerel
   *
   * rec20
   */
  Becquerel = "BQL",
  /**
   * British thermal unit (international table)
   *
   * rec20
   */
  BritishThermalUnitInternationalTable = "BTU",
  /**
   * bushel (US)
   *
   * rec20
   */
  BushelUs = "BUA",
  /**
   * bushel (UK)
   *
   * rec20
   */
  BushelUk = "BUI",
  /**
   * call
   *
   * rec20
   */
  Call = "C0",
  /**
   * millifarad
   *
   * rec20
   */
  Millifarad = "C10",
  /**
   * milligal
   *
   * rec20
   */
  Milligal = "C11",
  /**
   * milligram per metre
   *
   * rec20
   */
  MilligramPerMetre = "C12",
  /**
   * milligray
   *
   * rec20
   */
  Milligray = "C13",
  /**
   * millihenry
   *
   * rec20
   */
  Millihenry = "C14",
  /**
   * millijoule
   *
   * rec20
   */
  Millijoule = "C15",
  /**
   * millimetre per second
   *
   * rec20
   */
  MillimetrePerSecond = "C16",
  /**
   * millimetre squared per second
   *
   * rec20
   */
  MillimetreSquaredPerSecond = "C17",
  /**
   * millimole
   *
   * rec20
   */
  Millimole = "C18",
  /**
   * mole per kilogram
   *
   * rec20
   */
  MolePerKilogram = "C19",
  /**
   * millinewton
   *
   * rec20
   */
  Millinewton = "C20",
  /**
   * kibibit
   *
   * rec20
   */
  Kibibit = "C21",
  /**
   * millinewton per metre
   *
   * rec20
   */
  MillinewtonPerMetre = "C22",
  /**
   * milliohm metre
   *
   * rec20
   */
  MilliohmMetre = "C23",
  /**
   * millipascal second
   *
   * rec20
   */
  MillipascalSecond = "C24",
  /**
   * milliradian
   *
   * rec20
   */
  Milliradian = "C25",
  /**
   * millisecond
   *
   * rec20
   */
  Millisecond = "C26",
  /**
   * millisiemens
   *
   * rec20
   */
  Millisiemens = "C27",
  /**
   * millisievert
   *
   * rec20
   */
  Millisievert = "C28",
  /**
   * millitesla
   *
   * rec20
   */
  Millitesla = "C29",
  /**
   * microvolt per metre
   *
   * rec20
   */
  MicrovoltPerMetre = "C3",
  /**
   * millivolt per metre
   *
   * rec20
   */
  MillivoltPerMetre = "C30",
  /**
   * milliwatt
   *
   * rec20
   */
  Milliwatt = "C31",
  /**
   * milliwatt per square metre
   *
   * rec20
   */
  MilliwattPerSquareMetre = "C32",
  /**
   * milliweber
   *
   * rec20
   */
  Milliweber = "C33",
  /**
   * mole
   *
   * rec20
   */
  Mole = "C34",
  /**
   * mole per cubic decimetre
   *
   * rec20
   */
  MolePerCubicDecimetre = "C35",
  /**
   * mole per cubic metre
   *
   * rec20
   */
  MolePerCubicMetre = "C36",
  /**
   * kilobit
   *
   * rec20
   */
  Kilobit = "C37",
  /**
   * mole per litre
   *
   * rec20
   */
  MolePerLitre = "C38",
  /**
   * nanoampere
   *
   * rec20
   */
  Nanoampere = "C39",
  /**
   * nanocoulomb
   *
   * rec20
   */
  Nanocoulomb = "C40",
  /**
   * nanofarad
   *
   * rec20
   */
  Nanofarad = "C41",
  /**
   * nanofarad per metre
   *
   * rec20
   */
  NanofaradPerMetre = "C42",
  /**
   * nanohenry
   *
   * rec20
   */
  Nanohenry = "C43",
  /**
   * nanohenry per metre
   *
   * rec20
   */
  NanohenryPerMetre = "C44",
  /**
   * nanometre
   *
   * rec20
   */
  Nanometre = "C45",
  /**
   * nanoohm metre
   *
   * rec20
   */
  NanoohmMetre = "C46",
  /**
   * nanosecond
   *
   * rec20
   */
  Nanosecond = "C47",
  /**
   * nanotesla
   *
   * rec20
   */
  Nanotesla = "C48",
  /**
   * nanowatt
   *
   * rec20
   */
  Nanowatt = "C49",
  /**
   * neper
   *
   * rec20
   */
  Neper = "C50",
  /**
   * neper per second
   *
   * rec20
   */
  NeperPerSecond = "C51",
  /**
   * picometre
   *
   * rec20
   */
  Picometre = "C52",
  /**
   * newton metre second
   *
   * rec20
   */
  NewtonMetreSecond = "C53",
  /**
   * newton metre squared per kilogram squared
   *
   * rec20
   */
  NewtonMetreSquaredPerKilogramSquared = "C54",
  /**
   * newton per square metre
   *
   * rec20
   */
  NewtonPerSquareMetre = "C55",
  /**
   * newton per square millimetre
   *
   * rec20
   */
  NewtonPerSquareMillimetre = "C56",
  /**
   * newton second
   *
   * rec20
   */
  NewtonSecond = "C57",
  /**
   * newton second per metre
   *
   * rec20
   */
  NewtonSecondPerMetre = "C58",
  /**
   * octave
   *
   * rec20
   */
  Octave = "C59",
  /**
   * ohm centimetre
   *
   * rec20
   */
  OhmCentimetre = "C60",
  /**
   * ohm metre
   *
   * rec20
   */
  OhmMetre = "C61",
  /**
   * one
   *
   * rec20
   */
  One = "C62",
  /**
   * parsec
   *
   * rec20
   */
  Parsec = "C63",
  /**
   * pascal per kelvin
   *
   * rec20
   */
  PascalPerKelvin = "C64",
  /**
   * pascal second
   *
   * rec20
   */
  PascalSecond = "C65",
  /**
   * pascal second per cubic metre
   *
   * rec20
   */
  PascalSecondPerCubicMetre = "C66",
  /**
   * pascal second per metre
   *
   * rec20
   */
  PascalSecondPerMetre = "C67",
  /**
   * petajoule
   *
   * rec20
   */
  Petajoule = "C68",
  /**
   * phon
   *
   * rec20
   */
  Phon = "C69",
  /**
   * centipoise
   *
   * rec20
   */
  Centipoise = "C7",
  /**
   * picoampere
   *
   * rec20
   */
  Picoampere = "C70",
  /**
   * picocoulomb
   *
   * rec20
   */
  Picocoulomb = "C71",
  /**
   * picofarad per metre
   *
   * rec20
   */
  PicofaradPerMetre = "C72",
  /**
   * picohenry
   *
   * rec20
   */
  Picohenry = "C73",
  /**
   * kilobit per second
   *
   * rec20
   */
  KilobitPerSecond = "C74",
  /**
   * picowatt
   *
   * rec20
   */
  Picowatt = "C75",
  /**
   * picowatt per square metre
   *
   * rec20
   */
  PicowattPerSquareMetre = "C76",
  /**
   * pound-force
   *
   * rec20
   */
  PoundForce = "C78",
  /**
   * kilovolt ampere hour
   *
   * rec20
   */
  KilovoltAmpereHour = "C79",
  /**
   * millicoulomb per kilogram
   *
   * rec20
   */
  MillicoulombPerKilogram = "C8",
  /**
   * rad
   *
   * rec20
   */
  Rad = "C80",
  /**
   * radian
   *
   * rec20
   */
  Radian = "C81",
  /**
   * radian square metre per mole
   *
   * rec20
   */
  RadianSquareMetrePerMole = "C82",
  /**
   * radian square metre per kilogram
   *
   * rec20
   */
  RadianSquareMetrePerKilogram = "C83",
  /**
   * radian per metre
   *
   * rec20
   */
  RadianPerMetre = "C84",
  /**
   * reciprocal angstrom
   *
   * rec20
   */
  ReciprocalAngstrom = "C85",
  /**
   * reciprocal cubic metre
   *
   * rec20
   */
  ReciprocalCubicMetre = "C86",
  /**
   * reciprocal cubic metre per second
   *
   * rec20
   */
  ReciprocalCubicMetrePerSecond = "C87",
  /**
   * reciprocal electron volt per cubic metre
   *
   * rec20
   */
  ReciprocalElectronVoltPerCubicMetre = "C88",
  /**
   * reciprocal henry
   *
   * rec20
   */
  ReciprocalHenry = "C89",
  /**
   * coil group
   *
   * rec20
   */
  CoilGroup = "C9",
  /**
   * reciprocal joule per cubic metre
   *
   * rec20
   */
  ReciprocalJoulePerCubicMetre = "C90",
  /**
   * reciprocal kelvin or kelvin to the power minus one
   *
   * rec20
   */
  ReciprocalKelvinOrKelvinToPowerMinusOne = "C91",
  /**
   * reciprocal metre
   *
   * rec20
   */
  ReciprocalMetre = "C92",
  /**
   * reciprocal square metre
   *
   * rec20
   */
  ReciprocalSquareMetre = "C93",
  /**
   * reciprocal minute
   *
   * rec20
   */
  ReciprocalMinute = "C94",
  /**
   * reciprocal mole
   *
   * rec20
   */
  ReciprocalMole = "C95",
  /**
   * reciprocal pascal or pascal to the power minus one
   *
   * rec20
   */
  ReciprocalPascalOrPascalToPowerMinusOne = "C96",
  /**
   * reciprocal second
   *
   * rec20
   */
  ReciprocalSecond = "C97",
  /**
   * reciprocal second per metre squared
   *
   * rec20
   */
  ReciprocalSecondPerMetreSquared = "C99",
  /**
   * carrying capacity in metric ton
   *
   * rec20
   */
  CarryingCapacityInMetricTon = "CCT",
  /**
   * candela
   *
   * rec20
   */
  Candela = "CDL",
  /**
   * degree Celsius
   *
   * rec20
   */
  DegreeCelsius = "CEL",
  /**
   * hundred
   *
   * rec20
   */
  Hundred = "CEN",
  /**
   * card
   *
   * rec20
   */
  Card = "CG",
  /**
   * centigram
   *
   * rec20
   */
  Centigram = "CGM",
  /**
   * coulomb per kilogram
   *
   * rec20
   */
  CoulombPerKilogram = "CKG",
  /**
   * hundred leave
   *
   * rec20
   */
  HundredLeave = "CLF",
  /**
   * centilitre
   *
   * rec20
   */
  Centilitre = "CLT",
  /**
   * square centimetre
   *
   * rec20
   */
  SquareCentimetre = "CMK",
  /**
   * cubic centimetre
   *
   * rec20
   */
  CubicCentimetre = "CMQ",
  /**
   * centimetre
   *
   * rec20
   */
  Centimetre = "CMT",
  /**
   * hundred pack
   *
   * rec20
   */
  HundredPack = "CNP",
  /**
   * cental (UK)
   *
   * rec20
   */
  CentalUk = "CNT",
  /**
   * coulomb
   *
   * rec20
   */
  Coulomb = "COU",
  /**
   * content gram
   *
   * rec20
   */
  ContentGram = "CTG",
  /**
   * metric carat
   *
   * rec20
   */
  MetricCarat = "CTM",
  /**
   * content ton (metric)
   *
   * rec20
   */
  ContentTonMetric = "CTN",
  /**
   * curie
   *
   * rec20
   */
  Curie = "CUR",
  /**
   * hundred pound (cwt) / hundred weight (US)
   *
   * rec20
   */
  HundredPoundCwtHundredWeightUs = "CWA",
  /**
   * hundred weight (UK)
   *
   * rec20
   */
  HundredWeightUk = "CWI",
  /**
   * kilowatt hour per hour
   *
   * rec20
   */
  KilowattHourPerHour = "D03",
  /**
   * lot [unit of weight]
   *
   * rec20
   */
  LotUnitWeight = "D04",
  /**
   * reciprocal second per steradian
   *
   * rec20
   */
  ReciprocalSecondPerSteradian = "D1",
  /**
   * siemens per metre
   *
   * rec20
   */
  SiemensPerMetre = "D10",
  /**
   * mebibit
   *
   * rec20
   */
  Mebibit = "D11",
  /**
   * siemens square metre per mole
   *
   * rec20
   */
  SiemensSquareMetrePerMole = "D12",
  /**
   * sievert
   *
   * rec20
   */
  Sievert = "D13",
  /**
   * sone
   *
   * rec20
   */
  Sone = "D15",
  /**
   * square centimetre per erg
   *
   * rec20
   */
  SquareCentimetrePerErg = "D16",
  /**
   * square centimetre per steradian erg
   *
   * rec20
   */
  SquareCentimetrePerSteradianErg = "D17",
  /**
   * metre kelvin
   *
   * rec20
   */
  MetreKelvin = "D18",
  /**
   * square metre kelvin per watt
   *
   * rec20
   */
  SquareMetreKelvinPerWatt = "D19",
  /**
   * reciprocal second per steradian metre squared
   *
   * rec20
   */
  ReciprocalSecondPerSteradianMetreSquared = "D2",
  /**
   * square metre per joule
   *
   * rec20
   */
  SquareMetrePerJoule = "D20",
  /**
   * square metre per kilogram
   *
   * rec20
   */
  SquareMetrePerKilogram = "D21",
  /**
   * square metre per mole
   *
   * rec20
   */
  SquareMetrePerMole = "D22",
  /**
   * pen gram (protein)
   *
   * rec20
   */
  PenGramProtein = "D23",
  /**
   * square metre per steradian
   *
   * rec20
   */
  SquareMetrePerSteradian = "D24",
  /**
   * square metre per steradian joule
   *
   * rec20
   */
  SquareMetrePerSteradianJoule = "D25",
  /**
   * square metre per volt second
   *
   * rec20
   */
  SquareMetrePerVoltSecond = "D26",
  /**
   * steradian
   *
   * rec20
   */
  Steradian = "D27",
  /**
   * terahertz
   *
   * rec20
   */
  Terahertz = "D29",
  /**
   * terajoule
   *
   * rec20
   */
  Terajoule = "D30",
  /**
   * terawatt
   *
   * rec20
   */
  Terawatt = "D31",
  /**
   * terawatt hour
   *
   * rec20
   */
  TerawattHour = "D32",
  /**
   * tesla
   *
   * rec20
   */
  Tesla = "D33",
  /**
   * tex
   *
   * rec20
   */
  Tex = "D34",
  /**
   * megabit
   *
   * rec20
   */
  Megabit = "D36",
  /**
   * tonne per cubic metre
   *
   * rec20
   */
  TonnePerCubicMetre = "D41",
  /**
   * tropical year
   *
   * rec20
   */
  TropicalYear = "D42",
  /**
   * unified atomic mass unit
   *
   * rec20
   */
  UnifiedAtomicMassUnit = "D43",
  /**
   * var
   *
   * rec20
   */
  Var = "D44",
  /**
   * volt squared per kelvin squared
   *
   * rec20
   */
  VoltSquaredPerKelvinSquared = "D45",
  /**
   * volt - ampere
   *
   * rec20
   */
  VoltAmpere = "D46",
  /**
   * volt per centimetre
   *
   * rec20
   */
  VoltPerCentimetre = "D47",
  /**
   * volt per kelvin
   *
   * rec20
   */
  VoltPerKelvin = "D48",
  /**
   * millivolt per kelvin
   *
   * rec20
   */
  MillivoltPerKelvin = "D49",
  /**
   * kilogram per square centimetre
   *
   * rec20
   */
  KilogramPerSquareCentimetre = "D5",
  /**
   * volt per metre
   *
   * rec20
   */
  VoltPerMetre = "D50",
  /**
   * volt per millimetre
   *
   * rec20
   */
  VoltPerMillimetre = "D51",
  /**
   * watt per kelvin
   *
   * rec20
   */
  WattPerKelvin = "D52",
  /**
   * watt per metre kelvin
   *
   * rec20
   */
  WattPerMetreKelvin = "D53",
  /**
   * watt per square metre
   *
   * rec20
   */
  WattPerSquareMetre = "D54",
  /**
   * watt per square metre kelvin
   *
   * rec20
   */
  WattPerSquareMetreKelvin = "D55",
  /**
   * watt per square metre kelvin to the fourth power
   *
   * rec20
   */
  WattPerSquareMetreKelvinToFourthPower = "D56",
  /**
   * watt per steradian
   *
   * rec20
   */
  WattPerSteradian = "D57",
  /**
   * watt per steradian square metre
   *
   * rec20
   */
  WattPerSteradianSquareMetre = "D58",
  /**
   * weber per metre
   *
   * rec20
   */
  WeberPerMetre = "D59",
  /**
   * roentgen per second
   *
   * rec20
   */
  RoentgenPerSecond = "D6",
  /**
   * weber per millimetre
   *
   * rec20
   */
  WeberPerMillimetre = "D60",
  /**
   * minute [unit of angle]
   *
   * rec20
   */
  MinuteUnitAngle = "D61",
  /**
   * second [unit of angle]
   *
   * rec20
   */
  SecondUnitAngle = "D62",
  /**
   * book
   *
   * rec20
   */
  Book = "D63",
  /**
   * round
   *
   * rec20
   */
  Round = "D65",
  /**
   * number of words
   *
   * rec20
   */
  NumberWords = "D68",
  /**
   * inch to the fourth power
   *
   * rec20
   */
  InchToFourthPower = "D69",
  /**
   * joule square metre
   *
   * rec20
   */
  JouleSquareMetre = "D73",
  /**
   * kilogram per mole
   *
   * rec20
   */
  KilogramPerMole = "D74",
  /**
   * megacoulomb
   *
   * rec20
   */
  Megacoulomb = "D77",
  /**
   * megajoule per second
   *
   * rec20
   */
  MegajoulePerSecond = "D78",
  /**
   * microwatt
   *
   * rec20
   */
  Microwatt = "D80",
  /**
   * microtesla
   *
   * rec20
   */
  Microtesla = "D81",
  /**
   * microvolt
   *
   * rec20
   */
  Microvolt = "D82",
  /**
   * millinewton metre
   *
   * rec20
   */
  MillinewtonMetre = "D83",
  /**
   * microwatt per square metre
   *
   * rec20
   */
  MicrowattPerSquareMetre = "D85",
  /**
   * millicoulomb
   *
   * rec20
   */
  Millicoulomb = "D86",
  /**
   * millimole per kilogram
   *
   * rec20
   */
  MillimolePerKilogram = "D87",
  /**
   * millicoulomb per cubic metre
   *
   * rec20
   */
  MillicoulombPerCubicMetre = "D88",
  /**
   * millicoulomb per square metre
   *
   * rec20
   */
  MillicoulombPerSquareMetre = "D89",
  /**
   * rem
   *
   * rec20
   */
  Rem = "D91",
  /**
   * second per cubic metre
   *
   * rec20
   */
  SecondPerCubicMetre = "D93",
  /**
   * second per cubic metre radian
   *
   * rec20
   */
  SecondPerCubicMetreRadian = "D94",
  /**
   * joule per gram
   *
   * rec20
   */
  JoulePerGram = "D95",
  /**
   * decare
   *
   * rec20
   */
  Decare = "DAA",
  /**
   * ten day
   *
   * rec20
   */
  TenDay = "DAD",
  /**
   * day
   *
   * rec20
   */
  Day = "DAY",
  /**
   * dry pound
   *
   * rec20
   */
  DryPound = "DB",
  /**
   * Decibel-milliwatts
   *
   * Rec20
   */
  DecibelMilliwatts = "DBM",
  /**
   * Decibel watt
   *
   * Rec20
   */
  DecibelWatt = "DBW",
  /**
   * degree [unit of angle]
   *
   * rec20
   */
  DegreeUnitAngle = "DD",
  /**
   * decade
   *
   * rec20
   */
  Decade = "DEC",
  /**
   * decigram
   *
   * rec20
   */
  Decigram = "DG",
  /**
   * decagram
   *
   * rec20
   */
  Decagram = "DJ",
  /**
   * decilitre
   *
   * rec20
   */
  Decilitre = "DLT",
  /**
   * cubic decametre
   *
   * rec20
   */
  CubicDecametre = "DMA",
  /**
   * square decimetre
   *
   * rec20
   */
  SquareDecimetre = "DMK",
  /**
   * standard kilolitre
   *
   * rec20
   */
  StandardKilolitre = "DMO",
  /**
   * cubic decimetre
   *
   * rec20
   */
  CubicDecimetre = "DMQ",
  /**
   * decimetre
   *
   * rec20
   */
  Decimetre = "DMT",
  /**
   * decinewton metre
   *
   * rec20
   */
  DecinewtonMetre = "DN",
  /**
   * dozen piece
   *
   * rec20
   */
  DozenPiece = "DPC",
  /**
   * dozen pair
   *
   * rec20
   */
  DozenPair = "DPR",
  /**
   * displacement tonnage
   *
   * rec20
   */
  DisplacementTonnage = "DPT",
  /**
   * dram (US)
   *
   * rec20
   */
  DramUs = "DRA",
  /**
   * dram (UK)
   *
   * rec20
   */
  DramUk = "DRI",
  /**
   * dozen roll
   *
   * rec20
   */
  DozenRoll = "DRL",
  /**
   * dry ton
   *
   * rec20
   */
  DryTon = "DT",
  /**
   * decitonne
   *
   * rec20
   */
  Decitonne = "DTN",
  /**
   * pennyweight
   *
   * rec20
   */
  Pennyweight = "DWT",
  /**
   * dozen
   *
   * rec20
   */
  Dozen = "DZN",
  /**
   * dozen pack
   *
   * rec20
   */
  DozenPack = "DZP",
  /**
   * newton per square centimetre
   *
   * rec20
   */
  NewtonPerSquareCentimetre = "E01",
  /**
   * megawatt hour per hour
   *
   * rec20
   */
  MegawattHourPerHour = "E07",
  /**
   * megawatt per hertz
   *
   * rec20
   */
  MegawattPerHertz = "E08",
  /**
   * milliampere hour
   *
   * rec20
   */
  MilliampereHour = "E09",
  /**
   * degree day
   *
   * rec20
   */
  DegreeDay = "E10",
  /**
   * mille
   *
   * rec20
   */
  Mille = "E12",
  /**
   * kilocalorie (international table)
   *
   * rec20
   */
  KilocalorieInternationalTable = "E14",
  /**
   * kilocalorie (thermochemical) per hour
   *
   * rec20
   */
  KilocalorieThermochemicalPerHour = "E15",
  /**
   * million Btu(IT) per hour
   *
   * rec20
   */
  MillionBtuItPerHour = "E16",
  /**
   * cubic foot per second
   *
   * rec20
   */
  CubicFootPerSecond = "E17",
  /**
   * tonne per hour
   *
   * rec20
   */
  TonnePerHour = "E18",
  /**
   * ping
   *
   * rec20
   */
  Ping = "E19",
  /**
   * megabit per second
   *
   * rec20
   */
  MegabitPerSecond = "E20",
  /**
   * shares
   *
   * rec20
   */
  Shares = "E21",
  /**
   * TEU
   *
   * rec20
   */
  Teu = "E22",
  /**
   * tyre
   *
   * rec20
   */
  Tyre = "E23",
  /**
   * active unit
   *
   * rec20
   */
  ActiveUnit = "E25",
  /**
   * dose
   *
   * rec20
   */
  Dose = "E27",
  /**
   * air dry ton
   *
   * rec20
   */
  AirDryTon = "E28",
  /**
   * strand
   *
   * rec20
   */
  Strand = "E30",
  /**
   * square metre per litre
   *
   * rec20
   */
  SquareMetrePerLitre = "E31",
  /**
   * litre per hour
   *
   * rec20
   */
  LitrePerHour = "E32",
  /**
   * foot per thousand
   *
   * rec20
   */
  FootPerThousand = "E33",
  /**
   * gigabyte
   *
   * rec20
   */
  Gigabyte = "E34",
  /**
   * terabyte
   *
   * rec20
   */
  Terabyte = "E35",
  /**
   * petabyte
   *
   * rec20
   */
  Petabyte = "E36",
  /**
   * pixel
   *
   * rec20
   */
  Pixel = "E37",
  /**
   * megapixel
   *
   * rec20
   */
  Megapixel = "E38",
  /**
   * dots per inch
   *
   * rec20
   */
  DotsPerInch = "E39",
  /**
   * gross kilogram
   *
   * rec20
   */
  GrossKilogram = "E4",
  /**
   * part per hundred thousand
   *
   * rec20
   */
  PartPerHundredThousand = "E40",
  /**
   * kilogram-force per square millimetre
   *
   * rec20
   */
  KilogramForcePerSquareMillimetre = "E41",
  /**
   * kilogram-force per square centimetre
   *
   * rec20
   */
  KilogramForcePerSquareCentimetre = "E42",
  /**
   * joule per square centimetre
   *
   * rec20
   */
  JoulePerSquareCentimetre = "E43",
  /**
   * kilogram-force metre per square centimetre
   *
   * rec20
   */
  KilogramForceMetrePerSquareCentimetre = "E44",
  /**
   * milliohm
   *
   * rec20
   */
  Milliohm = "E45",
  /**
   * kilowatt hour per cubic metre
   *
   * rec20
   */
  KilowattHourPerCubicMetre = "E46",
  /**
   * kilowatt hour per kelvin
   *
   * rec20
   */
  KilowattHourPerKelvin = "E47",
  /**
   * service unit
   *
   * rec20
   */
  ServiceUnit = "E48",
  /**
   * working day
   *
   * rec20
   */
  WorkingDay = "E49",
  /**
   * accounting unit
   *
   * rec20
   */
  AccountingUnit = "E50",
  /**
   * job
   *
   * rec20
   */
  Job = "E51",
  /**
   * run foot
   *
   * rec20
   */
  RunFoot = "E52",
  /**
   * test
   *
   * rec20
   */
  Test = "E53",
  /**
   * trip
   *
   * rec20
   */
  Trip = "E54",
  /**
   * use
   *
   * rec20
   */
  Use = "E55",
  /**
   * well
   *
   * rec20
   */
  Well = "E56",
  /**
   * zone
   *
   * rec20
   */
  Zone = "E57",
  /**
   * exabit per second
   *
   * rec20
   */
  ExabitPerSecond = "E58",
  /**
   * exbibyte
   *
   * rec20
   */
  Exbibyte = "E59",
  /**
   * pebibyte
   *
   * rec20
   */
  Pebibyte = "E60",
  /**
   * tebibyte
   *
   * rec20
   */
  Tebibyte = "E61",
  /**
   * gibibyte
   *
   * rec20
   */
  Gibibyte = "E62",
  /**
   * mebibyte
   *
   * rec20
   */
  Mebibyte = "E63",
  /**
   * kibibyte
   *
   * rec20
   */
  Kibibyte = "E64",
  /**
   * exbibit per metre
   *
   * rec20
   */
  ExbibitPerMetre = "E65",
  /**
   * exbibit per square metre
   *
   * rec20
   */
  ExbibitPerSquareMetre = "E66",
  /**
   * exbibit per cubic metre
   *
   * rec20
   */
  ExbibitPerCubicMetre = "E67",
  /**
   * gigabyte per second
   *
   * rec20
   */
  GigabytePerSecond = "E68",
  /**
   * gibibit per metre
   *
   * rec20
   */
  GibibitPerMetre = "E69",
  /**
   * gibibit per square metre
   *
   * rec20
   */
  GibibitPerSquareMetre = "E70",
  /**
   * gibibit per cubic metre
   *
   * rec20
   */
  GibibitPerCubicMetre = "E71",
  /**
   * kibibit per metre
   *
   * rec20
   */
  KibibitPerMetre = "E72",
  /**
   * kibibit per square metre
   *
   * rec20
   */
  KibibitPerSquareMetre = "E73",
  /**
   * kibibit per cubic metre
   *
   * rec20
   */
  KibibitPerCubicMetre = "E74",
  /**
   * mebibit per metre
   *
   * rec20
   */
  MebibitPerMetre = "E75",
  /**
   * mebibit per square metre
   *
   * rec20
   */
  MebibitPerSquareMetre = "E76",
  /**
   * mebibit per cubic metre
   *
   * rec20
   */
  MebibitPerCubicMetre = "E77",
  /**
   * petabit
   *
   * rec20
   */
  Petabit = "E78",
  /**
   * petabit per second
   *
   * rec20
   */
  PetabitPerSecond = "E79",
  /**
   * pebibit per metre
   *
   * rec20
   */
  PebibitPerMetre = "E80",
  /**
   * pebibit per square metre
   *
   * rec20
   */
  PebibitPerSquareMetre = "E81",
  /**
   * pebibit per cubic metre
   *
   * rec20
   */
  PebibitPerCubicMetre = "E82",
  /**
   * terabit
   *
   * rec20
   */
  Terabit = "E83",
  /**
   * terabit per second
   *
   * rec20
   */
  TerabitPerSecond = "E84",
  /**
   * tebibit per metre
   *
   * rec20
   */
  TebibitPerMetre = "E85",
  /**
   * tebibit per cubic metre
   *
   * rec20
   */
  TebibitPerCubicMetre = "E86",
  /**
   * tebibit per square metre
   *
   * rec20
   */
  TebibitPerSquareMetre = "E87",
  /**
   * bit per metre
   *
   * rec20
   */
  BitPerMetre = "E88",
  /**
   * bit per square metre
   *
   * rec20
   */
  BitPerSquareMetre = "E89",
  /**
   * reciprocal centimetre
   *
   * rec20
   */
  ReciprocalCentimetre = "E90",
  /**
   * reciprocal day
   *
   * rec20
   */
  ReciprocalDay = "E91",
  /**
   * cubic decimetre per hour
   *
   * rec20
   */
  CubicDecimetrePerHour = "E92",
  /**
   * kilogram per hour
   *
   * rec20
   */
  KilogramPerHour = "E93",
  /**
   * kilomole per second
   *
   * rec20
   */
  KilomolePerSecond = "E94",
  /**
   * mole per second
   *
   * rec20
   */
  MolePerSecond = "E95",
  /**
   * degree per second
   *
   * rec20
   */
  DegreePerSecond = "E96",
  /**
   * millimetre per degree Celcius metre
   *
   * rec20
   */
  MillimetrePerDegreeCelciusMetre = "E97",
  /**
   * degree Celsius per kelvin
   *
   * rec20
   */
  DegreeCelsiusPerKelvin = "E98",
  /**
   * hectopascal per bar
   *
   * rec20
   */
  HectopascalPerBar = "E99",
  /**
   * each
   *
   * rec20
   */
  Each = "EA",
  /**
   * electronic mail box
   *
   * rec20
   */
  ElectronicMailBox = "EB",
  /**
   * equivalent gallon
   *
   * rec20
   */
  EquivalentGallon = "EQ",
  /**
   * bit per cubic metre
   *
   * rec20
   */
  BitPerCubicMetre = "F01",
  /**
   * kelvin per kelvin
   *
   * rec20
   */
  KelvinPerKelvin = "F02",
  /**
   * kilopascal per bar
   *
   * rec20
   */
  KilopascalPerBar = "F03",
  /**
   * millibar per bar
   *
   * rec20
   */
  MillibarPerBar = "F04",
  /**
   * megapascal per bar
   *
   * rec20
   */
  MegapascalPerBar = "F05",
  /**
   * poise per bar
   *
   * rec20
   */
  PoisePerBar = "F06",
  /**
   * pascal per bar
   *
   * rec20
   */
  PascalPerBar = "F07",
  /**
   * milliampere per inch
   *
   * rec20
   */
  MilliamperePerInch = "F08",
  /**
   * kelvin per hour
   *
   * rec20
   */
  KelvinPerHour = "F10",
  /**
   * kelvin per minute
   *
   * rec20
   */
  KelvinPerMinute = "F11",
  /**
   * kelvin per second
   *
   * rec20
   */
  KelvinPerSecond = "F12",
  /**
   * slug
   *
   * rec20
   */
  Slug = "F13",
  /**
   * gram per kelvin
   *
   * rec20
   */
  GramPerKelvin = "F14",
  /**
   * kilogram per kelvin
   *
   * rec20
   */
  KilogramPerKelvin = "F15",
  /**
   * milligram per kelvin
   *
   * rec20
   */
  MilligramPerKelvin = "F16",
  /**
   * pound-force per foot
   *
   * rec20
   */
  PoundForcePerFoot = "F17",
  /**
   * kilogram square centimetre
   *
   * rec20
   */
  KilogramSquareCentimetre = "F18",
  /**
   * kilogram square millimetre
   *
   * rec20
   */
  KilogramSquareMillimetre = "F19",
  /**
   * pound inch squared
   *
   * rec20
   */
  PoundInchSquared = "F20",
  /**
   * pound-force inch
   *
   * rec20
   */
  PoundForceInch = "F21",
  /**
   * pound-force foot per ampere
   *
   * rec20
   */
  PoundForceFootPerAmpere = "F22",
  /**
   * gram per cubic decimetre
   *
   * rec20
   */
  GramPerCubicDecimetre = "F23",
  /**
   * kilogram per kilomol
   *
   * rec20
   */
  KilogramPerKilomol = "F24",
  /**
   * gram per hertz
   *
   * rec20
   */
  GramPerHertz = "F25",
  /**
   * gram per day
   *
   * rec20
   */
  GramPerDay = "F26",
  /**
   * gram per hour
   *
   * rec20
   */
  GramPerHour = "F27",
  /**
   * gram per minute
   *
   * rec20
   */
  GramPerMinute = "F28",
  /**
   * gram per second
   *
   * rec20
   */
  GramPerSecond = "F29",
  /**
   * kilogram per day
   *
   * rec20
   */
  KilogramPerDay = "F30",
  /**
   * kilogram per minute
   *
   * rec20
   */
  KilogramPerMinute = "F31",
  /**
   * milligram per day
   *
   * rec20
   */
  MilligramPerDay = "F32",
  /**
   * milligram per minute
   *
   * rec20
   */
  MilligramPerMinute = "F33",
  /**
   * milligram per second
   *
   * rec20
   */
  MilligramPerSecond = "F34",
  /**
   * gram per day kelvin
   *
   * rec20
   */
  GramPerDayKelvin = "F35",
  /**
   * gram per hour kelvin
   *
   * rec20
   */
  GramPerHourKelvin = "F36",
  /**
   * gram per minute kelvin
   *
   * rec20
   */
  GramPerMinuteKelvin = "F37",
  /**
   * gram per second kelvin
   *
   * rec20
   */
  GramPerSecondKelvin = "F38",
  /**
   * kilogram per day kelvin
   *
   * rec20
   */
  KilogramPerDayKelvin = "F39",
  /**
   * kilogram per hour kelvin
   *
   * rec20
   */
  KilogramPerHourKelvin = "F40",
  /**
   * kilogram per minute kelvin
   *
   * rec20
   */
  KilogramPerMinuteKelvin = "F41",
  /**
   * kilogram per second kelvin
   *
   * rec20
   */
  KilogramPerSecondKelvin = "F42",
  /**
   * milligram per day kelvin
   *
   * rec20
   */
  MilligramPerDayKelvin = "F43",
  /**
   * milligram per hour kelvin
   *
   * rec20
   */
  MilligramPerHourKelvin = "F44",
  /**
   * milligram per minute kelvin
   *
   * rec20
   */
  MilligramPerMinuteKelvin = "F45",
  /**
   * milligram per second kelvin
   *
   * rec20
   */
  MilligramPerSecondKelvin = "F46",
  /**
   * newton per millimetre
   *
   * rec20
   */
  NewtonPerMillimetre = "F47",
  /**
   * pound-force per inch
   *
   * rec20
   */
  PoundForcePerInch = "F48",
  /**
   * rod [unit of distance]
   *
   * rec20
   */
  RodUnitDistance = "F49",
  /**
   * micrometre per kelvin
   *
   * rec20
   */
  MicrometrePerKelvin = "F50",
  /**
   * centimetre per kelvin
   *
   * rec20
   */
  CentimetrePerKelvin = "F51",
  /**
   * metre per kelvin
   *
   * rec20
   */
  MetrePerKelvin = "F52",
  /**
   * millimetre per kelvin
   *
   * rec20
   */
  MillimetrePerKelvin = "F53",
  /**
   * milliohm per metre
   *
   * rec20
   */
  MilliohmPerMetre = "F54",
  /**
   * ohm per mile (statute mile)
   *
   * rec20
   */
  OhmPerMileStatuteMile = "F55",
  /**
   * ohm per kilometre
   *
   * rec20
   */
  OhmPerKilometre = "F56",
  /**
   * milliampere per pound-force per square inch
   *
   * rec20
   */
  MilliamperePerPoundForcePerSquareInch = "F57",
  /**
   * reciprocal bar
   *
   * rec20
   */
  ReciprocalBar = "F58",
  /**
   * milliampere per bar
   *
   * rec20
   */
  MilliamperePerBar = "F59",
  /**
   * degree Celsius per bar
   *
   * rec20
   */
  DegreeCelsiusPerBar = "F60",
  /**
   * kelvin per bar
   *
   * rec20
   */
  KelvinPerBar = "F61",
  /**
   * gram per day bar
   *
   * rec20
   */
  GramPerDayBar = "F62",
  /**
   * gram per hour bar
   *
   * rec20
   */
  GramPerHourBar = "F63",
  /**
   * gram per minute bar
   *
   * rec20
   */
  GramPerMinuteBar = "F64",
  /**
   * gram per second bar
   *
   * rec20
   */
  GramPerSecondBar = "F65",
  /**
   * kilogram per day bar
   *
   * rec20
   */
  KilogramPerDayBar = "F66",
  /**
   * kilogram per hour bar
   *
   * rec20
   */
  KilogramPerHourBar = "F67",
  /**
   * kilogram per minute bar
   *
   * rec20
   */
  KilogramPerMinuteBar = "F68",
  /**
   * kilogram per second bar
   *
   * rec20
   */
  KilogramPerSecondBar = "F69",
  /**
   * milligram per day bar
   *
   * rec20
   */
  MilligramPerDayBar = "F70",
  /**
   * milligram per hour bar
   *
   * rec20
   */
  MilligramPerHourBar = "F71",
  /**
   * milligram per minute bar
   *
   * rec20
   */
  MilligramPerMinuteBar = "F72",
  /**
   * milligram per second bar
   *
   * rec20
   */
  MilligramPerSecondBar = "F73",
  /**
   * gram per bar
   *
   * rec20
   */
  GramPerBar = "F74",
  /**
   * milligram per bar
   *
   * rec20
   */
  MilligramPerBar = "F75",
  /**
   * milliampere per millimetre
   *
   * rec20
   */
  MilliamperePerMillimetre = "F76",
  /**
   * pascal second per kelvin
   *
   * rec20
   */
  PascalSecondPerKelvin = "F77",
  /**
   * inch of water
   *
   * rec20
   */
  InchWater = "F78",
  /**
   * inch of mercury
   *
   * rec20
   */
  InchMercury = "F79",
  /**
   * water horse power
   *
   * rec20
   */
  WaterHorsePower = "F80",
  /**
   * bar per kelvin
   *
   * rec20
   */
  BarPerKelvin = "F81",
  /**
   * hectopascal per kelvin
   *
   * rec20
   */
  HectopascalPerKelvin = "F82",
  /**
   * kilopascal per kelvin
   *
   * rec20
   */
  KilopascalPerKelvin = "F83",
  /**
   * millibar per kelvin
   *
   * rec20
   */
  MillibarPerKelvin = "F84",
  /**
   * megapascal per kelvin
   *
   * rec20
   */
  MegapascalPerKelvin = "F85",
  /**
   * poise per kelvin
   *
   * rec20
   */
  PoisePerKelvin = "F86",
  /**
   * volt per litre minute
   *
   * rec20
   */
  VoltPerLitreMinute = "F87",
  /**
   * newton centimetre
   *
   * rec20
   */
  NewtonCentimetre = "F88",
  /**
   * newton metre per degree
   *
   * rec20
   */
  NewtonMetrePerDegree = "F89",
  /**
   * newton metre per ampere
   *
   * rec20
   */
  NewtonMetrePerAmpere = "F90",
  /**
   * bar litre per second
   *
   * rec20
   */
  BarLitrePerSecond = "F91",
  /**
   * bar cubic metre per second
   *
   * rec20
   */
  BarCubicMetrePerSecond = "F92",
  /**
   * hectopascal litre per second
   *
   * rec20
   */
  HectopascalLitrePerSecond = "F93",
  /**
   * hectopascal cubic metre per second
   *
   * rec20
   */
  HectopascalCubicMetrePerSecond = "F94",
  /**
   * millibar litre per second
   *
   * rec20
   */
  MillibarLitrePerSecond = "F95",
  /**
   * millibar cubic metre per second
   *
   * rec20
   */
  MillibarCubicMetrePerSecond = "F96",
  /**
   * megapascal litre per second
   *
   * rec20
   */
  MegapascalLitrePerSecond = "F97",
  /**
   * megapascal cubic metre per second
   *
   * rec20
   */
  MegapascalCubicMetrePerSecond = "F98",
  /**
   * pascal litre per second
   *
   * rec20
   */
  PascalLitrePerSecond = "F99",
  /**
   * degree Fahrenheit
   *
   * rec20
   */
  DegreeFahrenheit = "FAH",
  /**
   * farad
   *
   * rec20
   */
  Farad = "FAR",
  /**
   * fibre metre
   *
   * rec20
   */
  FibreMetre = "FBM",
  /**
   * thousand cubic foot
   *
   * rec20
   */
  ThousandCubicFoot = "FC",
  /**
   * hundred cubic metre
   *
   * rec20
   */
  HundredCubicMetre = "FF",
  /**
   * micromole
   *
   * rec20
   */
  Micromole = "FH",
  /**
   * failures in time
   *
   * rec20
   */
  FailuresInTime = "FIT",
  /**
   * flake ton
   *
   * rec20
   */
  FlakeTon = "FL",
  /**
   * Formazin nephelometric unit
   *
   * Rec20
   */
  FormazinNephelometricUnit = "FNU",
  /**
   * foot
   *
   * rec20
   */
  Foot = "FOT",
  /**
   * pound per square foot
   *
   * rec20
   */
  PoundPerSquareFoot = "FP",
  /**
   * foot per minute
   *
   * rec20
   */
  FootPerMinute = "FR",
  /**
   * foot per second
   *
   * rec20
   */
  FootPerSecond = "FS",
  /**
   * square foot
   *
   * rec20
   */
  SquareFoot = "FTK",
  /**
   * cubic foot
   *
   * rec20
   */
  CubicFoot = "FTQ",
  /**
   * pascal cubic metre per second
   *
   * rec20
   */
  PascalCubicMetrePerSecond = "G01",
  /**
   * centimetre per bar
   *
   * rec20
   */
  CentimetrePerBar = "G04",
  /**
   * metre per bar
   *
   * rec20
   */
  MetrePerBar = "G05",
  /**
   * millimetre per bar
   *
   * rec20
   */
  MillimetrePerBar = "G06",
  /**
   * square inch per second
   *
   * rec20
   */
  SquareInchPerSecond = "G08",
  /**
   * square metre per second kelvin
   *
   * rec20
   */
  SquareMetrePerSecondKelvin = "G09",
  /**
   * stokes per kelvin
   *
   * rec20
   */
  StokesPerKelvin = "G10",
  /**
   * gram per cubic centimetre bar
   *
   * rec20
   */
  GramPerCubicCentimetreBar = "G11",
  /**
   * gram per cubic decimetre bar
   *
   * rec20
   */
  GramPerCubicDecimetreBar = "G12",
  /**
   * gram per litre bar
   *
   * rec20
   */
  GramPerLitreBar = "G13",
  /**
   * gram per cubic metre bar
   *
   * rec20
   */
  GramPerCubicMetreBar = "G14",
  /**
   * gram per millilitre bar
   *
   * rec20
   */
  GramPerMillilitreBar = "G15",
  /**
   * kilogram per cubic centimetre bar
   *
   * rec20
   */
  KilogramPerCubicCentimetreBar = "G16",
  /**
   * kilogram per litre bar
   *
   * rec20
   */
  KilogramPerLitreBar = "G17",
  /**
   * kilogram per cubic metre bar
   *
   * rec20
   */
  KilogramPerCubicMetreBar = "G18",
  /**
   * newton metre per kilogram
   *
   * rec20
   */
  NewtonMetrePerKilogram = "G19",
  /**
   * US gallon per minute
   *
   * rec20
   */
  UsGallonPerMinute = "G2",
  /**
   * pound-force foot per pound
   *
   * rec20
   */
  PoundForceFootPerPound = "G20",
  /**
   * cup [unit of volume]
   *
   * rec20
   */
  CupUnitVolume = "G21",
  /**
   * peck
   *
   * rec20
   */
  Peck = "G23",
  /**
   * tablespoon (US)
   *
   * rec20
   */
  TablespoonUs = "G24",
  /**
   * teaspoon (US)
   *
   * rec20
   */
  TeaspoonUs = "G25",
  /**
   * stere
   *
   * rec20
   */
  Stere = "G26",
  /**
   * cubic centimetre per kelvin
   *
   * rec20
   */
  CubicCentimetrePerKelvin = "G27",
  /**
   * litre per kelvin
   *
   * rec20
   */
  LitrePerKelvin = "G28",
  /**
   * cubic metre per kelvin
   *
   * rec20
   */
  CubicMetrePerKelvin = "G29",
  /**
   * Imperial gallon per minute
   *
   * rec20
   */
  ImperialGallonPerMinute = "G3",
  /**
   * millilitre per kelvin
   *
   * rec20
   */
  MillilitrePerKelvin = "G30",
  /**
   * kilogram per cubic centimetre
   *
   * rec20
   */
  KilogramPerCubicCentimetre = "G31",
  /**
   * ounce (avoirdupois) per cubic yard
   *
   * rec20
   */
  OunceAvoirdupoisPerCubicYard = "G32",
  /**
   * gram per cubic centimetre kelvin
   *
   * rec20
   */
  GramPerCubicCentimetreKelvin = "G33",
  /**
   * gram per cubic decimetre kelvin
   *
   * rec20
   */
  GramPerCubicDecimetreKelvin = "G34",
  /**
   * gram per litre kelvin
   *
   * rec20
   */
  GramPerLitreKelvin = "G35",
  /**
   * gram per cubic metre kelvin
   *
   * rec20
   */
  GramPerCubicMetreKelvin = "G36",
  /**
   * gram per millilitre kelvin
   *
   * rec20
   */
  GramPerMillilitreKelvin = "G37",
  /**
   * kilogram per cubic centimetre kelvin
   *
   * rec20
   */
  KilogramPerCubicCentimetreKelvin = "G38",
  /**
   * kilogram per litre kelvin
   *
   * rec20
   */
  KilogramPerLitreKelvin = "G39",
  /**
   * kilogram per cubic metre kelvin
   *
   * rec20
   */
  KilogramPerCubicMetreKelvin = "G40",
  /**
   * square metre per second bar
   *
   * rec20
   */
  SquareMetrePerSecondBar = "G41",
  /**
   * microsiemens per centimetre
   *
   * rec20
   */
  MicrosiemensPerCentimetre = "G42",
  /**
   * microsiemens per metre
   *
   * rec20
   */
  MicrosiemensPerMetre = "G43",
  /**
   * nanosiemens per centimetre
   *
   * rec20
   */
  NanosiemensPerCentimetre = "G44",
  /**
   * nanosiemens per metre
   *
   * rec20
   */
  NanosiemensPerMetre = "G45",
  /**
   * stokes per bar
   *
   * rec20
   */
  StokesPerBar = "G46",
  /**
   * cubic centimetre per day
   *
   * rec20
   */
  CubicCentimetrePerDay = "G47",
  /**
   * cubic centimetre per hour
   *
   * rec20
   */
  CubicCentimetrePerHour = "G48",
  /**
   * cubic centimetre per minute
   *
   * rec20
   */
  CubicCentimetrePerMinute = "G49",
  /**
   * gallon (US) per hour
   *
   * rec20
   */
  GallonUsPerHour = "G50",
  /**
   * litre per second
   *
   * rec20
   */
  LitrePerSecond = "G51",
  /**
   * cubic metre per day
   *
   * rec20
   */
  CubicMetrePerDay = "G52",
  /**
   * cubic metre per minute
   *
   * rec20
   */
  CubicMetrePerMinute = "G53",
  /**
   * millilitre per day
   *
   * rec20
   */
  MillilitrePerDay = "G54",
  /**
   * millilitre per hour
   *
   * rec20
   */
  MillilitrePerHour = "G55",
  /**
   * cubic inch per hour
   *
   * rec20
   */
  CubicInchPerHour = "G56",
  /**
   * cubic inch per minute
   *
   * rec20
   */
  CubicInchPerMinute = "G57",
  /**
   * cubic inch per second
   *
   * rec20
   */
  CubicInchPerSecond = "G58",
  /**
   * milliampere per litre minute
   *
   * rec20
   */
  MilliamperePerLitreMinute = "G59",
  /**
   * volt per bar
   *
   * rec20
   */
  VoltPerBar = "G60",
  /**
   * cubic centimetre per day kelvin
   *
   * rec20
   */
  CubicCentimetrePerDayKelvin = "G61",
  /**
   * cubic centimetre per hour kelvin
   *
   * rec20
   */
  CubicCentimetrePerHourKelvin = "G62",
  /**
   * cubic centimetre per minute kelvin
   *
   * rec20
   */
  CubicCentimetrePerMinuteKelvin = "G63",
  /**
   * cubic centimetre per second kelvin
   *
   * rec20
   */
  CubicCentimetrePerSecondKelvin = "G64",
  /**
   * litre per day kelvin
   *
   * rec20
   */
  LitrePerDayKelvin = "G65",
  /**
   * litre per hour kelvin
   *
   * rec20
   */
  LitrePerHourKelvin = "G66",
  /**
   * litre per minute kelvin
   *
   * rec20
   */
  LitrePerMinuteKelvin = "G67",
  /**
   * litre per second kelvin
   *
   * rec20
   */
  LitrePerSecondKelvin = "G68",
  /**
   * cubic metre per day kelvin
   *
   * rec20
   */
  CubicMetrePerDayKelvin = "G69",
  /**
   * cubic metre per hour kelvin
   *
   * rec20
   */
  CubicMetrePerHourKelvin = "G70",
  /**
   * cubic metre per minute kelvin
   *
   * rec20
   */
  CubicMetrePerMinuteKelvin = "G71",
  /**
   * cubic metre per second kelvin
   *
   * rec20
   */
  CubicMetrePerSecondKelvin = "G72",
  /**
   * millilitre per day kelvin
   *
   * rec20
   */
  MillilitrePerDayKelvin = "G73",
  /**
   * millilitre per hour kelvin
   *
   * rec20
   */
  MillilitrePerHourKelvin = "G74",
  /**
   * millilitre per minute kelvin
   *
   * rec20
   */
  MillilitrePerMinuteKelvin = "G75",
  /**
   * millilitre per second kelvin
   *
   * rec20
   */
  MillilitrePerSecondKelvin = "G76",
  /**
   * millimetre to the fourth power
   *
   * rec20
   */
  MillimetreToFourthPower = "G77",
  /**
   * cubic centimetre per day bar
   *
   * rec20
   */
  CubicCentimetrePerDayBar = "G78",
  /**
   * cubic centimetre per hour bar
   *
   * rec20
   */
  CubicCentimetrePerHourBar = "G79",
  /**
   * cubic centimetre per minute bar
   *
   * rec20
   */
  CubicCentimetrePerMinuteBar = "G80",
  /**
   * cubic centimetre per second bar
   *
   * rec20
   */
  CubicCentimetrePerSecondBar = "G81",
  /**
   * litre per day bar
   *
   * rec20
   */
  LitrePerDayBar = "G82",
  /**
   * litre per hour bar
   *
   * rec20
   */
  LitrePerHourBar = "G83",
  /**
   * litre per minute bar
   *
   * rec20
   */
  LitrePerMinuteBar = "G84",
  /**
   * litre per second bar
   *
   * rec20
   */
  LitrePerSecondBar = "G85",
  /**
   * cubic metre per day bar
   *
   * rec20
   */
  CubicMetrePerDayBar = "G86",
  /**
   * cubic metre per hour bar
   *
   * rec20
   */
  CubicMetrePerHourBar = "G87",
  /**
   * cubic metre per minute bar
   *
   * rec20
   */
  CubicMetrePerMinuteBar = "G88",
  /**
   * cubic metre per second bar
   *
   * rec20
   */
  CubicMetrePerSecondBar = "G89",
  /**
   * millilitre per day bar
   *
   * rec20
   */
  MillilitrePerDayBar = "G90",
  /**
   * millilitre per hour bar
   *
   * rec20
   */
  MillilitrePerHourBar = "G91",
  /**
   * millilitre per minute bar
   *
   * rec20
   */
  MillilitrePerMinuteBar = "G92",
  /**
   * millilitre per second bar
   *
   * rec20
   */
  MillilitrePerSecondBar = "G93",
  /**
   * cubic centimetre per bar
   *
   * rec20
   */
  CubicCentimetrePerBar = "G94",
  /**
   * litre per bar
   *
   * rec20
   */
  LitrePerBar = "G95",
  /**
   * cubic metre per bar
   *
   * rec20
   */
  CubicMetrePerBar = "G96",
  /**
   * millilitre per bar
   *
   * rec20
   */
  MillilitrePerBar = "G97",
  /**
   * microhenry per kiloohm
   *
   * rec20
   */
  MicrohenryPerKiloohm = "G98",
  /**
   * microhenry per ohm
   *
   * rec20
   */
  MicrohenryPerOhm = "G99",
  /**
   * gallon (US) per day
   *
   * rec20
   */
  GallonUsPerDay = "GB",
  /**
   * gigabecquerel
   *
   * rec20
   */
  Gigabecquerel = "GBQ",
  /**
   * gram, dry weight
   *
   * rec20
   */
  GramDryWeight = "GDW",
  /**
   * pound per gallon (US)
   *
   * rec20
   */
  PoundPerGallonUs = "GE",
  /**
   * gram per metre (gram per 100 centimetres)
   *
   * rec20
   */
  GramPerMetreGramPer100Centimetres = "GF",
  /**
   * gram of fissile isotope
   *
   * rec20
   */
  GramFissileIsotope = "GFI",
  /**
   * great gross
   *
   * rec20
   */
  GreatGross = "GGR",
  /**
   * gill (US)
   *
   * rec20
   */
  GillUs = "GIA",
  /**
   * gram, including container
   *
   * rec20
   */
  GramIncludingContainer = "GIC",
  /**
   * gill (UK)
   *
   * rec20
   */
  GillUk = "GII",
  /**
   * gram, including inner packaging
   *
   * rec20
   */
  GramIncludingInnerPackaging = "GIP",
  /**
   * gram per millilitre
   *
   * rec20
   */
  GramPerMillilitre = "GJ",
  /**
   * gram per litre
   *
   * rec20
   */
  GramPerLitre = "GL",
  /**
   * dry gallon (US)
   *
   * rec20
   */
  DryGallonUs = "GLD",
  /**
   * gallon (UK)
   *
   * rec20
   */
  GallonUk = "GLI",
  /**
   * gallon (US)
   *
   * rec20
   */
  GallonUs = "GLL",
  /**
   * gram per square metre
   *
   * rec20
   */
  GramPerSquareMetre = "GM",
  /**
   * milligram per square metre
   *
   * rec20
   */
  MilligramPerSquareMetre = "GO",
  /**
   * milligram per cubic metre
   *
   * rec20
   */
  MilligramPerCubicMetre = "GP",
  /**
   * microgram per cubic metre
   *
   * rec20
   */
  MicrogramPerCubicMetre = "GQ",
  /**
   * gram
   *
   * rec20
   */
  Gram = "GRM",
  /**
   * grain
   *
   * rec20
   */
  Grain = "GRN",
  /**
   * gross
   *
   * rec20
   */
  Gross = "GRO",
  /**
   * gigajoule
   *
   * rec20
   */
  Gigajoule = "GV",
  /**
   * gigawatt hour
   *
   * rec20
   */
  GigawattHour = "GWH",
  /**
   * henry per kiloohm
   *
   * rec20
   */
  HenryPerKiloohm = "H03",
  /**
   * henry per ohm
   *
   * rec20
   */
  HenryPerOhm = "H04",
  /**
   * millihenry per kiloohm
   *
   * rec20
   */
  MillihenryPerKiloohm = "H05",
  /**
   * millihenry per ohm
   *
   * rec20
   */
  MillihenryPerOhm = "H06",
  /**
   * pascal second per bar
   *
   * rec20
   */
  PascalSecondPerBar = "H07",
  /**
   * microbecquerel
   *
   * rec20
   */
  Microbecquerel = "H08",
  /**
   * reciprocal year
   *
   * rec20
   */
  ReciprocalYear = "H09",
  /**
   * reciprocal hour
   *
   * rec20
   */
  ReciprocalHour = "H10",
  /**
   * reciprocal month
   *
   * rec20
   */
  ReciprocalMonth = "H11",
  /**
   * degree Celsius per hour
   *
   * rec20
   */
  DegreeCelsiusPerHour = "H12",
  /**
   * degree Celsius per minute
   *
   * rec20
   */
  DegreeCelsiusPerMinute = "H13",
  /**
   * degree Celsius per second
   *
   * rec20
   */
  DegreeCelsiusPerSecond = "H14",
  /**
   * square centimetre per gram
   *
   * rec20
   */
  SquareCentimetrePerGram = "H15",
  /**
   * square decametre
   *
   * rec20
   */
  SquareDecametre = "H16",
  /**
   * square hectometre
   *
   * rec20
   */
  SquareHectometre = "H18",
  /**
   * cubic hectometre
   *
   * rec20
   */
  CubicHectometre = "H19",
  /**
   * cubic kilometre
   *
   * rec20
   */
  CubicKilometre = "H20",
  /**
   * blank
   *
   * rec20
   */
  Blank = "H21",
  /**
   * volt square inch per pound-force
   *
   * rec20
   */
  VoltSquareInchPerPoundForce = "H22",
  /**
   * volt per inch
   *
   * rec20
   */
  VoltPerInch = "H23",
  /**
   * volt per microsecond
   *
   * rec20
   */
  VoltPerMicrosecond = "H24",
  /**
   * percent per kelvin
   *
   * rec20
   */
  PercentPerKelvin = "H25",
  /**
   * ohm per metre
   *
   * rec20
   */
  OhmPerMetre = "H26",
  /**
   * degree per metre
   *
   * rec20
   */
  DegreePerMetre = "H27",
  /**
   * microfarad per kilometre
   *
   * rec20
   */
  MicrofaradPerKilometre = "H28",
  /**
   * microgram per litre
   *
   * rec20
   */
  MicrogramPerLitre = "H29",
  /**
   * square micrometre (square micron)
   *
   * rec20
   */
  SquareMicrometreSquareMicron = "H30",
  /**
   * ampere per kilogram
   *
   * rec20
   */
  AmperePerKilogram = "H31",
  /**
   * ampere squared second
   *
   * rec20
   */
  AmpereSquaredSecond = "H32",
  /**
   * farad per kilometre
   *
   * rec20
   */
  FaradPerKilometre = "H33",
  /**
   * hertz metre
   *
   * rec20
   */
  HertzMetre = "H34",
  /**
   * kelvin metre per watt
   *
   * rec20
   */
  KelvinMetrePerWatt = "H35",
  /**
   * megaohm per kilometre
   *
   * rec20
   */
  MegaohmPerKilometre = "H36",
  /**
   * megaohm per metre
   *
   * rec20
   */
  MegaohmPerMetre = "H37",
  /**
   * megaampere
   *
   * rec20
   */
  Megaampere = "H38",
  /**
   * megahertz kilometre
   *
   * rec20
   */
  MegahertzKilometre = "H39",
  /**
   * newton per ampere
   *
   * rec20
   */
  NewtonPerAmpere = "H40",
  /**
   * newton metre watt to the power minus 0,5
   *
   * rec20
   */
  NewtonMetreWattToPowerMinus05 = "H41",
  /**
   * pascal per metre
   *
   * rec20
   */
  PascalPerMetre = "H42",
  /**
   * siemens per centimetre
   *
   * rec20
   */
  SiemensPerCentimetre = "H43",
  /**
   * teraohm
   *
   * rec20
   */
  Teraohm = "H44",
  /**
   * volt second per metre
   *
   * rec20
   */
  VoltSecondPerMetre = "H45",
  /**
   * volt per second
   *
   * rec20
   */
  VoltPerSecond = "H46",
  /**
   * watt per cubic metre
   *
   * rec20
   */
  WattPerCubicMetre = "H47",
  /**
   * attofarad
   *
   * rec20
   */
  Attofarad = "H48",
  /**
   * centimetre per hour
   *
   * rec20
   */
  CentimetrePerHour = "H49",
  /**
   * reciprocal cubic centimetre
   *
   * rec20
   */
  ReciprocalCubicCentimetre = "H50",
  /**
   * decibel per kilometre
   *
   * rec20
   */
  DecibelPerKilometre = "H51",
  /**
   * decibel per metre
   *
   * rec20
   */
  DecibelPerMetre = "H52",
  /**
   * kilogram per bar
   *
   * rec20
   */
  KilogramPerBar = "H53",
  /**
   * kilogram per cubic decimetre kelvin
   *
   * rec20
   */
  KilogramPerCubicDecimetreKelvin = "H54",
  /**
   * kilogram per cubic decimetre bar
   *
   * rec20
   */
  KilogramPerCubicDecimetreBar = "H55",
  /**
   * kilogram per square metre second
   *
   * rec20
   */
  KilogramPerSquareMetreSecond = "H56",
  /**
   * inch per two pi radiant
   *
   * rec20
   */
  InchPerTwoPiRadiant = "H57",
  /**
   * metre per volt second
   *
   * rec20
   */
  MetrePerVoltSecond = "H58",
  /**
   * square metre per newton
   *
   * rec20
   */
  SquareMetrePerNewton = "H59",
  /**
   * cubic metre per cubic metre
   *
   * rec20
   */
  CubicMetrePerCubicMetre = "H60",
  /**
   * millisiemens per centimetre
   *
   * rec20
   */
  MillisiemensPerCentimetre = "H61",
  /**
   * millivolt per minute
   *
   * rec20
   */
  MillivoltPerMinute = "H62",
  /**
   * milligram per square centimetre
   *
   * rec20
   */
  MilligramPerSquareCentimetre = "H63",
  /**
   * milligram per gram
   *
   * rec20
   */
  MilligramPerGram = "H64",
  /**
   * millilitre per cubic metre
   *
   * rec20
   */
  MillilitrePerCubicMetre = "H65",
  /**
   * millimetre per year
   *
   * rec20
   */
  MillimetrePerYear = "H66",
  /**
   * millimetre per hour
   *
   * rec20
   */
  MillimetrePerHour = "H67",
  /**
   * millimole per gram
   *
   * rec20
   */
  MillimolePerGram = "H68",
  /**
   * picopascal per kilometre
   *
   * rec20
   */
  PicopascalPerKilometre = "H69",
  /**
   * picosecond
   *
   * rec20
   */
  Picosecond = "H70",
  /**
   * percent per month
   *
   * rec20
   */
  PercentPerMonth = "H71",
  /**
   * percent per hectobar
   *
   * rec20
   */
  PercentPerHectobar = "H72",
  /**
   * percent per decakelvin
   *
   * rec20
   */
  PercentPerDecakelvin = "H73",
  /**
   * watt per metre
   *
   * rec20
   */
  WattPerMetre = "H74",
  /**
   * decapascal
   *
   * rec20
   */
  Decapascal = "H75",
  /**
   * gram per millimetre
   *
   * rec20
   */
  GramPerMillimetre = "H76",
  /**
   * module width
   *
   * rec20
   */
  ModuleWidth = "H77",
  /**
   * French gauge
   *
   * rec20
   */
  FrenchGauge = "H79",
  /**
   * rack unit
   *
   * rec20
   */
  RackUnit = "H80",
  /**
   * millimetre per minute
   *
   * rec20
   */
  MillimetrePerMinute = "H81",
  /**
   * big point
   *
   * rec20
   */
  BigPoint = "H82",
  /**
   * litre per kilogram
   *
   * rec20
   */
  LitrePerKilogram = "H83",
  /**
   * gram millimetre
   *
   * rec20
   */
  GramMillimetre = "H84",
  /**
   * reciprocal week
   *
   * rec20
   */
  ReciprocalWeek = "H85",
  /**
   * piece
   *
   * rec20
   */
  Piece = "H87",
  /**
   * megaohm kilometre
   *
   * rec20
   */
  MegaohmKilometre = "H88",
  /**
   * percent per ohm
   *
   * rec20
   */
  PercentPerOhm = "H89",
  /**
   * percent per degree
   *
   * rec20
   */
  PercentPerDegree = "H90",
  /**
   * percent per ten thousand
   *
   * rec20
   */
  PercentPerTenThousand = "H91",
  /**
   * percent per one hundred thousand
   *
   * rec20
   */
  PercentPerOneHundredThousand = "H92",
  /**
   * percent per hundred
   *
   * rec20
   */
  PercentPerHundred = "H93",
  /**
   * percent per thousand
   *
   * rec20
   */
  PercentPerThousand = "H94",
  /**
   * percent per volt
   *
   * rec20
   */
  PercentPerVolt = "H95",
  /**
   * percent per bar
   *
   * rec20
   */
  PercentPerBar = "H96",
  /**
   * percent per inch
   *
   * rec20
   */
  PercentPerInch = "H98",
  /**
   * percent per metre
   *
   * rec20
   */
  PercentPerMetre = "H99",
  /**
   * hank
   *
   * rec20
   */
  Hank = "HA",
  /**
   * Piece Day
   *
   * Rec20
   */
  PieceDay = "HAD",
  /**
   * hectobar
   *
   * rec20
   */
  Hectobar = "HBA",
  /**
   * hundred boxes
   *
   * rec20
   */
  HundredBoxes = "HBX",
  /**
   * hundred count
   *
   * rec20
   */
  HundredCount = "HC",
  /**
   * hundred kilogram, dry weight
   *
   * rec20
   */
  HundredKilogramDryWeight = "HDW",
  /**
   * head
   *
   * rec20
   */
  Head = "HEA",
  /**
   * hectogram
   *
   * rec20
   */
  Hectogram = "HGM",
  /**
   * hundred cubic foot
   *
   * rec20
   */
  HundredCubicFoot = "HH",
  /**
   * hundred international unit
   *
   * rec20
   */
  HundredInternationalUnit = "HIU",
  /**
   * hundred kilogram, net mass
   *
   * rec20
   */
  HundredKilogramNetMass = "HKM",
  /**
   * hectolitre
   *
   * rec20
   */
  Hectolitre = "HLT",
  /**
   * mile per hour (statute mile)
   *
   * rec20
   */
  MilePerHourStatuteMile = "HM",
  /**
   * Piece Month
   *
   * Rec20
   */
  PieceMonth = "HMO",
  /**
   * million cubic metre
   *
   * rec20
   */
  MillionCubicMetre = "HMQ",
  /**
   * hectometre
   *
   * rec20
   */
  Hectometre = "HMT",
  /**
   * hectolitre of pure alcohol
   *
   * rec20
   */
  HectolitrePureAlcohol = "HPA",
  /**
   * hertz
   *
   * rec20
   */
  Hertz = "HTZ",
  /**
   * hour
   *
   * rec20
   */
  Hour = "HUR",
  /**
   * Piece Week
   *
   * Rec20
   */
  PieceWeek = "HWE",
  /**
   * inch pound (pound inch)
   *
   * rec20
   */
  InchPoundPoundInch = "IA",
  /**
   * person
   *
   * rec20
   */
  Person = "IE",
  /**
   * inch
   *
   * rec20
   */
  Inch = "INH",
  /**
   * square inch
   *
   * rec20
   */
  SquareInch = "INK",
  /**
   * cubic inch
   *
   * rec20
   */
  CubicInch = "INQ",
  /**
   * international sugar degree
   *
   * rec20
   */
  InternationalSugarDegree = "ISD",
  /**
   * inch per second
   *
   * rec20
   */
  InchPerSecond = "IU",
  /**
   * international unit per gram
   *
   * rec20
   */
  InternationalUnitPerGram = "IUG",
  /**
   * inch per second squared
   *
   * rec20
   */
  InchPerSecondSquared = "IV",
  /**
   * percent per millimetre
   *
   * rec20
   */
  PercentPerMillimetre = "J10",
  /**
   * per mille per psi
   *
   * rec20
   */
  PerMillePerPsi = "J12",
  /**
   * degree API
   *
   * rec20
   */
  DegreeApi = "J13",
  /**
   * degree Baume (origin scale)
   *
   * rec20
   */
  DegreeBaumeOriginScale = "J14",
  /**
   * degree Baume (US heavy)
   *
   * rec20
   */
  DegreeBaumeUsHeavy = "J15",
  /**
   * degree Baume (US light)
   *
   * rec20
   */
  DegreeBaumeUsLight = "J16",
  /**
   * degree Balling
   *
   * rec20
   */
  DegreeBalling = "J17",
  /**
   * degree Brix
   *
   * rec20
   */
  DegreeBrix = "J18",
  /**
   * degree Fahrenheit hour square foot per British thermal unit (thermochemical)
   *
   * rec20
   */
  DegreeFahrenheitHourSquareFootPerBritishThermalUnitThermochemical = "J19",
  /**
   * joule per kilogram
   *
   * rec20
   */
  JoulePerKilogram = "J2",
  /**
   * degree Fahrenheit per kelvin
   *
   * rec20
   */
  DegreeFahrenheitPerKelvin = "J20",
  /**
   * degree Fahrenheit per bar
   *
   * rec20
   */
  DegreeFahrenheitPerBar = "J21",
  /**
   * degree Fahrenheit hour square foot per British thermal unit (international table)
   *
   * rec20
   */
  DegreeFahrenheitHourSquareFootPerBritishThermalUnitInternationalTable = "J22",
  /**
   * degree Fahrenheit per hour
   *
   * rec20
   */
  DegreeFahrenheitPerHour = "J23",
  /**
   * degree Fahrenheit per minute
   *
   * rec20
   */
  DegreeFahrenheitPerMinute = "J24",
  /**
   * degree Fahrenheit per second
   *
   * rec20
   */
  DegreeFahrenheitPerSecond = "J25",
  /**
   * reciprocal degree Fahrenheit
   *
   * rec20
   */
  ReciprocalDegreeFahrenheit = "J26",
  /**
   * degree Oechsle
   *
   * rec20
   */
  DegreeOechsle = "J27",
  /**
   * degree Rankine per hour
   *
   * rec20
   */
  DegreeRankinePerHour = "J28",
  /**
   * degree Rankine per minute
   *
   * rec20
   */
  DegreeRankinePerMinute = "J29",
  /**
   * degree Rankine per second
   *
   * rec20
   */
  DegreeRankinePerSecond = "J30",
  /**
   * degree Twaddell
   *
   * rec20
   */
  DegreeTwaddell = "J31",
  /**
   * micropoise
   *
   * rec20
   */
  Micropoise = "J32",
  /**
   * microgram per kilogram
   *
   * rec20
   */
  MicrogramPerKilogram = "J33",
  /**
   * microgram per cubic metre kelvin
   *
   * rec20
   */
  MicrogramPerCubicMetreKelvin = "J34",
  /**
   * microgram per cubic metre bar
   *
   * rec20
   */
  MicrogramPerCubicMetreBar = "J35",
  /**
   * microlitre per litre
   *
   * rec20
   */
  MicrolitrePerLitre = "J36",
  /**
   * baud
   *
   * rec20
   */
  Baud = "J38",
  /**
   * British thermal unit (mean)
   *
   * rec20
   */
  BritishThermalUnitMean = "J39",
  /**
   * British thermal unit (international table) foot per hour square foot degree Fahrenheit
   *
   * rec20
   */
  BritishThermalUnitInternationalTableFootPerHourSquareFootDegreeFahrenheit = "J40",
  /**
   * British thermal unit (international table) inch per hour square foot degree Fahrenheit
   *
   * rec20
   */
  BritishThermalUnitInternationalTableInchPerHourSquareFootDegreeFahrenheit = "J41",
  /**
   * British thermal unit (international table) inch per second square foot degree Fahrenheit
   *
   * rec20
   */
  BritishThermalUnitInternationalTableInchPerSecondSquareFootDegreeFahrenheit = "J42",
  /**
   * British thermal unit (international table) per pound degree Fahrenheit
   *
   * rec20
   */
  BritishThermalUnitInternationalTablePerPoundDegreeFahrenheit = "J43",
  /**
   * British thermal unit (international table) per minute
   *
   * rec20
   */
  BritishThermalUnitInternationalTablePerMinute = "J44",
  /**
   * British thermal unit (international table) per second
   *
   * rec20
   */
  BritishThermalUnitInternationalTablePerSecond = "J45",
  /**
   * British thermal unit (thermochemical) foot per hour square foot degree Fahrenheit
   *
   * rec20
   */
  BritishThermalUnitThermochemicalFootPerHourSquareFootDegreeFahrenheit = "J46",
  /**
   * British thermal unit (thermochemical) per hour
   *
   * rec20
   */
  BritishThermalUnitThermochemicalPerHour = "J47",
  /**
   * British thermal unit (thermochemical) inch per hour square foot degree Fahrenheit
   *
   * rec20
   */
  BritishThermalUnitThermochemicalInchPerHourSquareFootDegreeFahrenheit = "J48",
  /**
   * British thermal unit (thermochemical) inch per second square foot degree Fahrenheit
   *
   * rec20
   */
  BritishThermalUnitThermochemicalInchPerSecondSquareFootDegreeFahrenheit = "J49",
  /**
   * British thermal unit (thermochemical) per pound degree Fahrenheit
   *
   * rec20
   */
  BritishThermalUnitThermochemicalPerPoundDegreeFahrenheit = "J50",
  /**
   * British thermal unit (thermochemical) per minute
   *
   * rec20
   */
  BritishThermalUnitThermochemicalPerMinute = "J51",
  /**
   * British thermal unit (thermochemical) per second
   *
   * rec20
   */
  BritishThermalUnitThermochemicalPerSecond = "J52",
  /**
   * coulomb square metre per kilogram
   *
   * rec20
   */
  CoulombSquareMetrePerKilogram = "J53",
  /**
   * megabaud
   *
   * rec20
   */
  Megabaud = "J54",
  /**
   * watt second
   *
   * rec20
   */
  WattSecond = "J55",
  /**
   * bar per bar
   *
   * rec20
   */
  BarPerBar = "J56",
  /**
   * barrel (UK petroleum)
   *
   * rec20
   */
  BarrelUkPetroleum = "J57",
  /**
   * barrel (UK petroleum) per minute
   *
   * rec20
   */
  BarrelUkPetroleumPerMinute = "J58",
  /**
   * barrel (UK petroleum) per day
   *
   * rec20
   */
  BarrelUkPetroleumPerDay = "J59",
  /**
   * barrel (UK petroleum) per hour
   *
   * rec20
   */
  BarrelUkPetroleumPerHour = "J60",
  /**
   * barrel (UK petroleum) per second
   *
   * rec20
   */
  BarrelUkPetroleumPerSecond = "J61",
  /**
   * barrel (US petroleum) per hour
   *
   * rec20
   */
  BarrelUsPetroleumPerHour = "J62",
  /**
   * barrel (US petroleum) per second
   *
   * rec20
   */
  BarrelUsPetroleumPerSecond = "J63",
  /**
   * bushel (UK) per day
   *
   * rec20
   */
  BushelUkPerDay = "J64",
  /**
   * bushel (UK) per hour
   *
   * rec20
   */
  BushelUkPerHour = "J65",
  /**
   * bushel (UK) per minute
   *
   * rec20
   */
  BushelUkPerMinute = "J66",
  /**
   * bushel (UK) per second
   *
   * rec20
   */
  BushelUkPerSecond = "J67",
  /**
   * bushel (US dry) per day
   *
   * rec20
   */
  BushelUsDryPerDay = "J68",
  /**
   * bushel (US dry) per hour
   *
   * rec20
   */
  BushelUsDryPerHour = "J69",
  /**
   * bushel (US dry) per minute
   *
   * rec20
   */
  BushelUsDryPerMinute = "J70",
  /**
   * bushel (US dry) per second
   *
   * rec20
   */
  BushelUsDryPerSecond = "J71",
  /**
   * centinewton metre
   *
   * rec20
   */
  CentinewtonMetre = "J72",
  /**
   * centipoise per kelvin
   *
   * rec20
   */
  CentipoisePerKelvin = "J73",
  /**
   * centipoise per bar
   *
   * rec20
   */
  CentipoisePerBar = "J74",
  /**
   * calorie (mean)
   *
   * rec20
   */
  CalorieMean = "J75",
  /**
   * calorie (international table) per gram degree Celsius
   *
   * rec20
   */
  CalorieInternationalTablePerGramDegreeCelsius = "J76",
  /**
   * calorie (thermochemical) per centimetre second degree Celsius
   *
   * rec20
   */
  CalorieThermochemicalPerCentimetreSecondDegreeCelsius = "J78",
  /**
   * calorie (thermochemical) per gram degree Celsius
   *
   * rec20
   */
  CalorieThermochemicalPerGramDegreeCelsius = "J79",
  /**
   * calorie (thermochemical) per minute
   *
   * rec20
   */
  CalorieThermochemicalPerMinute = "J81",
  /**
   * calorie (thermochemical) per second
   *
   * rec20
   */
  CalorieThermochemicalPerSecond = "J82",
  /**
   * clo
   *
   * rec20
   */
  Clo = "J83",
  /**
   * centimetre per second kelvin
   *
   * rec20
   */
  CentimetrePerSecondKelvin = "J84",
  /**
   * centimetre per second bar
   *
   * rec20
   */
  CentimetrePerSecondBar = "J85",
  /**
   * cubic centimetre per cubic metre
   *
   * rec20
   */
  CubicCentimetrePerCubicMetre = "J87",
  /**
   * cubic decimetre per day
   *
   * rec20
   */
  CubicDecimetrePerDay = "J90",
  /**
   * cubic decimetre per cubic metre
   *
   * rec20
   */
  CubicDecimetrePerCubicMetre = "J91",
  /**
   * cubic decimetre per minute
   *
   * rec20
   */
  CubicDecimetrePerMinute = "J92",
  /**
   * cubic decimetre per second
   *
   * rec20
   */
  CubicDecimetrePerSecond = "J93",
  /**
   * ounce (UK fluid) per day
   *
   * rec20
   */
  OunceUkFluidPerDay = "J95",
  /**
   * ounce (UK fluid) per hour
   *
   * rec20
   */
  OunceUkFluidPerHour = "J96",
  /**
   * ounce (UK fluid) per minute
   *
   * rec20
   */
  OunceUkFluidPerMinute = "J97",
  /**
   * ounce (UK fluid) per second
   *
   * rec20
   */
  OunceUkFluidPerSecond = "J98",
  /**
   * ounce (US fluid) per day
   *
   * rec20
   */
  OunceUsFluidPerDay = "J99",
  /**
   * joule per kelvin
   *
   * rec20
   */
  JoulePerKelvin = "JE",
  /**
   * megajoule per kilogram
   *
   * rec20
   */
  MegajoulePerKilogram = "JK",
  /**
   * megajoule per cubic metre
   *
   * rec20
   */
  MegajoulePerCubicMetre = "JM",
  /**
   * pipeline joint
   *
   * rec20
   */
  PipelineJoint = "JNT",
  /**
   * joule
   *
   * rec20
   */
  Joule = "JOU",
  /**
   * hundred metre
   *
   * rec20
   */
  HundredMetre = "JPS",
  /**
   * number of jewels
   *
   * rec20
   */
  NumberJewels = "JWL",
  /**
   * kilowatt demand
   *
   * rec20
   */
  KilowattDemand = "K1",
  /**
   * ounce (US fluid) per hour
   *
   * rec20
   */
  OunceUsFluidPerHour = "K10",
  /**
   * ounce (US fluid) per minute
   *
   * rec20
   */
  OunceUsFluidPerMinute = "K11",
  /**
   * ounce (US fluid) per second
   *
   * rec20
   */
  OunceUsFluidPerSecond = "K12",
  /**
   * foot per degree Fahrenheit
   *
   * rec20
   */
  FootPerDegreeFahrenheit = "K13",
  /**
   * foot per hour
   *
   * rec20
   */
  FootPerHour = "K14",
  /**
   * foot pound-force per hour
   *
   * rec20
   */
  FootPoundForcePerHour = "K15",
  /**
   * foot pound-force per minute
   *
   * rec20
   */
  FootPoundForcePerMinute = "K16",
  /**
   * foot per psi
   *
   * rec20
   */
  FootPerPsi = "K17",
  /**
   * foot per second degree Fahrenheit
   *
   * rec20
   */
  FootPerSecondDegreeFahrenheit = "K18",
  /**
   * foot per second psi
   *
   * rec20
   */
  FootPerSecondPsi = "K19",
  /**
   * kilovolt ampere reactive demand
   *
   * rec20
   */
  KilovoltAmpereReactiveDemand = "K2",
  /**
   * reciprocal cubic foot
   *
   * rec20
   */
  ReciprocalCubicFoot = "K20",
  /**
   * cubic foot per degree Fahrenheit
   *
   * rec20
   */
  CubicFootPerDegreeFahrenheit = "K21",
  /**
   * cubic foot per day
   *
   * rec20
   */
  CubicFootPerDay = "K22",
  /**
   * cubic foot per psi
   *
   * rec20
   */
  CubicFootPerPsi = "K23",
  /**
   * gallon (UK) per day
   *
   * rec20
   */
  GallonUkPerDay = "K26",
  /**
   * gallon (UK) per hour
   *
   * rec20
   */
  GallonUkPerHour = "K27",
  /**
   * gallon (UK) per second
   *
   * rec20
   */
  GallonUkPerSecond = "K28",
  /**
   * kilovolt ampere reactive hour
   *
   * rec20
   */
  KilovoltAmpereReactiveHour = "K3",
  /**
   * gallon (US liquid) per second
   *
   * rec20
   */
  GallonUsLiquidPerSecond = "K30",
  /**
   * gram-force per square centimetre
   *
   * rec20
   */
  GramForcePerSquareCentimetre = "K31",
  /**
   * gill (UK) per day
   *
   * rec20
   */
  GillUkPerDay = "K32",
  /**
   * gill (UK) per hour
   *
   * rec20
   */
  GillUkPerHour = "K33",
  /**
   * gill (UK) per minute
   *
   * rec20
   */
  GillUkPerMinute = "K34",
  /**
   * gill (UK) per second
   *
   * rec20
   */
  GillUkPerSecond = "K35",
  /**
   * gill (US) per day
   *
   * rec20
   */
  GillUsPerDay = "K36",
  /**
   * gill (US) per hour
   *
   * rec20
   */
  GillUsPerHour = "K37",
  /**
   * gill (US) per minute
   *
   * rec20
   */
  GillUsPerMinute = "K38",
  /**
   * gill (US) per second
   *
   * rec20
   */
  GillUsPerSecond = "K39",
  /**
   * standard acceleration of free fall
   *
   * rec20
   */
  StandardAccelerationFreeFall = "K40",
  /**
   * grain per gallon (US)
   *
   * rec20
   */
  GrainPerGallonUs = "K41",
  /**
   * horsepower (boiler)
   *
   * rec20
   */
  HorsepowerBoiler = "K42",
  /**
   * horsepower (electric)
   *
   * rec20
   */
  HorsepowerElectric = "K43",
  /**
   * inch per degree Fahrenheit
   *
   * rec20
   */
  InchPerDegreeFahrenheit = "K45",
  /**
   * inch per psi
   *
   * rec20
   */
  InchPerPsi = "K46",
  /**
   * inch per second degree Fahrenheit
   *
   * rec20
   */
  InchPerSecondDegreeFahrenheit = "K47",
  /**
   * inch per second psi
   *
   * rec20
   */
  InchPerSecondPsi = "K48",
  /**
   * reciprocal cubic inch
   *
   * rec20
   */
  ReciprocalCubicInch = "K49",
  /**
   * kilobaud
   *
   * rec20
   */
  Kilobaud = "K50",
  /**
   * kilocalorie (mean)
   *
   * rec20
   */
  KilocalorieMean = "K51",
  /**
   * kilocalorie (international table) per hour metre degree Celsius
   *
   * rec20
   */
  KilocalorieInternationalTablePerHourMetreDegreeCelsius = "K52",
  /**
   * kilocalorie (thermochemical)
   *
   * rec20
   */
  KilocalorieThermochemical = "K53",
  /**
   * kilocalorie (thermochemical) per minute
   *
   * rec20
   */
  KilocalorieThermochemicalPerMinute = "K54",
  /**
   * kilocalorie (thermochemical) per second
   *
   * rec20
   */
  KilocalorieThermochemicalPerSecond = "K55",
  /**
   * kilomole per hour
   *
   * rec20
   */
  KilomolePerHour = "K58",
  /**
   * kilomole per cubic metre kelvin
   *
   * rec20
   */
  KilomolePerCubicMetreKelvin = "K59",
  /**
   * kilolitre
   *
   * rec20
   */
  Kilolitre = "K6",
  /**
   * kilomole per cubic metre bar
   *
   * rec20
   */
  KilomolePerCubicMetreBar = "K60",
  /**
   * kilomole per minute
   *
   * rec20
   */
  KilomolePerMinute = "K61",
  /**
   * litre per litre
   *
   * rec20
   */
  LitrePerLitre = "K62",
  /**
   * reciprocal litre
   *
   * rec20
   */
  ReciprocalLitre = "K63",
  /**
   * pound (avoirdupois) per degree Fahrenheit
   *
   * rec20
   */
  PoundAvoirdupoisPerDegreeFahrenheit = "K64",
  /**
   * pound (avoirdupois) square foot
   *
   * rec20
   */
  PoundAvoirdupoisSquareFoot = "K65",
  /**
   * pound (avoirdupois) per day
   *
   * rec20
   */
  PoundAvoirdupoisPerDay = "K66",
  /**
   * pound per foot hour
   *
   * rec20
   */
  PoundPerFootHour = "K67",
  /**
   * pound per foot second
   *
   * rec20
   */
  PoundPerFootSecond = "K68",
  /**
   * pound (avoirdupois) per cubic foot degree Fahrenheit
   *
   * rec20
   */
  PoundAvoirdupoisPerCubicFootDegreeFahrenheit = "K69",
  /**
   * pound (avoirdupois) per cubic foot psi
   *
   * rec20
   */
  PoundAvoirdupoisPerCubicFootPsi = "K70",
  /**
   * pound (avoirdupois) per gallon (UK)
   *
   * rec20
   */
  PoundAvoirdupoisPerGallonUk = "K71",
  /**
   * pound (avoirdupois) per hour degree Fahrenheit
   *
   * rec20
   */
  PoundAvoirdupoisPerHourDegreeFahrenheit = "K73",
  /**
   * pound (avoirdupois) per hour psi
   *
   * rec20
   */
  PoundAvoirdupoisPerHourPsi = "K74",
  /**
   * pound (avoirdupois) per cubic inch degree Fahrenheit
   *
   * rec20
   */
  PoundAvoirdupoisPerCubicInchDegreeFahrenheit = "K75",
  /**
   * pound (avoirdupois) per cubic inch psi
   *
   * rec20
   */
  PoundAvoirdupoisPerCubicInchPsi = "K76",
  /**
   * pound (avoirdupois) per psi
   *
   * rec20
   */
  PoundAvoirdupoisPerPsi = "K77",
  /**
   * pound (avoirdupois) per minute
   *
   * rec20
   */
  PoundAvoirdupoisPerMinute = "K78",
  /**
   * pound (avoirdupois) per minute degree Fahrenheit
   *
   * rec20
   */
  PoundAvoirdupoisPerMinuteDegreeFahrenheit = "K79",
  /**
   * pound (avoirdupois) per minute psi
   *
   * rec20
   */
  PoundAvoirdupoisPerMinutePsi = "K80",
  /**
   * pound (avoirdupois) per second
   *
   * rec20
   */
  PoundAvoirdupoisPerSecond = "K81",
  /**
   * pound (avoirdupois) per second degree Fahrenheit
   *
   * rec20
   */
  PoundAvoirdupoisPerSecondDegreeFahrenheit = "K82",
  /**
   * pound (avoirdupois) per second psi
   *
   * rec20
   */
  PoundAvoirdupoisPerSecondPsi = "K83",
  /**
   * pound per cubic yard
   *
   * rec20
   */
  PoundPerCubicYard = "K84",
  /**
   * pound-force per square foot
   *
   * rec20
   */
  PoundForcePerSquareFoot = "K85",
  /**
   * pound-force per square inch degree Fahrenheit
   *
   * rec20
   */
  PoundForcePerSquareInchDegreeFahrenheit = "K86",
  /**
   * psi cubic inch per second
   *
   * rec20
   */
  PsiCubicInchPerSecond = "K87",
  /**
   * psi litre per second
   *
   * rec20
   */
  PsiLitrePerSecond = "K88",
  /**
   * psi cubic metre per second
   *
   * rec20
   */
  PsiCubicMetrePerSecond = "K89",
  /**
   * psi cubic yard per second
   *
   * rec20
   */
  PsiCubicYardPerSecond = "K90",
  /**
   * pound-force second per square foot
   *
   * rec20
   */
  PoundForceSecondPerSquareFoot = "K91",
  /**
   * pound-force second per square inch
   *
   * rec20
   */
  PoundForceSecondPerSquareInch = "K92",
  /**
   * reciprocal psi
   *
   * rec20
   */
  ReciprocalPsi = "K93",
  /**
   * quart (UK liquid) per day
   *
   * rec20
   */
  QuartUkLiquidPerDay = "K94",
  /**
   * quart (UK liquid) per hour
   *
   * rec20
   */
  QuartUkLiquidPerHour = "K95",
  /**
   * quart (UK liquid) per minute
   *
   * rec20
   */
  QuartUkLiquidPerMinute = "K96",
  /**
   * quart (UK liquid) per second
   *
   * rec20
   */
  QuartUkLiquidPerSecond = "K97",
  /**
   * quart (US liquid) per day
   *
   * rec20
   */
  QuartUsLiquidPerDay = "K98",
  /**
   * quart (US liquid) per hour
   *
   * rec20
   */
  QuartUsLiquidPerHour = "K99",
  /**
   * cake
   *
   * rec20
   */
  Cake = "KA",
  /**
   * katal
   *
   * rec20
   */
  Katal = "KAT",
  /**
   * kilocharacter
   *
   * rec20
   */
  Kilocharacter = "KB",
  /**
   * kilobar
   *
   * rec20
   */
  Kilobar = "KBA",
  /**
   * kilogram of choline chloride
   *
   * rec20
   */
  KilogramCholineChloride = "KCC",
  /**
   * kilogram drained net weight
   *
   * rec20
   */
  KilogramDrainedNetWeight = "KDW",
  /**
   * kelvin
   *
   * rec20
   */
  Kelvin = "KEL",
  /**
   * kilogram
   *
   * rec20
   */
  Kilogram = "KGM",
  /**
   * kilogram per second
   *
   * rec20
   */
  KilogramPerSecond = "KGS",
  /**
   * kilogram of hydrogen peroxide
   *
   * rec20
   */
  KilogramHydrogenPeroxide = "KHY",
  /**
   * kilohertz
   *
   * rec20
   */
  Kilohertz = "KHZ",
  /**
   * kilogram per millimetre width
   *
   * rec20
   */
  KilogramPerMillimetreWidth = "KI",
  /**
   * kilogram, including container
   *
   * rec20
   */
  KilogramIncludingContainer = "KIC",
  /**
   * kilogram, including inner packaging
   *
   * rec20
   */
  KilogramIncludingInnerPackaging = "KIP",
  /**
   * kilosegment
   *
   * rec20
   */
  Kilosegment = "KJ",
  /**
   * kilojoule
   *
   * rec20
   */
  Kilojoule = "KJO",
  /**
   * kilogram per metre
   *
   * rec20
   */
  KilogramPerMetre = "KL",
  /**
   * lactic dry material percentage
   *
   * rec20
   */
  LacticDryMaterialPercentage = "KLK",
  /**
   * kilolux
   *
   * rec20
   */
  Kilolux = "KLX",
  /**
   * kilogram of methylamine
   *
   * rec20
   */
  KilogramMethylamine = "KMA",
  /**
   * kilometre per hour
   *
   * rec20
   */
  KilometrePerHour = "KMH",
  /**
   * square kilometre
   *
   * rec20
   */
  SquareKilometre = "KMK",
  /**
   * kilogram per cubic metre
   *
   * rec20
   */
  KilogramPerCubicMetre = "KMQ",
  /**
   * kilometre
   *
   * rec20
   */
  Kilometre = "KMT",
  /**
   * kilogram of nitrogen
   *
   * rec20
   */
  KilogramNitrogen = "KNI",
  /**
   * kilonewton per square metre
   *
   * rec20
   */
  KilonewtonPerSquareMetre = "KNM",
  /**
   * kilogram named substance
   *
   * rec20
   */
  KilogramNamedSubstance = "KNS",
  /**
   * knot
   *
   * rec20
   */
  Knot = "KNT",
  /**
   * milliequivalence caustic potash per gram of product
   *
   * rec20
   */
  MilliequivalenceCausticPotashPerGramProduct = "KO",
  /**
   * kilopascal
   *
   * rec20
   */
  Kilopascal = "KPA",
  /**
   * kilogram of potassium hydroxide (caustic potash)
   *
   * rec20
   */
  KilogramPotassiumHydroxideCausticPotash = "KPH",
  /**
   * kilogram of potassium oxide
   *
   * rec20
   */
  KilogramPotassiumOxide = "KPO",
  /**
   * kilogram of phosphorus pentoxide (phosphoric anhydride)
   *
   * rec20
   */
  KilogramPhosphorusPentoxidePhosphoricAnhydride = "KPP",
  /**
   * kiloroentgen
   *
   * rec20
   */
  Kiloroentgen = "KR",
  /**
   * kilogram of substance 90 % dry
   *
   * rec20
   */
  KilogramSubstance90Dry = "KSD",
  /**
   * kilogram of sodium hydroxide (caustic soda)
   *
   * rec20
   */
  KilogramSodiumHydroxideCausticSoda = "KSH",
  /**
   * kit
   *
   * rec20
   */
  Kit = "KT",
  /**
   * kilotonne
   *
   * rec20
   */
  Kilotonne = "KTN",
  /**
   * kilogram of uranium
   *
   * rec20
   */
  KilogramUranium = "KUR",
  /**
   * kilovolt - ampere
   *
   * rec20
   */
  KilovoltAmpere = "KVA",
  /**
   * kilovar
   *
   * rec20
   */
  Kilovar = "KVR",
  /**
   * kilovolt
   *
   * rec20
   */
  Kilovolt = "KVT",
  /**
   * kilogram per millimetre
   *
   * rec20
   */
  KilogramPerMillimetre = "KW",
  /**
   * kilowatt hour
   *
   * rec20
   */
  KilowattHour = "KWH",
  /**
   * Kilowatt hour per normalized cubic metre
   *
   * rec20
   */
  KilowattHourPerNormalizedCubicMetre = "KWN",
  /**
   * kilogram of tungsten trioxide
   *
   * rec20
   */
  KilogramTungstenTrioxide = "KWO",
  /**
   * Kilowatt hour per standard cubic metre
   *
   * rec20
   */
  KilowattHourPerStandardCubicMetre = "KWS",
  /**
   * kilowatt
   *
   * rec20
   */
  Kilowatt = "KWT",
  /**
   * kilowatt year
   *
   * Rec20
   */
  KilowattYear = "KWY",
  /**
   * millilitre per kilogram
   *
   * rec20
   */
  MillilitrePerKilogram = "KX",
  /**
   * quart (US liquid) per minute
   *
   * rec20
   */
  QuartUsLiquidPerMinute = "L10",
  /**
   * quart (US liquid) per second
   *
   * rec20
   */
  QuartUsLiquidPerSecond = "L11",
  /**
   * metre per second kelvin
   *
   * rec20
   */
  MetrePerSecondKelvin = "L12",
  /**
   * metre per second bar
   *
   * rec20
   */
  MetrePerSecondBar = "L13",
  /**
   * square metre hour degree Celsius per kilocalorie (international table)
   *
   * rec20
   */
  SquareMetreHourDegreeCelsiusPerKilocalorieInternationalTable = "L14",
  /**
   * millipascal second per kelvin
   *
   * rec20
   */
  MillipascalSecondPerKelvin = "L15",
  /**
   * millipascal second per bar
   *
   * rec20
   */
  MillipascalSecondPerBar = "L16",
  /**
   * milligram per cubic metre kelvin
   *
   * rec20
   */
  MilligramPerCubicMetreKelvin = "L17",
  /**
   * milligram per cubic metre bar
   *
   * rec20
   */
  MilligramPerCubicMetreBar = "L18",
  /**
   * millilitre per litre
   *
   * rec20
   */
  MillilitrePerLitre = "L19",
  /**
   * litre per minute
   *
   * rec20
   */
  LitrePerMinute = "L2",
  /**
   * reciprocal cubic millimetre
   *
   * rec20
   */
  ReciprocalCubicMillimetre = "L20",
  /**
   * cubic millimetre per cubic metre
   *
   * rec20
   */
  CubicMillimetrePerCubicMetre = "L21",
  /**
   * mole per hour
   *
   * rec20
   */
  MolePerHour = "L23",
  /**
   * mole per kilogram kelvin
   *
   * rec20
   */
  MolePerKilogramKelvin = "L24",
  /**
   * mole per kilogram bar
   *
   * rec20
   */
  MolePerKilogramBar = "L25",
  /**
   * mole per litre kelvin
   *
   * rec20
   */
  MolePerLitreKelvin = "L26",
  /**
   * mole per litre bar
   *
   * rec20
   */
  MolePerLitreBar = "L27",
  /**
   * mole per cubic metre kelvin
   *
   * rec20
   */
  MolePerCubicMetreKelvin = "L28",
  /**
   * mole per cubic metre bar
   *
   * rec20
   */
  MolePerCubicMetreBar = "L29",
  /**
   * mole per minute
   *
   * rec20
   */
  MolePerMinute = "L30",
  /**
   * milliroentgen aequivalent men
   *
   * rec20
   */
  MilliroentgenAequivalentMen = "L31",
  /**
   * nanogram per kilogram
   *
   * rec20
   */
  NanogramPerKilogram = "L32",
  /**
   * ounce (avoirdupois) per day
   *
   * rec20
   */
  OunceAvoirdupoisPerDay = "L33",
  /**
   * ounce (avoirdupois) per hour
   *
   * rec20
   */
  OunceAvoirdupoisPerHour = "L34",
  /**
   * ounce (avoirdupois) per minute
   *
   * rec20
   */
  OunceAvoirdupoisPerMinute = "L35",
  /**
   * ounce (avoirdupois) per second
   *
   * rec20
   */
  OunceAvoirdupoisPerSecond = "L36",
  /**
   * ounce (avoirdupois) per gallon (UK)
   *
   * rec20
   */
  OunceAvoirdupoisPerGallonUk = "L37",
  /**
   * ounce (avoirdupois) per gallon (US)
   *
   * rec20
   */
  OunceAvoirdupoisPerGallonUs = "L38",
  /**
   * ounce (avoirdupois) per cubic inch
   *
   * rec20
   */
  OunceAvoirdupoisPerCubicInch = "L39",
  /**
   * ounce (avoirdupois)-force
   *
   * rec20
   */
  OunceAvoirdupoisForce = "L40",
  /**
   * ounce (avoirdupois)-force inch
   *
   * rec20
   */
  OunceAvoirdupoisForceInch = "L41",
  /**
   * picosiemens per metre
   *
   * rec20
   */
  PicosiemensPerMetre = "L42",
  /**
   * peck (UK)
   *
   * rec20
   */
  PeckUk = "L43",
  /**
   * peck (UK) per day
   *
   * rec20
   */
  PeckUkPerDay = "L44",
  /**
   * peck (UK) per hour
   *
   * rec20
   */
  PeckUkPerHour = "L45",
  /**
   * peck (UK) per minute
   *
   * rec20
   */
  PeckUkPerMinute = "L46",
  /**
   * peck (UK) per second
   *
   * rec20
   */
  PeckUkPerSecond = "L47",
  /**
   * peck (US dry) per day
   *
   * rec20
   */
  PeckUsDryPerDay = "L48",
  /**
   * peck (US dry) per hour
   *
   * rec20
   */
  PeckUsDryPerHour = "L49",
  /**
   * peck (US dry) per minute
   *
   * rec20
   */
  PeckUsDryPerMinute = "L50",
  /**
   * peck (US dry) per second
   *
   * rec20
   */
  PeckUsDryPerSecond = "L51",
  /**
   * psi per psi
   *
   * rec20
   */
  PsiPerPsi = "L52",
  /**
   * pint (UK) per day
   *
   * rec20
   */
  PintUkPerDay = "L53",
  /**
   * pint (UK) per hour
   *
   * rec20
   */
  PintUkPerHour = "L54",
  /**
   * pint (UK) per minute
   *
   * rec20
   */
  PintUkPerMinute = "L55",
  /**
   * pint (UK) per second
   *
   * rec20
   */
  PintUkPerSecond = "L56",
  /**
   * pint (US liquid) per day
   *
   * rec20
   */
  PintUsLiquidPerDay = "L57",
  /**
   * pint (US liquid) per hour
   *
   * rec20
   */
  PintUsLiquidPerHour = "L58",
  /**
   * pint (US liquid) per minute
   *
   * rec20
   */
  PintUsLiquidPerMinute = "L59",
  /**
   * pint (US liquid) per second
   *
   * rec20
   */
  PintUsLiquidPerSecond = "L60",
  /**
   * slug per day
   *
   * rec20
   */
  SlugPerDay = "L63",
  /**
   * slug per foot second
   *
   * rec20
   */
  SlugPerFootSecond = "L64",
  /**
   * slug per cubic foot
   *
   * rec20
   */
  SlugPerCubicFoot = "L65",
  /**
   * slug per hour
   *
   * rec20
   */
  SlugPerHour = "L66",
  /**
   * slug per minute
   *
   * rec20
   */
  SlugPerMinute = "L67",
  /**
   * slug per second
   *
   * rec20
   */
  SlugPerSecond = "L68",
  /**
   * tonne per kelvin
   *
   * rec20
   */
  TonnePerKelvin = "L69",
  /**
   * tonne per bar
   *
   * rec20
   */
  TonnePerBar = "L70",
  /**
   * tonne per day
   *
   * rec20
   */
  TonnePerDay = "L71",
  /**
   * tonne per day kelvin
   *
   * rec20
   */
  TonnePerDayKelvin = "L72",
  /**
   * tonne per day bar
   *
   * rec20
   */
  TonnePerDayBar = "L73",
  /**
   * tonne per hour kelvin
   *
   * rec20
   */
  TonnePerHourKelvin = "L74",
  /**
   * tonne per hour bar
   *
   * rec20
   */
  TonnePerHourBar = "L75",
  /**
   * tonne per cubic metre kelvin
   *
   * rec20
   */
  TonnePerCubicMetreKelvin = "L76",
  /**
   * tonne per cubic metre bar
   *
   * rec20
   */
  TonnePerCubicMetreBar = "L77",
  /**
   * tonne per minute
   *
   * rec20
   */
  TonnePerMinute = "L78",
  /**
   * tonne per minute kelvin
   *
   * rec20
   */
  TonnePerMinuteKelvin = "L79",
  /**
   * tonne per minute bar
   *
   * rec20
   */
  TonnePerMinuteBar = "L80",
  /**
   * tonne per second
   *
   * rec20
   */
  TonnePerSecond = "L81",
  /**
   * tonne per second kelvin
   *
   * rec20
   */
  TonnePerSecondKelvin = "L82",
  /**
   * tonne per second bar
   *
   * rec20
   */
  TonnePerSecondBar = "L83",
  /**
   * ton (UK shipping)
   *
   * rec20
   */
  TonUkShipping = "L84",
  /**
   * ton long per day
   *
   * rec20
   */
  TonLongPerDay = "L85",
  /**
   * ton (US shipping)
   *
   * rec20
   */
  TonUsShipping = "L86",
  /**
   * ton short per degree Fahrenheit
   *
   * rec20
   */
  TonShortPerDegreeFahrenheit = "L87",
  /**
   * ton short per day
   *
   * rec20
   */
  TonShortPerDay = "L88",
  /**
   * ton short per hour degree Fahrenheit
   *
   * rec20
   */
  TonShortPerHourDegreeFahrenheit = "L89",
  /**
   * ton short per hour psi
   *
   * rec20
   */
  TonShortPerHourPsi = "L90",
  /**
   * ton short per psi
   *
   * rec20
   */
  TonShortPerPsi = "L91",
  /**
   * ton (UK long) per cubic yard
   *
   * rec20
   */
  TonUkLongPerCubicYard = "L92",
  /**
   * ton (US short) per cubic yard
   *
   * rec20
   */
  TonUsShortPerCubicYard = "L93",
  /**
   * ton-force (US short)
   *
   * rec20
   */
  TonForceUsShort = "L94",
  /**
   * common year
   *
   * rec20
   */
  CommonYear = "L95",
  /**
   * sidereal year
   *
   * rec20
   */
  SiderealYear = "L96",
  /**
   * yard per degree Fahrenheit
   *
   * rec20
   */
  YardPerDegreeFahrenheit = "L98",
  /**
   * yard per psi
   *
   * rec20
   */
  YardPerPsi = "L99",
  /**
   * pound per cubic inch
   *
   * rec20
   */
  PoundPerCubicInch = "LA",
  /**
   * lactose excess percentage
   *
   * rec20
   */
  LactoseExcessPercentage = "LAC",
  /**
   * pound
   *
   * rec20
   */
  Pound = "LBR",
  /**
   * troy pound (US)
   *
   * rec20
   */
  TroyPoundUs = "LBT",
  /**
   * litre per day
   *
   * rec20
   */
  LitrePerDay = "LD",
  /**
   * leaf
   *
   * rec20
   */
  Leaf = "LEF",
  /**
   * linear foot
   *
   * rec20
   */
  LinearFoot = "LF",
  /**
   * labour hour
   *
   * rec20
   */
  LabourHour = "LH",
  /**
   * link
   *
   * rec20
   */
  Link = "LK",
  /**
   * linear metre
   *
   * rec20
   */
  LinearMetre = "LM",
  /**
   * length
   *
   * rec20
   */
  Length = "LN",
  /**
   * lot [unit of procurement]
   *
   * rec20
   */
  LotUnitProcurement = "LO",
  /**
   * liquid pound
   *
   * rec20
   */
  LiquidPound = "LP",
  /**
   * litre of pure alcohol
   *
   * rec20
   */
  LitrePureAlcohol = "LPA",
  /**
   * layer
   *
   * rec20
   */
  Layer = "LR",
  /**
   * lump sum
   *
   * rec20
   */
  LumpSum = "LS",
  /**
   * ton (UK) or long ton (US)
   *
   * rec20
   */
  TonUkOrLongTonUs = "LTN",
  /**
   * litre
   *
   * rec20
   */
  Litre = "LTR",
  /**
   * metric ton, lubricating oil
   *
   * rec20
   */
  MetricTonLubricatingOil = "LUB",
  /**
   * lumen
   *
   * rec20
   */
  Lumen = "LUM",
  /**
   * lux
   *
   * rec20
   */
  Lux = "LUX",
  /**
   * linear yard
   *
   * rec20
   */
  LinearYard = "LY",
  /**
   * milligram per litre
   *
   * rec20
   */
  MilligramPerLitre = "M1",
  /**
   * reciprocal cubic yard
   *
   * rec20
   */
  ReciprocalCubicYard = "M10",
  /**
   * cubic yard per degree Fahrenheit
   *
   * rec20
   */
  CubicYardPerDegreeFahrenheit = "M11",
  /**
   * cubic yard per day
   *
   * rec20
   */
  CubicYardPerDay = "M12",
  /**
   * cubic yard per hour
   *
   * rec20
   */
  CubicYardPerHour = "M13",
  /**
   * cubic yard per psi
   *
   * rec20
   */
  CubicYardPerPsi = "M14",
  /**
   * cubic yard per minute
   *
   * rec20
   */
  CubicYardPerMinute = "M15",
  /**
   * cubic yard per second
   *
   * rec20
   */
  CubicYardPerSecond = "M16",
  /**
   * kilohertz metre
   *
   * rec20
   */
  KilohertzMetre = "M17",
  /**
   * gigahertz metre
   *
   * rec20
   */
  GigahertzMetre = "M18",
  /**
   * Beaufort
   *
   * rec20
   */
  Beaufort = "M19",
  /**
   * reciprocal megakelvin or megakelvin to the power minus one
   *
   * rec20
   */
  ReciprocalMegakelvinOrMegakelvinToPowerMinusOne = "M20",
  /**
   * reciprocal kilovolt - ampere reciprocal hour
   *
   * rec20
   */
  ReciprocalKilovoltAmpereReciprocalHour = "M21",
  /**
   * millilitre per square centimetre minute
   *
   * rec20
   */
  MillilitrePerSquareCentimetreMinute = "M22",
  /**
   * newton per centimetre
   *
   * rec20
   */
  NewtonPerCentimetre = "M23",
  /**
   * ohm kilometre
   *
   * rec20
   */
  OhmKilometre = "M24",
  /**
   * percent per degree Celsius
   *
   * rec20
   */
  PercentPerDegreeCelsius = "M25",
  /**
   * gigaohm per metre
   *
   * rec20
   */
  GigaohmPerMetre = "M26",
  /**
   * megahertz metre
   *
   * rec20
   */
  MegahertzMetre = "M27",
  /**
   * kilogram per kilogram
   *
   * rec20
   */
  KilogramPerKilogram = "M29",
  /**
   * reciprocal volt - ampere reciprocal second
   *
   * rec20
   */
  ReciprocalVoltAmpereReciprocalSecond = "M30",
  /**
   * kilogram per kilometre
   *
   * rec20
   */
  KilogramPerKilometre = "M31",
  /**
   * pascal second per litre
   *
   * rec20
   */
  PascalSecondPerLitre = "M32",
  /**
   * millimole per litre
   *
   * rec20
   */
  MillimolePerLitre = "M33",
  /**
   * newton metre per square metre
   *
   * rec20
   */
  NewtonMetrePerSquareMetre = "M34",
  /**
   * millivolt - ampere
   *
   * rec20
   */
  MillivoltAmpere = "M35",
  /**
   * 30-day month
   *
   * rec20
   */
  _30DayMonth = "M36",
  /**
   * actual/360
   *
   * rec20
   */
  Actual360 = "M37",
  /**
   * kilometre per second squared
   *
   * rec20
   */
  KilometrePerSecondSquared = "M38",
  /**
   * centimetre per second squared
   *
   * rec20
   */
  CentimetrePerSecondSquared = "M39",
  /**
   * monetary value
   *
   * rec20
   */
  MonetaryValue = "M4",
  /**
   * yard per second squared
   *
   * rec20
   */
  YardPerSecondSquared = "M40",
  /**
   * millimetre per second squared
   *
   * rec20
   */
  MillimetrePerSecondSquared = "M41",
  /**
   * mile (statute mile) per second squared
   *
   * rec20
   */
  MileStatuteMilePerSecondSquared = "M42",
  /**
   * mil
   *
   * rec20
   */
  Mil = "M43",
  /**
   * revolution
   *
   * rec20
   */
  Revolution = "M44",
  /**
   * degree [unit of angle] per second squared
   *
   * rec20
   */
  DegreeUnitAnglePerSecondSquared = "M45",
  /**
   * revolution per minute
   *
   * rec20
   */
  RevolutionPerMinute = "M46",
  /**
   * circular mil
   *
   * rec20
   */
  CircularMil = "M47",
  /**
   * square mile (based on U.S. survey foot)
   *
   * rec20
   */
  SquareMileBasedOnUSSurveyFoot = "M48",
  /**
   * chain (based on U.S. survey foot)
   *
   * rec20
   */
  ChainBasedOnUSSurveyFoot = "M49",
  /**
   * microcurie
   *
   * rec20
   */
  Microcurie = "M5",
  /**
   * furlong
   *
   * rec20
   */
  Furlong = "M50",
  /**
   * foot (U.S. survey)
   *
   * rec20
   */
  FootUSSurvey = "M51",
  /**
   * mile (based on U.S. survey foot)
   *
   * rec20
   */
  MileBasedOnUSSurveyFoot = "M52",
  /**
   * metre per pascal
   *
   * rec20
   */
  MetrePerPascal = "M53",
  /**
   * metre per radiant
   *
   * rec20
   */
  MetrePerRadiant = "M55",
  /**
   * shake
   *
   * rec20
   */
  Shake = "M56",
  /**
   * mile per minute
   *
   * rec20
   */
  MilePerMinute = "M57",
  /**
   * mile per second
   *
   * rec20
   */
  MilePerSecond = "M58",
  /**
   * metre per second pascal
   *
   * rec20
   */
  MetrePerSecondPascal = "M59",
  /**
   * metre per hour
   *
   * rec20
   */
  MetrePerHour = "M60",
  /**
   * inch per year
   *
   * rec20
   */
  InchPerYear = "M61",
  /**
   * kilometre per second
   *
   * rec20
   */
  KilometrePerSecond = "M62",
  /**
   * inch per minute
   *
   * rec20
   */
  InchPerMinute = "M63",
  /**
   * yard per second
   *
   * rec20
   */
  YardPerSecond = "M64",
  /**
   * yard per minute
   *
   * rec20
   */
  YardPerMinute = "M65",
  /**
   * yard per hour
   *
   * rec20
   */
  YardPerHour = "M66",
  /**
   * acre-foot (based on U.S. survey foot)
   *
   * rec20
   */
  AcreFootBasedOnUSSurveyFoot = "M67",
  /**
   * cord (128 ft3)
   *
   * rec20
   */
  Cord128Ft3 = "M68",
  /**
   * cubic mile (UK statute)
   *
   * rec20
   */
  CubicMileUkStatute = "M69",
  /**
   * micro-inch
   *
   * rec20
   */
  MicroInch = "M7",
  /**
   * ton, register
   *
   * rec20
   */
  TonRegister = "M70",
  /**
   * cubic metre per pascal
   *
   * rec20
   */
  CubicMetrePerPascal = "M71",
  /**
   * bel
   *
   * rec20
   */
  Bel = "M72",
  /**
   * kilogram per cubic metre pascal
   *
   * rec20
   */
  KilogramPerCubicMetrePascal = "M73",
  /**
   * kilogram per pascal
   *
   * rec20
   */
  KilogramPerPascal = "M74",
  /**
   * kilopound-force
   *
   * rec20
   */
  KilopoundForce = "M75",
  /**
   * poundal
   *
   * rec20
   */
  Poundal = "M76",
  /**
   * kilogram metre per second squared
   *
   * rec20
   */
  KilogramMetrePerSecondSquared = "M77",
  /**
   * pond
   *
   * rec20
   */
  Pond = "M78",
  /**
   * square foot per hour
   *
   * rec20
   */
  SquareFootPerHour = "M79",
  /**
   * stokes per pascal
   *
   * rec20
   */
  StokesPerPascal = "M80",
  /**
   * square centimetre per second
   *
   * rec20
   */
  SquareCentimetrePerSecond = "M81",
  /**
   * square metre per second pascal
   *
   * rec20
   */
  SquareMetrePerSecondPascal = "M82",
  /**
   * denier
   *
   * rec20
   */
  Denier_Dup = "M83",
  /**
   * pound per yard
   *
   * rec20
   */
  PoundPerYard = "M84",
  /**
   * ton, assay
   *
   * rec20
   */
  TonAssay = "M85",
  /**
   * pfund
   *
   * rec20
   */
  Pfund = "M86",
  /**
   * kilogram per second pascal
   *
   * rec20
   */
  KilogramPerSecondPascal = "M87",
  /**
   * tonne per month
   *
   * rec20
   */
  TonnePerMonth = "M88",
  /**
   * tonne per year
   *
   * rec20
   */
  TonnePerYear = "M89",
  /**
   * million Btu per 1000 cubic foot
   *
   * rec20
   */
  MillionBtuPer1000CubicFoot = "M9",
  /**
   * kilopound per hour
   *
   * rec20
   */
  KilopoundPerHour = "M90",
  /**
   * pound per pound
   *
   * rec20
   */
  PoundPerPound = "M91",
  /**
   * pound-force foot
   *
   * rec20
   */
  PoundForceFoot = "M92",
  /**
   * newton metre per radian
   *
   * rec20
   */
  NewtonMetrePerRadian = "M93",
  /**
   * kilogram metre
   *
   * rec20
   */
  KilogramMetre = "M94",
  /**
   * poundal foot
   *
   * rec20
   */
  PoundalFoot = "M95",
  /**
   * poundal inch
   *
   * rec20
   */
  PoundalInch = "M96",
  /**
   * dyne metre
   *
   * rec20
   */
  DyneMetre = "M97",
  /**
   * kilogram centimetre per second
   *
   * rec20
   */
  KilogramCentimetrePerSecond = "M98",
  /**
   * gram centimetre per second
   *
   * rec20
   */
  GramCentimetrePerSecond = "M99",
  /**
   * megavolt ampere reactive hour
   *
   * rec20
   */
  MegavoltAmpereReactiveHour = "MAH",
  /**
   * megalitre
   *
   * rec20
   */
  Megalitre = "MAL",
  /**
   * megametre
   *
   * rec20
   */
  Megametre = "MAM",
  /**
   * megavar
   *
   * rec20
   */
  Megavar = "MAR",
  /**
   * megawatt
   *
   * rec20
   */
  Megawatt = "MAW",
  /**
   * thousand standard brick equivalent
   *
   * rec20
   */
  ThousandStandardBrickEquivalent = "MBE",
  /**
   * thousand board foot
   *
   * rec20
   */
  ThousandBoardFoot = "MBF",
  /**
   * millibar
   *
   * rec20
   */
  Millibar = "MBR",
  /**
   * microgram
   *
   * rec20
   */
  Microgram = "MC",
  /**
   * millicurie
   *
   * rec20
   */
  Millicurie = "MCU",
  /**
   * air dry metric ton
   *
   * rec20
   */
  AirDryMetricTon = "MD",
  /**
   * milligram
   *
   * rec20
   */
  Milligram = "MGM",
  /**
   * megahertz
   *
   * rec20
   */
  Megahertz = "MHZ",
  /**
   * square mile (statute mile)
   *
   * rec20
   */
  SquareMileStatuteMile = "MIK",
  /**
   * thousand
   *
   * rec20
   */
  Thousand = "MIL",
  /**
   * minute [unit of time]
   *
   * rec20
   */
  MinuteUnitTime = "MIN",
  /**
   * million
   *
   * rec20
   */
  Million = "MIO",
  /**
   * million international unit
   *
   * rec20
   */
  MillionInternationalUnit = "MIU",
  /**
   * Square Metre Day
   *
   * Rec20
   */
  SquareMetreDay = "MKD",
  /**
   * Square Metre Month
   *
   * Rec20
   */
  SquareMetreMonth = "MKM",
  /**
   * Square Metre Week
   *
   * Rec20
   */
  SquareMetreWeek = "MKW",
  /**
   * milliard
   *
   * rec20
   */
  Milliard = "MLD",
  /**
   * millilitre
   *
   * rec20
   */
  Millilitre = "MLT",
  /**
   * square millimetre
   *
   * rec20
   */
  SquareMillimetre = "MMK",
  /**
   * cubic millimetre
   *
   * rec20
   */
  CubicMillimetre = "MMQ",
  /**
   * millimetre
   *
   * rec20
   */
  Millimetre = "MMT",
  /**
   * kilogram, dry weight
   *
   * rec20
   */
  KilogramDryWeight = "MND",
  /**
   * Mega Joule per Normalised cubic Metre
   *
   * Rec20
   */
  MegaJoulePerNormalisedCubicMetre = "MNJ",
  /**
   * month
   *
   * rec20
   */
  Month = "MON",
  /**
   * megapascal
   *
   * rec20
   */
  Megapascal = "MPA",
  /**
   * Cubic Metre Day
   *
   * Rec20
   */
  CubicMetreDay = "MQD",
  /**
   * cubic metre per hour
   *
   * rec20
   */
  CubicMetrePerHour = "MQH",
  /**
   * Cubic Metre Month
   *
   * Rec20
   */
  CubicMetreMonth = "MQM",
  /**
   * cubic metre per second
   *
   * rec20
   */
  CubicMetrePerSecond = "MQS",
  /**
   * Cubic Metre Week
   *
   * Rec20
   */
  CubicMetreWeek = "MQW",
  /**
   * Metre Day
   *
   * Rec20
   */
  MetreDay = "MRD",
  /**
   * Metre Month
   *
   * Rec20
   */
  MetreMonth = "MRM",
  /**
   * Metre Week
   *
   * Rec20
   */
  MetreWeek = "MRW",
  /**
   * metre per second squared
   *
   * rec20
   */
  MetrePerSecondSquared = "MSK",
  /**
   * square metre
   *
   * rec20
   */
  SquareMetre = "MTK",
  /**
   * cubic metre
   *
   * rec20
   */
  CubicMetre = "MTQ",
  /**
   * metre
   *
   * rec20
   */
  Metre = "MTR",
  /**
   * metre per second
   *
   * rec20
   */
  MetrePerSecond = "MTS",
  /**
   * milihertz
   *
   * Rec20
   */
  Milihertz = "MTZ",
  /**
   * megavolt - ampere
   *
   * rec20
   */
  MegavoltAmpere = "MVA",
  /**
   * megawatt hour (1000 kW.h)
   *
   * rec20
   */
  MegawattHour1000KwH = "MWH",
  /**
   * pen calorie
   *
   * rec20
   */
  PenCalorie = "N1",
  /**
   * pound foot per second
   *
   * rec20
   */
  PoundFootPerSecond = "N10",
  /**
   * pound inch per second
   *
   * rec20
   */
  PoundInchPerSecond = "N11",
  /**
   * Pferdestaerke
   *
   * rec20
   */
  Pferdestaerke = "N12",
  /**
   * centimetre of mercury (0 ºC)
   *
   * rec20
   */
  CentimetreMercury0Oc = "N13",
  /**
   * centimetre of water (4 ºC)
   *
   * rec20
   */
  CentimetreWater4Oc = "N14",
  /**
   * foot of water (39.2 ºF)
   *
   * rec20
   */
  FootWater392Of = "N15",
  /**
   * inch of mercury (32 ºF)
   *
   * rec20
   */
  InchMercury32Of = "N16",
  /**
   * inch of mercury (60 ºF)
   *
   * rec20
   */
  InchMercury60Of = "N17",
  /**
   * inch of water (39.2 ºF)
   *
   * rec20
   */
  InchWater392Of = "N18",
  /**
   * inch of water (60 ºF)
   *
   * rec20
   */
  InchWater60Of = "N19",
  /**
   * kip per square inch
   *
   * rec20
   */
  KipPerSquareInch = "N20",
  /**
   * poundal per square foot
   *
   * rec20
   */
  PoundalPerSquareFoot = "N21",
  /**
   * ounce (avoirdupois) per square inch
   *
   * rec20
   */
  OunceAvoirdupoisPerSquareInch = "N22",
  /**
   * conventional metre of water
   *
   * rec20
   */
  ConventionalMetreWater = "N23",
  /**
   * gram per square millimetre
   *
   * rec20
   */
  GramPerSquareMillimetre = "N24",
  /**
   * pound per square yard
   *
   * rec20
   */
  PoundPerSquareYard = "N25",
  /**
   * poundal per square inch
   *
   * rec20
   */
  PoundalPerSquareInch = "N26",
  /**
   * foot to the fourth power
   *
   * rec20
   */
  FootToFourthPower = "N27",
  /**
   * cubic decimetre per kilogram
   *
   * rec20
   */
  CubicDecimetrePerKilogram = "N28",
  /**
   * cubic foot per pound
   *
   * rec20
   */
  CubicFootPerPound = "N29",
  /**
   * print point
   *
   * rec20
   */
  PrintPoint = "N3",
  /**
   * cubic inch per pound
   *
   * rec20
   */
  CubicInchPerPound = "N30",
  /**
   * kilonewton per metre
   *
   * rec20
   */
  KilonewtonPerMetre = "N31",
  /**
   * poundal per inch
   *
   * rec20
   */
  PoundalPerInch = "N32",
  /**
   * pound-force per yard
   *
   * rec20
   */
  PoundForcePerYard = "N33",
  /**
   * poundal second per square foot
   *
   * rec20
   */
  PoundalSecondPerSquareFoot = "N34",
  /**
   * poise per pascal
   *
   * rec20
   */
  PoisePerPascal = "N35",
  /**
   * newton second per square metre
   *
   * rec20
   */
  NewtonSecondPerSquareMetre = "N36",
  /**
   * kilogram per metre second
   *
   * rec20
   */
  KilogramPerMetreSecond = "N37",
  /**
   * kilogram per metre minute
   *
   * rec20
   */
  KilogramPerMetreMinute = "N38",
  /**
   * kilogram per metre day
   *
   * rec20
   */
  KilogramPerMetreDay = "N39",
  /**
   * kilogram per metre hour
   *
   * rec20
   */
  KilogramPerMetreHour = "N40",
  /**
   * gram per centimetre second
   *
   * rec20
   */
  GramPerCentimetreSecond = "N41",
  /**
   * poundal second per square inch
   *
   * rec20
   */
  PoundalSecondPerSquareInch = "N42",
  /**
   * pound per foot minute
   *
   * rec20
   */
  PoundPerFootMinute = "N43",
  /**
   * pound per foot day
   *
   * rec20
   */
  PoundPerFootDay = "N44",
  /**
   * cubic metre per second pascal
   *
   * rec20
   */
  CubicMetrePerSecondPascal = "N45",
  /**
   * foot poundal
   *
   * rec20
   */
  FootPoundal = "N46",
  /**
   * inch poundal
   *
   * rec20
   */
  InchPoundal = "N47",
  /**
   * watt per square centimetre
   *
   * rec20
   */
  WattPerSquareCentimetre = "N48",
  /**
   * watt per square inch
   *
   * rec20
   */
  WattPerSquareInch = "N49",
  /**
   * British thermal unit (international table) per square foot hour
   *
   * rec20
   */
  BritishThermalUnitInternationalTablePerSquareFootHour = "N50",
  /**
   * British thermal unit (thermochemical) per square foot hour
   *
   * rec20
   */
  BritishThermalUnitThermochemicalPerSquareFootHour = "N51",
  /**
   * British thermal unit (thermochemical) per square foot minute
   *
   * rec20
   */
  BritishThermalUnitThermochemicalPerSquareFootMinute = "N52",
  /**
   * British thermal unit (international table) per square foot second
   *
   * rec20
   */
  BritishThermalUnitInternationalTablePerSquareFootSecond = "N53",
  /**
   * British thermal unit (thermochemical) per square foot second
   *
   * rec20
   */
  BritishThermalUnitThermochemicalPerSquareFootSecond = "N54",
  /**
   * British thermal unit (international table) per square inch second
   *
   * rec20
   */
  BritishThermalUnitInternationalTablePerSquareInchSecond = "N55",
  /**
   * calorie (thermochemical) per square centimetre minute
   *
   * rec20
   */
  CalorieThermochemicalPerSquareCentimetreMinute = "N56",
  /**
   * calorie (thermochemical) per square centimetre second
   *
   * rec20
   */
  CalorieThermochemicalPerSquareCentimetreSecond = "N57",
  /**
   * British thermal unit (international table) per cubic foot
   *
   * rec20
   */
  BritishThermalUnitInternationalTablePerCubicFoot = "N58",
  /**
   * British thermal unit (thermochemical) per cubic foot
   *
   * rec20
   */
  BritishThermalUnitThermochemicalPerCubicFoot = "N59",
  /**
   * British thermal unit (international table) per degree Fahrenheit
   *
   * rec20
   */
  BritishThermalUnitInternationalTablePerDegreeFahrenheit = "N60",
  /**
   * British thermal unit (thermochemical) per degree Fahrenheit
   *
   * rec20
   */
  BritishThermalUnitThermochemicalPerDegreeFahrenheit = "N61",
  /**
   * British thermal unit (international table) per degree Rankine
   *
   * rec20
   */
  BritishThermalUnitInternationalTablePerDegreeRankine = "N62",
  /**
   * British thermal unit (thermochemical) per degree Rankine
   *
   * rec20
   */
  BritishThermalUnitThermochemicalPerDegreeRankine = "N63",
  /**
   * British thermal unit (thermochemical) per pound degree Rankine
   *
   * rec20
   */
  BritishThermalUnitThermochemicalPerPoundDegreeRankine = "N64",
  /**
   * kilocalorie (international table) per gram kelvin
   *
   * rec20
   */
  KilocalorieInternationalTablePerGramKelvin = "N65",
  /**
   * British thermal unit (39 ºF)
   *
   * rec20
   */
  BritishThermalUnit39Of = "N66",
  /**
   * British thermal unit (59 ºF)
   *
   * rec20
   */
  BritishThermalUnit59Of = "N67",
  /**
   * British thermal unit (60 ºF)
   *
   * rec20
   */
  BritishThermalUnit60Of = "N68",
  /**
   * calorie (20 ºC)
   *
   * rec20
   */
  Calorie20Oc = "N69",
  /**
   * quad (1015 BtuIT)
   *
   * rec20
   */
  Quad1015Btuit = "N70",
  /**
   * therm (EC)
   *
   * rec20
   */
  ThermEc = "N71",
  /**
   * therm (U.S.)
   *
   * rec20
   */
  ThermUS = "N72",
  /**
   * British thermal unit (thermochemical) per pound
   *
   * rec20
   */
  BritishThermalUnitThermochemicalPerPound = "N73",
  /**
   * British thermal unit (international table) per hour square foot degree Fahrenheit
   *
   * rec20
   */
  BritishThermalUnitInternationalTablePerHourSquareFootDegreeFahrenheit = "N74",
  /**
   * British thermal unit (thermochemical) per hour square foot degree Fahrenheit
   *
   * rec20
   */
  BritishThermalUnitThermochemicalPerHourSquareFootDegreeFahrenheit = "N75",
  /**
   * British thermal unit (international table) per second square foot degree Fahrenheit
   *
   * rec20
   */
  BritishThermalUnitInternationalTablePerSecondSquareFootDegreeFahrenheit = "N76",
  /**
   * British thermal unit (thermochemical) per second square foot degree Fahrenheit
   *
   * rec20
   */
  BritishThermalUnitThermochemicalPerSecondSquareFootDegreeFahrenheit = "N77",
  /**
   * kilowatt per square metre kelvin
   *
   * rec20
   */
  KilowattPerSquareMetreKelvin = "N78",
  /**
   * kelvin per pascal
   *
   * rec20
   */
  KelvinPerPascal = "N79",
  /**
   * watt per metre degree Celsius
   *
   * rec20
   */
  WattPerMetreDegreeCelsius = "N80",
  /**
   * kilowatt per metre kelvin
   *
   * rec20
   */
  KilowattPerMetreKelvin = "N81",
  /**
   * kilowatt per metre degree Celsius
   *
   * rec20
   */
  KilowattPerMetreDegreeCelsius = "N82",
  /**
   * metre per degree Celcius metre
   *
   * rec20
   */
  MetrePerDegreeCelciusMetre = "N83",
  /**
   * degree Fahrenheit hour per British thermal unit (international table)
   *
   * rec20
   */
  DegreeFahrenheitHourPerBritishThermalUnitInternationalTable = "N84",
  /**
   * degree Fahrenheit hour per British thermal unit (thermochemical)
   *
   * rec20
   */
  DegreeFahrenheitHourPerBritishThermalUnitThermochemical = "N85",
  /**
   * degree Fahrenheit second per British thermal unit (international table)
   *
   * rec20
   */
  DegreeFahrenheitSecondPerBritishThermalUnitInternationalTable = "N86",
  /**
   * degree Fahrenheit second per British thermal unit (thermochemical)
   *
   * rec20
   */
  DegreeFahrenheitSecondPerBritishThermalUnitThermochemical = "N87",
  /**
   * degree Fahrenheit hour square foot per British thermal unit (international table) inch
   *
   * rec20
   */
  DegreeFahrenheitHourSquareFootPerBritishThermalUnitInternationalTableInch = "N88",
  /**
   * degree Fahrenheit hour square foot per British thermal unit (thermochemical) inch
   *
   * rec20
   */
  DegreeFahrenheitHourSquareFootPerBritishThermalUnitThermochemicalInch = "N89",
  /**
   * kilofarad
   *
   * rec20
   */
  Kilofarad = "N90",
  /**
   * reciprocal joule
   *
   * rec20
   */
  ReciprocalJoule = "N91",
  /**
   * picosiemens
   *
   * rec20
   */
  Picosiemens = "N92",
  /**
   * ampere per pascal
   *
   * rec20
   */
  AmperePerPascal = "N93",
  /**
   * franklin
   *
   * rec20
   */
  Franklin = "N94",
  /**
   * ampere minute
   *
   * rec20
   */
  AmpereMinute = "N95",
  /**
   * biot
   *
   * rec20
   */
  Biot = "N96",
  /**
   * gilbert
   *
   * rec20
   */
  Gilbert = "N97",
  /**
   * volt per pascal
   *
   * rec20
   */
  VoltPerPascal = "N98",
  /**
   * picovolt
   *
   * rec20
   */
  Picovolt = "N99",
  /**
   * milligram per kilogram
   *
   * rec20
   */
  MilligramPerKilogram = "NA",
  /**
   * number of articles
   *
   * rec20
   */
  NumberArticles = "NAR",
  /**
   * number of cells
   *
   * rec20
   */
  NumberCells = "NCL",
  /**
   * newton
   *
   * rec20
   */
  Newton = "NEW",
  /**
   * message
   *
   * rec20
   */
  Message = "NF",
  /**
   * nil
   *
   * rec20
   */
  Nil = "NIL",
  /**
   * number of international units
   *
   * rec20
   */
  NumberInternationalUnits = "NIU",
  /**
   * load
   *
   * rec20
   */
  Load = "NL",
  /**
   * Normalised cubic metre
   *
   * rec20
   */
  NormalisedCubicMetre = "NM3",
  /**
   * nautical mile
   *
   * rec20
   */
  NauticalMile = "NMI",
  /**
   * number of packs
   *
   * rec20
   */
  NumberPacks = "NMP",
  /**
   * number of parts
   *
   * rec20
   */
  NumberParts = "NPT",
  /**
   * net ton
   *
   * rec20
   */
  NetTon = "NT",
  /**
   * Nephelometric turbidity unit
   *
   * Rec20
   */
  NephelometricTurbidityUnit = "NTU",
  /**
   * newton metre
   *
   * rec20
   */
  NewtonMetre = "NU",
  /**
   * part per thousand
   *
   * rec20
   */
  PartPerThousand = "NX",
  /**
   * panel
   *
   * rec20
   */
  Panel = "OA",
  /**
   * ozone depletion equivalent
   *
   * rec20
   */
  OzoneDepletionEquivalent = "ODE",
  /**
   * ODS Grams
   *
   * rec20
   */
  OdsGrams = "ODG",
  /**
   * ODS Kilograms
   *
   * rec20
   */
  OdsKilograms = "ODK",
  /**
   * ODS Milligrams
   *
   * rec20
   */
  OdsMilligrams = "ODM",
  /**
   * ohm
   *
   * rec20
   */
  Ohm = "OHM",
  /**
   * ounce per square yard
   *
   * rec20
   */
  OuncePerSquareYard = "ON",
  /**
   * ounce (avoirdupois)
   *
   * rec20
   */
  OunceAvoirdupois = "ONZ",
  /**
   * oscillations per minute
   *
   * rec20
   */
  OscillationsPerMinute = "OPM",
  /**
   * overtime hour
   *
   * rec20
   */
  OvertimeHour = "OT",
  /**
   * fluid ounce (US)
   *
   * rec20
   */
  FluidOunceUs = "OZA",
  /**
   * fluid ounce (UK)
   *
   * rec20
   */
  FluidOunceUk = "OZI",
  /**
   * percent
   *
   * rec20
   */
  Percent = "P1",
  /**
   * coulomb per metre
   *
   * rec20
   */
  CoulombPerMetre = "P10",
  /**
   * kiloweber
   *
   * rec20
   */
  Kiloweber = "P11",
  /**
   * gamma
   *
   * rec20
   */
  Gamma = "P12",
  /**
   * kilotesla
   *
   * rec20
   */
  Kilotesla = "P13",
  /**
   * joule per second
   *
   * rec20
   */
  JoulePerSecond = "P14",
  /**
   * joule per minute
   *
   * rec20
   */
  JoulePerMinute = "P15",
  /**
   * joule per hour
   *
   * rec20
   */
  JoulePerHour = "P16",
  /**
   * joule per day
   *
   * rec20
   */
  JoulePerDay = "P17",
  /**
   * kilojoule per second
   *
   * rec20
   */
  KilojoulePerSecond = "P18",
  /**
   * kilojoule per minute
   *
   * rec20
   */
  KilojoulePerMinute = "P19",
  /**
   * pound per foot
   *
   * rec20
   */
  PoundPerFoot = "P2",
  /**
   * kilojoule per hour
   *
   * rec20
   */
  KilojoulePerHour = "P20",
  /**
   * kilojoule per day
   *
   * rec20
   */
  KilojoulePerDay = "P21",
  /**
   * nanoohm
   *
   * rec20
   */
  Nanoohm = "P22",
  /**
   * ohm circular-mil per foot
   *
   * rec20
   */
  OhmCircularMilPerFoot = "P23",
  /**
   * kilohenry
   *
   * rec20
   */
  Kilohenry = "P24",
  /**
   * lumen per square foot
   *
   * rec20
   */
  LumenPerSquareFoot = "P25",
  /**
   * phot
   *
   * rec20
   */
  Phot = "P26",
  /**
   * footcandle
   *
   * rec20
   */
  Footcandle = "P27",
  /**
   * candela per square inch
   *
   * rec20
   */
  CandelaPerSquareInch = "P28",
  /**
   * footlambert
   *
   * rec20
   */
  Footlambert = "P29",
  /**
   * lambert
   *
   * rec20
   */
  Lambert = "P30",
  /**
   * stilb
   *
   * rec20
   */
  Stilb = "P31",
  /**
   * candela per square foot
   *
   * rec20
   */
  CandelaPerSquareFoot = "P32",
  /**
   * kilocandela
   *
   * rec20
   */
  Kilocandela = "P33",
  /**
   * millicandela
   *
   * rec20
   */
  Millicandela = "P34",
  /**
   * Hefner-Kerze
   *
   * rec20
   */
  HefnerKerze = "P35",
  /**
   * international candle
   *
   * rec20
   */
  InternationalCandle = "P36",
  /**
   * British thermal unit (international table) per square foot
   *
   * rec20
   */
  BritishThermalUnitInternationalTablePerSquareFoot = "P37",
  /**
   * British thermal unit (thermochemical) per square foot
   *
   * rec20
   */
  BritishThermalUnitThermochemicalPerSquareFoot = "P38",
  /**
   * calorie (thermochemical) per square centimetre
   *
   * rec20
   */
  CalorieThermochemicalPerSquareCentimetre = "P39",
  /**
   * langley
   *
   * rec20
   */
  Langley = "P40",
  /**
   * decade (logarithmic)
   *
   * rec20
   */
  DecadeLogarithmic = "P41",
  /**
   * pascal squared second
   *
   * rec20
   */
  PascalSquaredSecond = "P42",
  /**
   * bel per metre
   *
   * rec20
   */
  BelPerMetre = "P43",
  /**
   * pound mole
   *
   * rec20
   */
  PoundMole = "P44",
  /**
   * pound mole per second
   *
   * rec20
   */
  PoundMolePerSecond = "P45",
  /**
   * pound mole per minute
   *
   * rec20
   */
  PoundMolePerMinute = "P46",
  /**
   * kilomole per kilogram
   *
   * rec20
   */
  KilomolePerKilogram = "P47",
  /**
   * pound mole per pound
   *
   * rec20
   */
  PoundMolePerPound = "P48",
  /**
   * newton square metre per ampere
   *
   * rec20
   */
  NewtonSquareMetrePerAmpere = "P49",
  /**
   * five pack
   *
   * rec20
   */
  FivePack = "P5",
  /**
   * weber metre
   *
   * rec20
   */
  WeberMetre = "P50",
  /**
   * mol per kilogram pascal
   *
   * rec20
   */
  MolPerKilogramPascal = "P51",
  /**
   * mol per cubic metre pascal
   *
   * rec20
   */
  MolPerCubicMetrePascal = "P52",
  /**
   * unit pole
   *
   * rec20
   */
  UnitPole = "P53",
  /**
   * milligray per second
   *
   * rec20
   */
  MilligrayPerSecond = "P54",
  /**
   * microgray per second
   *
   * rec20
   */
  MicrograyPerSecond = "P55",
  /**
   * nanogray per second
   *
   * rec20
   */
  NanograyPerSecond = "P56",
  /**
   * gray per minute
   *
   * rec20
   */
  GrayPerMinute = "P57",
  /**
   * milligray per minute
   *
   * rec20
   */
  MilligrayPerMinute = "P58",
  /**
   * microgray per minute
   *
   * rec20
   */
  MicrograyPerMinute = "P59",
  /**
   * nanogray per minute
   *
   * rec20
   */
  NanograyPerMinute = "P60",
  /**
   * gray per hour
   *
   * rec20
   */
  GrayPerHour = "P61",
  /**
   * milligray per hour
   *
   * rec20
   */
  MilligrayPerHour = "P62",
  /**
   * microgray per hour
   *
   * rec20
   */
  MicrograyPerHour = "P63",
  /**
   * nanogray per hour
   *
   * rec20
   */
  NanograyPerHour = "P64",
  /**
   * sievert per second
   *
   * rec20
   */
  SievertPerSecond = "P65",
  /**
   * millisievert per second
   *
   * rec20
   */
  MillisievertPerSecond = "P66",
  /**
   * microsievert per second
   *
   * rec20
   */
  MicrosievertPerSecond = "P67",
  /**
   * nanosievert per second
   *
   * rec20
   */
  NanosievertPerSecond = "P68",
  /**
   * rem per second
   *
   * rec20
   */
  RemPerSecond = "P69",
  /**
   * sievert per hour
   *
   * rec20
   */
  SievertPerHour = "P70",
  /**
   * millisievert per hour
   *
   * rec20
   */
  MillisievertPerHour = "P71",
  /**
   * microsievert per hour
   *
   * rec20
   */
  MicrosievertPerHour = "P72",
  /**
   * nanosievert per hour
   *
   * rec20
   */
  NanosievertPerHour = "P73",
  /**
   * sievert per minute
   *
   * rec20
   */
  SievertPerMinute = "P74",
  /**
   * millisievert per minute
   *
   * rec20
   */
  MillisievertPerMinute = "P75",
  /**
   * microsievert per minute
   *
   * rec20
   */
  MicrosievertPerMinute = "P76",
  /**
   * nanosievert per minute
   *
   * rec20
   */
  NanosievertPerMinute = "P77",
  /**
   * reciprocal square inch
   *
   * rec20
   */
  ReciprocalSquareInch = "P78",
  /**
   * pascal square metre per kilogram
   *
   * rec20
   */
  PascalSquareMetrePerKilogram = "P79",
  /**
   * millipascal per metre
   *
   * rec20
   */
  MillipascalPerMetre = "P80",
  /**
   * kilopascal per metre
   *
   * rec20
   */
  KilopascalPerMetre = "P81",
  /**
   * hectopascal per metre
   *
   * rec20
   */
  HectopascalPerMetre = "P82",
  /**
   * standard atmosphere per metre
   *
   * rec20
   */
  StandardAtmospherePerMetre = "P83",
  /**
   * technical atmosphere per metre
   *
   * rec20
   */
  TechnicalAtmospherePerMetre = "P84",
  /**
   * torr per metre
   *
   * rec20
   */
  TorrPerMetre = "P85",
  /**
   * psi per inch
   *
   * rec20
   */
  PsiPerInch = "P86",
  /**
   * cubic metre per second square metre
   *
   * rec20
   */
  CubicMetrePerSecondSquareMetre = "P87",
  /**
   * rhe
   *
   * rec20
   */
  Rhe = "P88",
  /**
   * pound-force foot per inch
   *
   * rec20
   */
  PoundForceFootPerInch = "P89",
  /**
   * pound-force inch per inch
   *
   * rec20
   */
  PoundForceInchPerInch = "P90",
  /**
   * perm (0 ºC)
   *
   * rec20
   */
  Perm0Oc = "P91",
  /**
   * perm (23 ºC)
   *
   * rec20
   */
  Perm23Oc = "P92",
  /**
   * byte per second
   *
   * rec20
   */
  BytePerSecond = "P93",
  /**
   * kilobyte per second
   *
   * rec20
   */
  KilobytePerSecond = "P94",
  /**
   * megabyte per second
   *
   * rec20
   */
  MegabytePerSecond = "P95",
  /**
   * reciprocal volt
   *
   * rec20
   */
  ReciprocalVolt = "P96",
  /**
   * reciprocal radian
   *
   * rec20
   */
  ReciprocalRadian = "P97",
  /**
   * pascal to the power sum of stoichiometric numbers
   *
   * rec20
   */
  PascalToPowerSumStoichiometricNumbers = "P98",
  /**
   * mole per cubiv metre to the power sum of stoichiometric numbers
   *
   * rec20
   */
  MolePerCubivMetreToPowerSumStoichiometricNumbers = "P99",
  /**
   * pascal
   *
   * rec20
   */
  Pascal = "PAL",
  /**
   * pad
   *
   * rec20
   */
  Pad = "PD",
  /**
   * proof litre
   *
   * rec20
   */
  ProofLitre = "PFL",
  /**
   * proof gallon
   *
   * rec20
   */
  ProofGallon = "PGL",
  /**
   * pitch
   *
   * rec20
   */
  Pitch = "PI",
  /**
   * degree Plato
   *
   * rec20
   */
  DegreePlato = "PLA",
  /**
   * pound per inch of length
   *
   * rec20
   */
  PoundPerInchLength = "PO",
  /**
   * page per inch
   *
   * rec20
   */
  PagePerInch = "PQ",
  /**
   * pair
   *
   * rec20
   */
  Pair = "PR",
  /**
   * pound-force per square inch
   *
   * rec20
   */
  PoundForcePerSquareInch = "PS",
  /**
   * dry pint (US)
   *
   * rec20
   */
  DryPintUs = "PTD",
  /**
   * pint (UK)
   *
   * rec20
   */
  PintUk = "PTI",
  /**
   * liquid pint (US)
   *
   * rec20
   */
  LiquidPintUs = "PTL",
  /**
   * portion
   *
   * rec20
   */
  Portion = "PTN",
  /**
   * joule per tesla
   *
   * rec20
   */
  JoulePerTesla = "Q10",
  /**
   * erlang
   *
   * rec20
   */
  Erlang = "Q11",
  /**
   * octet
   *
   * rec20
   */
  Octet = "Q12",
  /**
   * octet per second
   *
   * rec20
   */
  OctetPerSecond = "Q13",
  /**
   * shannon
   *
   * rec20
   */
  Shannon = "Q14",
  /**
   * hartley
   *
   * rec20
   */
  Hartley = "Q15",
  /**
   * natural unit of information
   *
   * rec20
   */
  NaturalUnitInformation = "Q16",
  /**
   * shannon per second
   *
   * rec20
   */
  ShannonPerSecond = "Q17",
  /**
   * hartley per second
   *
   * rec20
   */
  HartleyPerSecond = "Q18",
  /**
   * natural unit of information per second
   *
   * rec20
   */
  NaturalUnitInformationPerSecond = "Q19",
  /**
   * second per kilogramm
   *
   * rec20
   */
  SecondPerKilogramm = "Q20",
  /**
   * watt square metre
   *
   * rec20
   */
  WattSquareMetre = "Q21",
  /**
   * second per radian cubic metre
   *
   * rec20
   */
  SecondPerRadianCubicMetre = "Q22",
  /**
   * weber to the power minus one
   *
   * rec20
   */
  WeberToPowerMinusOne = "Q23",
  /**
   * reciprocal inch
   *
   * rec20
   */
  ReciprocalInch = "Q24",
  /**
   * dioptre
   *
   * rec20
   */
  Dioptre = "Q25",
  /**
   * one per one
   *
   * rec20
   */
  OnePerOne = "Q26",
  /**
   * newton metre per metre
   *
   * rec20
   */
  NewtonMetrePerMetre = "Q27",
  /**
   * kilogram per square metre pascal second
   *
   * rec20
   */
  KilogramPerSquareMetrePascalSecond = "Q28",
  /**
   * microgram per hectogram
   *
   * rec20
   */
  MicrogramPerHectogram = "Q29",
  /**
   * meal
   *
   * rec20
   */
  Meal = "Q3",
  /**
   * pH (potential of Hydrogen)
   *
   * rec20
   */
  PhPotentialHydrogen = "Q30",
  /**
   * kilojoule per gram
   *
   * rec20
   */
  KilojoulePerGram = "Q31",
  /**
   * femtolitre
   *
   * rec20
   */
  Femtolitre = "Q32",
  /**
   * picolitre
   *
   * rec20
   */
  Picolitre = "Q33",
  /**
   * nanolitre
   *
   * rec20
   */
  Nanolitre = "Q34",
  /**
   * megawatts per minute
   *
   * rec20
   */
  MegawattsPerMinute = "Q35",
  /**
   * square metre per cubic metre
   *
   * rec20
   */
  SquareMetrePerCubicMetre = "Q36",
  /**
   * Standard cubic metre per day
   *
   * rec20
   */
  StandardCubicMetrePerDay = "Q37",
  /**
   * Standard cubic metre per hour
   *
   * rec20
   */
  StandardCubicMetrePerHour = "Q38",
  /**
   * Normalized cubic metre per day
   *
   * rec20
   */
  NormalizedCubicMetrePerDay = "Q39",
  /**
   * Normalized cubic metre per hour
   *
   * rec20
   */
  NormalizedCubicMetrePerHour = "Q40",
  /**
   * Joule per normalised cubic metre
   *
   * rec20
   */
  JoulePerNormalisedCubicMetre = "Q41",
  /**
   * Joule per standard cubic metre
   *
   * rec20
   */
  JoulePerStandardCubicMetre = "Q42",
  /**
   * page - facsimile
   *
   * rec20
   */
  PageFacsimile = "QA",
  /**
   * quarter (of a year)
   *
   * rec20
   */
  QuarterAYear = "QAN",
  /**
   * page - hardcopy
   *
   * rec20
   */
  PageHardcopy = "QB",
  /**
   * quire
   *
   * rec20
   */
  Quire = "QR",
  /**
   * dry quart (US)
   *
   * rec20
   */
  DryQuartUs = "QTD",
  /**
   * quart (UK)
   *
   * rec20
   */
  QuartUk = "QTI",
  /**
   * liquid quart (US)
   *
   * rec20
   */
  LiquidQuartUs = "QTL",
  /**
   * quarter (UK)
   *
   * rec20
   */
  QuarterUk = "QTR",
  /**
   * pica
   *
   * rec20
   */
  Pica = "R1",
  /**
   * thousand cubic metre
   *
   * rec20
   */
  ThousandCubicMetre = "R9",
  /**
   * running or operating hour
   *
   * rec20
   */
  RunningOrOperatingHour = "RH",
  /**
   * ream
   *
   * rec20
   */
  Ream = "RM",
  /**
   * room
   *
   * rec20
   */
  Room = "ROM",
  /**
   * pound per ream
   *
   * rec20
   */
  PoundPerReam = "RP",
  /**
   * revolutions per minute
   *
   * rec20
   */
  RevolutionsPerMinute = "RPM",
  /**
   * revolutions per second
   *
   * rec20
   */
  RevolutionsPerSecond = "RPS",
  /**
   * revenue ton mile
   *
   * rec20
   */
  RevenueTonMile = "RT",
  /**
   * square foot per second
   *
   * rec20
   */
  SquareFootPerSecond = "S3",
  /**
   * square metre per second
   *
   * rec20
   */
  SquareMetrePerSecond = "S4",
  /**
   * half year (6 months)
   *
   * rec20
   */
  HalfYear6Months = "SAN",
  /**
   * score
   *
   * rec20
   */
  Score = "SCO",
  /**
   * scruple
   *
   * rec20
   */
  Scruple = "SCR",
  /**
   * second [unit of time]
   *
   * rec20
   */
  SecondUnitTime = "SEC",
  /**
   * set
   *
   * rec20
   */
  Set = "SET",
  /**
   * segment
   *
   * rec20
   */
  Segment = "SG",
  /**
   * siemens
   *
   * rec20
   */
  Siemens = "SIE",
  /**
   * Standard cubic metre
   *
   * rec20
   */
  StandardCubicMetre = "SM3",
  /**
   * mile (statute mile)
   *
   * rec20
   */
  MileStatuteMile = "SMI",
  /**
   * square
   *
   * rec20
   */
  Square = "SQ",
  /**
   * square, roofing
   *
   * rec20
   */
  SquareRoofing = "SQR",
  /**
   * strip
   *
   * rec20
   */
  Strip = "SR",
  /**
   * stick
   *
   * rec20
   */
  Stick = "STC",
  /**
   * stone (UK)
   *
   * rec20
   */
  StoneUk = "STI",
  /**
   * stick, cigarette
   *
   * rec20
   */
  StickCigarette = "STK",
  /**
   * standard litre
   *
   * rec20
   */
  StandardLitre = "STL",
  /**
   * ton (US) or short ton (UK/US)
   *
   * rec20
   */
  TonUsOrShortTonUkUs = "STN",
  /**
   * straw
   *
   * rec20
   */
  Straw = "STW",
  /**
   * skein
   *
   * rec20
   */
  Skein = "SW",
  /**
   * shipment
   *
   * rec20
   */
  Shipment = "SX",
  /**
   * syringe
   *
   * rec20
   */
  Syringe = "SYR",
  /**
   * telecommunication line in service
   *
   * rec20
   */
  TelecommunicationLineInService = "T0",
  /**
   * thousand piece
   *
   * rec20
   */
  ThousandPiece = "T3",
  /**
   * kiloampere hour (thousand ampere hour)
   *
   * rec20
   */
  KiloampereHourThousandAmpereHour = "TAH",
  /**
   * total acid number
   *
   * rec20
   */
  TotalAcidNumber = "TAN",
  /**
   * thousand square inch
   *
   * rec20
   */
  ThousandSquareInch = "TI",
  /**
   * metric ton, including container
   *
   * rec20
   */
  MetricTonIncludingContainer = "TIC",
  /**
   * metric ton, including inner packaging
   *
   * rec20
   */
  MetricTonIncludingInnerPackaging = "TIP",
  /**
   * tonne kilometre
   *
   * rec20
   */
  TonneKilometre = "TKM",
  /**
   * kilogram of imported meat, less offal
   *
   * rec20
   */
  KilogramImportedMeatLessOffal = "TMS",
  /**
   * tonne (metric ton)
   *
   * rec20
   */
  TonneMetricTon = "TNE",
  /**
   * ten pack
   *
   * rec20
   */
  TenPack = "TP",
  /**
   * teeth per inch
   *
   * rec20
   */
  TeethPerInch = "TPI",
  /**
   * ten pair
   *
   * rec20
   */
  TenPair = "TPR",
  /**
   * thousand cubic metre per day
   *
   * rec20
   */
  ThousandCubicMetrePerDay = "TQD",
  /**
   * trillion (EUR)
   *
   * rec20
   */
  TrillionEur = "TRL",
  /**
   * ten set
   *
   * rec20
   */
  TenSet = "TST",
  /**
   * ten thousand sticks
   *
   * rec20
   */
  TenThousandSticks = "TTS",
  /**
   * treatment
   *
   * rec20
   */
  Treatment = "U1",
  /**
   * tablet
   *
   * rec20
   */
  Tablet = "U2",
  /**
   * telecommunication line in service average
   *
   * rec20
   */
  TelecommunicationLineInServiceAverage = "UB",
  /**
   * telecommunication port
   *
   * rec20
   */
  TelecommunicationPort = "UC",
  /**
   * volt - ampere per kilogram
   *
   * rec20
   */
  VoltAmperePerKilogram = "VA",
  /**
   * volt
   *
   * rec20
   */
  Volt = "VLT",
  /**
   * percent volume
   *
   * rec20
   */
  PercentVolume = "VP",
  /**
   * wet kilo
   *
   * rec20
   */
  WetKilo = "W2",
  /**
   * watt per kilogram
   *
   * rec20
   */
  WattPerKilogram = "WA",
  /**
   * wet pound
   *
   * rec20
   */
  WetPound = "WB",
  /**
   * cord
   *
   * rec20
   */
  Cord = "WCD",
  /**
   * wet ton
   *
   * rec20
   */
  WetTon = "WE",
  /**
   * weber
   *
   * rec20
   */
  Weber = "WEB",
  /**
   * week
   *
   * rec20
   */
  Week = "WEE",
  /**
   * wine gallon
   *
   * rec20
   */
  WineGallon = "WG",
  /**
   * watt hour
   *
   * rec20
   */
  WattHour = "WHR",
  /**
   * working month
   *
   * rec20
   */
  WorkingMonth = "WM",
  /**
   * standard
   *
   * rec20
   */
  Standard = "WSD",
  /**
   * watt
   *
   * rec20
   */
  Watt = "WTT",
  /**
   * Gunter's chain
   *
   * rec20
   */
  GuntersChain = "X1",
  /**
   * square yard
   *
   * rec20
   */
  SquareYard = "YDK",
  /**
   * cubic yard
   *
   * rec20
   */
  CubicYard = "YDQ",
  /**
   * yard
   *
   * rec20
   */
  Yard = "YRD",
  /**
   * hanging container
   *
   * rec20
   */
  HangingContainer = "Z11",
  /**
   * nanomole
   *
   * Rec20
   */
  Nanomole = "Z9",
  /**
   * page
   *
   * rec20
   */
  Page = "ZP",
  /**
   * mutually defined
   *
   * rec20
   */
  MutuallyDefined = "ZZ",
  /**
   * Drum, steel
   *
   * rec21
   */
  DrumSteel = "X1A",
  /**
   * Drum, aluminium
   *
   * rec21
   */
  DrumAluminium = "X1B",
  /**
   * Drum, plywood
   *
   * rec21
   */
  DrumPlywood = "X1D",
  /**
   * Container, flexible
   *
   * rec21
   */
  ContainerFlexible = "X1F",
  /**
   * Drum, fibre
   *
   * rec21
   */
  DrumFibre = "X1G",
  /**
   * Drum, wooden
   *
   * rec21
   */
  DrumWooden = "X1W",
  /**
   * Barrel, wooden
   *
   * rec21
   */
  BarrelWooden = "X2C",
  /**
   * Jerrican, steel
   *
   * rec21
   */
  JerricanSteel = "X3A",
  /**
   * Jerrican, plastic
   *
   * rec21
   */
  JerricanPlastic = "X3H",
  /**
   * Bag, super bulk
   *
   * rec21
   */
  BagSuperBulk = "X43",
  /**
   * Bag, polybag
   *
   * rec21
   */
  BagPolybag = "X44",
  /**
   * Box, steel
   *
   * rec21
   */
  BoxSteel = "X4A",
  /**
   * Box, aluminium
   *
   * rec21
   */
  BoxAluminium = "X4B",
  /**
   * Box, natural wood
   *
   * rec21
   */
  BoxNaturalWood = "X4C",
  /**
   * Box, plywood
   *
   * rec21
   */
  BoxPlywood = "X4D",
  /**
   * Box, reconstituted wood
   *
   * rec21
   */
  BoxReconstitutedWood = "X4F",
  /**
   * Box, fibreboard
   *
   * rec21
   */
  BoxFibreboard = "X4G",
  /**
   * Box, plastic
   *
   * rec21
   */
  BoxPlastic = "X4H",
  /**
   * Bag, woven plastic
   *
   * rec21
   */
  BagWovenPlastic = "X5H",
  /**
   * Bag, textile
   *
   * rec21
   */
  BagTextile = "X5L",
  /**
   * Bag, paper
   *
   * rec21
   */
  BagPaper = "X5M",
  /**
   * Composite packaging, plastic receptacle
   *
   * rec21
   */
  CompositePackagingPlasticReceptacle = "X6H",
  /**
   * Composite packaging, glass receptacle
   *
   * rec21
   */
  CompositePackagingGlassReceptacle = "X6P",
  /**
   * Case, car
   *
   * rec21
   */
  CaseCar = "X7A",
  /**
   * Case, wooden
   *
   * rec21
   */
  CaseWooden = "X7B",
  /**
   * Pallet, wooden
   *
   * rec21
   */
  PalletWooden = "X8A",
  /**
   * Crate, wooden
   *
   * rec21
   */
  CrateWooden = "X8B",
  /**
   * Bundle, wooden
   *
   * rec21
   */
  BundleWooden = "X8C",
  /**
   * Intermediate bulk container, rigid plastic
   *
   * rec21
   */
  IntermediateBulkContainerRigidPlastic = "XAA",
  /**
   * Receptacle, fibre
   *
   * rec21
   */
  ReceptacleFibre = "XAB",
  /**
   * Receptacle, paper
   *
   * rec21
   */
  ReceptaclePaper = "XAC",
  /**
   * Receptacle, wooden
   *
   * rec21
   */
  ReceptacleWooden = "XAD",
  /**
   * Aerosol
   *
   * rec21
   */
  Aerosol = "XAE",
  /**
   * Pallet, modular, collars 80cms * 60cms
   *
   * rec21
   */
  PalletModularCollars80cms60cms = "XAF",
  /**
   * Pallet, shrinkwrapped
   *
   * rec21
   */
  PalletShrinkwrapped = "XAG",
  /**
   * Pallet, 100cms * 110cms
   *
   * rec21
   */
  Pallet100cms110cms = "XAH",
  /**
   * Clamshell
   *
   * rec21
   */
  Clamshell = "XAI",
  /**
   * Cone
   *
   * rec21
   */
  Cone = "XAJ",
  /**
   * Ball
   *
   * rec21
   */
  Ball_Dup = "XAL",
  /**
   * Ampoule, non-protected
   *
   * rec21
   */
  AmpouleNonProtected = "XAM",
  /**
   * Ampoule, protected
   *
   * rec21
   */
  AmpouleProtected = "XAP",
  /**
   * Atomizer
   *
   * rec21
   */
  Atomizer = "XAT",
  /**
   * Capsule
   *
   * rec21
   */
  Capsule = "XAV",
  /**
   * Belt
   *
   * rec21
   */
  Belt = "XB4",
  /**
   * Barrel
   *
   * rec21
   */
  Barrel = "XBA",
  /**
   * Bobbin
   *
   * rec21
   */
  Bobbin = "XBB",
  /**
   * Bottlecrate / bottlerack
   *
   * rec21
   */
  BottlecrateBottlerack = "XBC",
  /**
   * Board
   *
   * rec21
   */
  Board = "XBD",
  /**
   * Bundle
   *
   * rec21
   */
  Bundle = "XBE",
  /**
   * Balloon, non-protected
   *
   * rec21
   */
  BalloonNonProtected = "XBF",
  /**
   * Bag
   *
   * rec21
   */
  Bag = "XBG",
  /**
   * Bunch
   *
   * rec21
   */
  Bunch = "XBH",
  /**
   * Bin
   *
   * rec21
   */
  Bin = "XBI",
  /**
   * Bucket
   *
   * rec21
   */
  Bucket = "XBJ",
  /**
   * Basket
   *
   * rec21
   */
  Basket = "XBK",
  /**
   * Bale, compressed
   *
   * rec21
   */
  BaleCompressed = "XBL",
  /**
   * Basin
   *
   * rec21
   */
  Basin = "XBM",
  /**
   * Bale, non-compressed
   *
   * rec21
   */
  BaleNonCompressed = "XBN",
  /**
   * Bottle, non-protected, cylindrical
   *
   * rec21
   */
  BottleNonProtectedCylindrical = "XBO",
  /**
   * Balloon, protected
   *
   * rec21
   */
  BalloonProtected = "XBP",
  /**
   * Bottle, protected cylindrical
   *
   * rec21
   */
  BottleProtectedCylindrical = "XBQ",
  /**
   * Bar
   *
   * rec21
   */
  Bar = "XBR",
  /**
   * Bottle, non-protected, bulbous
   *
   * rec21
   */
  BottleNonProtectedBulbous = "XBS",
  /**
   * Bolt
   *
   * rec21
   */
  Bolt = "XBT",
  /**
   * Butt
   *
   * rec21
   */
  Butt = "XBU",
  /**
   * Bottle, protected bulbous
   *
   * rec21
   */
  BottleProtectedBulbous = "XBV",
  /**
   * Box, for liquids
   *
   * rec21
   */
  BoxForLiquids = "XBW",
  /**
   * Box
   *
   * rec21
   */
  Box = "XBX",
  /**
   * Board, in bundle/bunch/truss
   *
   * rec21
   */
  BoardInBundleBunchTruss = "XBY",
  /**
   * Bars, in bundle/bunch/truss
   *
   * rec21
   */
  BarsInBundleBunchTruss = "XBZ",
  /**
   * Can, rectangular
   *
   * rec21
   */
  CanRectangular = "XCA",
  /**
   * Crate, beer
   *
   * rec21
   */
  CrateBeer = "XCB",
  /**
   * Churn
   *
   * rec21
   */
  Churn = "XCC",
  /**
   * Can, with handle and spout
   *
   * rec21
   */
  CanWithHandleAndSpout = "XCD",
  /**
   * Creel
   *
   * rec21
   */
  Creel = "XCE",
  /**
   * Coffer
   *
   * rec21
   */
  Coffer = "XCF",
  /**
   * Cage
   *
   * rec21
   */
  Cage = "XCG",
  /**
   * Chest
   *
   * rec21
   */
  Chest = "XCH",
  /**
   * Canister
   *
   * rec21
   */
  Canister = "XCI",
  /**
   * Coffin
   *
   * rec21
   */
  Coffin = "XCJ",
  /**
   * Cask
   *
   * rec21
   */
  Cask = "XCK",
  /**
   * Coil
   *
   * rec21
   */
  Coil = "XCL",
  /**
   * Card
   *
   * rec21
   */
  Card_Dup = "XCM",
  /**
   * Container, not otherwise specified as transport equipment
   *
   * rec21
   */
  ContainerNotOtherwiseSpecifiedAsTransportEquipment = "XCN",
  /**
   * Carboy, non-protected
   *
   * rec21
   */
  CarboyNonProtected = "XCO",
  /**
   * Carboy, protected
   *
   * rec21
   */
  CarboyProtected = "XCP",
  /**
   * Cartridge
   *
   * rec21
   */
  Cartridge = "XCQ",
  /**
   * Crate
   *
   * rec21
   */
  Crate = "XCR",
  /**
   * Case
   *
   * rec21
   */
  Case = "XCS",
  /**
   * Carton
   *
   * rec21
   */
  Carton = "XCT",
  /**
   * Cup
   *
   * rec21
   */
  Cup = "XCU",
  /**
   * Cover
   *
   * rec21
   */
  Cover = "XCV",
  /**
   * Cage, roll
   *
   * rec21
   */
  CageRoll = "XCW",
  /**
   * Can, cylindrical
   *
   * rec21
   */
  CanCylindrical = "XCX",
  /**
   * Cylinder
   *
   * rec21
   */
  Cylinder = "XCY",
  /**
   * Canvas
   *
   * rec21
   */
  Canvas = "XCZ",
  /**
   * Crate, multiple layer, plastic
   *
   * rec21
   */
  CrateMultipleLayerPlastic = "XDA",
  /**
   * Crate, multiple layer, wooden
   *
   * rec21
   */
  CrateMultipleLayerWooden = "XDB",
  /**
   * Crate, multiple layer, cardboard
   *
   * rec21
   */
  CrateMultipleLayerCardboard = "XDC",
  /**
   * Cage, Commonwealth Handling Equipment Pool (CHEP)
   *
   * rec21
   */
  CageCommonwealthHandlingEquipmentPoolChep = "XDG",
  /**
   * Box, Commonwealth Handling Equipment Pool (CHEP), Eurobox
   *
   * rec21
   */
  BoxCommonwealthHandlingEquipmentPoolChepEurobox = "XDH",
  /**
   * Drum, iron
   *
   * rec21
   */
  DrumIron = "XDI",
  /**
   * Demijohn, non-protected
   *
   * rec21
   */
  DemijohnNonProtected = "XDJ",
  /**
   * Crate, bulk, cardboard
   *
   * rec21
   */
  CrateBulkCardboard = "XDK",
  /**
   * Crate, bulk, plastic
   *
   * rec21
   */
  CrateBulkPlastic = "XDL",
  /**
   * Crate, bulk, wooden
   *
   * rec21
   */
  CrateBulkWooden = "XDM",
  /**
   * Dispenser
   *
   * rec21
   */
  Dispenser = "XDN",
  /**
   * Demijohn, protected
   *
   * rec21
   */
  DemijohnProtected = "XDP",
  /**
   * Drum
   *
   * rec21
   */
  Drum = "XDR",
  /**
   * Tray, one layer no cover, plastic
   *
   * rec21
   */
  TrayOneLayerNoCoverPlastic = "XDS",
  /**
   * Tray, one layer no cover, wooden
   *
   * rec21
   */
  TrayOneLayerNoCoverWooden = "XDT",
  /**
   * Tray, one layer no cover, polystyrene
   *
   * rec21
   */
  TrayOneLayerNoCoverPolystyrene = "XDU",
  /**
   * Tray, one layer no cover, cardboard
   *
   * rec21
   */
  TrayOneLayerNoCoverCardboard = "XDV",
  /**
   * Tray, two layers no cover, plastic tray
   *
   * rec21
   */
  TrayTwoLayersNoCoverPlasticTray = "XDW",
  /**
   * Tray, two layers no cover, wooden
   *
   * rec21
   */
  TrayTwoLayersNoCoverWooden = "XDX",
  /**
   * Tray, two layers no cover, cardboard
   *
   * rec21
   */
  TrayTwoLayersNoCoverCardboard = "XDY",
  /**
   * Bag, plastic
   *
   * rec21
   */
  BagPlastic = "XEC",
  /**
   * Case, with pallet base
   *
   * rec21
   */
  CaseWithPalletBase = "XED",
  /**
   * Case, with pallet base, wooden
   *
   * rec21
   */
  CaseWithPalletBaseWooden = "XEE",
  /**
   * Case, with pallet base, cardboard
   *
   * rec21
   */
  CaseWithPalletBaseCardboard = "XEF",
  /**
   * Case, with pallet base, plastic
   *
   * rec21
   */
  CaseWithPalletBasePlastic = "XEG",
  /**
   * Case, with pallet base, metal
   *
   * rec21
   */
  CaseWithPalletBaseMetal = "XEH",
  /**
   * Case, isothermic
   *
   * rec21
   */
  CaseIsothermic = "XEI",
  /**
   * Envelope
   *
   * rec21
   */
  Envelope = "XEN",
  /**
   * Flexibag
   *
   * rec21
   */
  Flexibag = "XFB",
  /**
   * Crate, fruit
   *
   * rec21
   */
  CrateFruit = "XFC",
  /**
   * Crate, framed
   *
   * rec21
   */
  CrateFramed = "XFD",
  /**
   * Flexitank
   *
   * rec21
   */
  Flexitank = "XFE",
  /**
   * Firkin
   *
   * rec21
   */
  Firkin = "XFI",
  /**
   * Flask
   *
   * rec21
   */
  Flask = "XFL",
  /**
   * Footlocker
   *
   * rec21
   */
  Footlocker = "XFO",
  /**
   * Filmpack
   *
   * rec21
   */
  Filmpack = "XFP",
  /**
   * Frame
   *
   * rec21
   */
  Frame = "XFR",
  /**
   * Foodtainer
   *
   * rec21
   */
  Foodtainer = "XFT",
  /**
   * Cart, flatbed
   *
   * rec21
   */
  CartFlatbed = "XFW",
  /**
   * Bag, flexible container
   *
   * rec21
   */
  BagFlexibleContainer = "XFX",
  /**
   * Bottle, gas
   *
   * rec21
   */
  BottleGas = "XGB",
  /**
   * Girder
   *
   * rec21
   */
  Girder = "XGI",
  /**
   * Container, gallon
   *
   * rec21
   */
  ContainerGallon = "XGL",
  /**
   * Receptacle, glass
   *
   * rec21
   */
  ReceptacleGlass = "XGR",
  /**
   * Tray, containing horizontally stacked flat items
   *
   * rec21
   */
  TrayContainingHorizontallyStackedFlatItems = "XGU",
  /**
   * Bag, gunny
   *
   * rec21
   */
  BagGunny = "XGY",
  /**
   * Girders, in bundle/bunch/truss
   *
   * rec21
   */
  GirdersInBundleBunchTruss = "XGZ",
  /**
   * Basket, with handle, plastic
   *
   * rec21
   */
  BasketWithHandlePlastic = "XHA",
  /**
   * Basket, with handle, wooden
   *
   * rec21
   */
  BasketWithHandleWooden = "XHB",
  /**
   * Basket, with handle, cardboard
   *
   * rec21
   */
  BasketWithHandleCardboard = "XHC",
  /**
   * Hogshead
   *
   * rec21
   */
  Hogshead = "XHG",
  /**
   * Hanger
   *
   * rec21
   */
  Hanger = "XHN",
  /**
   * Hamper
   *
   * rec21
   */
  Hamper = "XHR",
  /**
   * Package, display, wooden
   *
   * rec21
   */
  PackageDisplayWooden = "XIA",
  /**
   * Package, display, cardboard
   *
   * rec21
   */
  PackageDisplayCardboard = "XIB",
  /**
   * Package, display, plastic
   *
   * rec21
   */
  PackageDisplayPlastic = "XIC",
  /**
   * Package, display, metal
   *
   * rec21
   */
  PackageDisplayMetal = "XID",
  /**
   * Package, show
   *
   * rec21
   */
  PackageShow = "XIE",
  /**
   * Package, flow
   *
   * rec21
   */
  PackageFlow = "XIF",
  /**
   * Package, paper wrapped
   *
   * rec21
   */
  PackagePaperWrapped = "XIG",
  /**
   * Drum, plastic
   *
   * rec21
   */
  DrumPlastic = "XIH",
  /**
   * Package, cardboard, with bottle grip-holes
   *
   * rec21
   */
  PackageCardboardWithBottleGripHoles = "XIK",
  /**
   * Tray, rigid, lidded stackable (CEN TS 14482:2002)
   *
   * rec21
   */
  TrayRigidLiddedStackableCenTs144822002 = "XIL",
  /**
   * Ingot
   *
   * rec21
   */
  Ingot = "XIN",
  /**
   * Ingots, in bundle/bunch/truss
   *
   * rec21
   */
  IngotsInBundleBunchTruss = "XIZ",
  /**
   * Bag, jumbo
   *
   * rec21
   */
  BagJumbo = "XJB",
  /**
   * Jerrican, rectangular
   *
   * rec21
   */
  JerricanRectangular = "XJC",
  /**
   * Jug
   *
   * rec21
   */
  Jug = "XJG",
  /**
   * Jar
   *
   * rec21
   */
  Jar = "XJR",
  /**
   * Jutebag
   *
   * rec21
   */
  Jutebag = "XJT",
  /**
   * Jerrican, cylindrical
   *
   * rec21
   */
  JerricanCylindrical = "XJY",
  /**
   * Keg
   *
   * rec21
   */
  Keg = "XKG",
  /**
   * Kit
   *
   * rec21
   */
  Kit_Dup = "XKI",
  /**
   * Luggage
   *
   * rec21
   */
  Luggage = "XLE",
  /**
   * Log
   *
   * rec21
   */
  Log = "XLG",
  /**
   * Lot
   *
   * rec21
   */
  Lot = "XLT",
  /**
   * Lug
   *
   * rec21
   */
  Lug = "XLU",
  /**
   * Liftvan
   *
   * rec21
   */
  Liftvan = "XLV",
  /**
   * Logs, in bundle/bunch/truss
   *
   * rec21
   */
  LogsInBundleBunchTruss = "XLZ",
  /**
   * Crate, metal
   *
   * rec21
   */
  CrateMetal = "XMA",
  /**
   * Bag, multiply
   *
   * rec21
   */
  BagMultiply = "XMB",
  /**
   * Crate, milk
   *
   * rec21
   */
  CrateMilk = "XMC",
  /**
   * Container, metal
   *
   * rec21
   */
  ContainerMetal = "XME",
  /**
   * Receptacle, metal
   *
   * rec21
   */
  ReceptacleMetal = "XMR",
  /**
   * Sack, multi-wall
   *
   * rec21
   */
  SackMultiWall = "XMS",
  /**
   * Mat
   *
   * rec21
   */
  Mat = "XMT",
  /**
   * Receptacle, plastic wrapped
   *
   * rec21
   */
  ReceptaclePlasticWrapped = "XMW",
  /**
   * Matchbox
   *
   * rec21
   */
  Matchbox = "XMX",
  /**
   * Not available
   *
   * rec21
   */
  NotAvailable = "XNA",
  /**
   * Unpacked or unpackaged
   *
   * rec21
   */
  UnpackedOrUnpackaged = "XNE",
  /**
   * Unpacked or unpackaged, single unit
   *
   * rec21
   */
  UnpackedOrUnpackagedSingleUnit = "XNF",
  /**
   * Unpacked or unpackaged, multiple units
   *
   * rec21
   */
  UnpackedOrUnpackagedMultipleUnits = "XNG",
  /**
   * Nest
   *
   * rec21
   */
  Nest = "XNS",
  /**
   * Net
   *
   * rec21
   */
  Net = "XNT",
  /**
   * Net, tube, plastic
   *
   * rec21
   */
  NetTubePlastic = "XNU",
  /**
   * Net, tube, textile
   *
   * rec21
   */
  NetTubeTextile = "XNV",
  /**
   * Two sided cage on wheels with fixing strap
   *
   * Rec21
   */
  TwoSidedCageOnWheelsWithFixingStrap = "XO1",
  /**
   * Trolley
   *
   * Rec21
   */
  Trolley = "XO2",
  /**
   * Oneway pallet ISO 0 - 1/2 EURO Pallet
   *
   * Rec21
   */
  OnewayPalletIso012EuroPallet = "XO3",
  /**
   * Oneway pallet ISO 1 - 1/1 EURO Pallet
   *
   * Rec21
   */
  OnewayPalletIso111EuroPallet = "XO4",
  /**
   * Oneway pallet ISO 2 - 2/1 EURO Pallet
   *
   * Rec21
   */
  OnewayPalletIso221EuroPallet = "XO5",
  /**
   * Pallet with exceptional dimensions
   *
   * Rec21
   */
  PalletWithExceptionalDimensions = "XO6",
  /**
   * Wooden pallet 40 cm x 80 cm
   *
   * Rec21
   */
  WoodenPallet40CmX80Cm = "XO7",
  /**
   * Plastic pallet SRS 60 cm x 80 cm
   *
   * Rec21
   */
  PlasticPalletSrs60CmX80Cm = "XO8",
  /**
   * Plastic pallet SRS 80 cm x 120 cm
   *
   * Rec21
   */
  PlasticPalletSrs80CmX120Cm = "XO9",
  /**
   * Pallet, CHEP 40 cm x 60 cm
   *
   * rec21
   */
  PalletChep40CmX60Cm = "XOA",
  /**
   * Pallet, CHEP 80 cm x 120 cm
   *
   * rec21
   */
  PalletChep80CmX120Cm = "XOB",
  /**
   * Pallet, CHEP 100 cm x 120 cm
   *
   * rec21
   */
  PalletChep100CmX120Cm = "XOC",
  /**
   * Pallet, AS 4068-1993
   *
   * rec21
   */
  PalletAs40681993 = "XOD",
  /**
   * Pallet, ISO T11
   *
   * rec21
   */
  PalletIsoT11 = "XOE",
  /**
   * Platform, unspecified weight or dimension
   *
   * rec21
   */
  PlatformUnspecifiedWeightOrDimension = "XOF",
  /**
   * Pallet ISO 0 - 1/2 EURO Pallet
   *
   * Rec21
   */
  PalletIso012EuroPallet = "XOG",
  /**
   * Pallet ISO 1 - 1/1 EURO Pallet
   *
   * Rec21
   */
  PalletIso111EuroPallet = "XOH",
  /**
   * Pallet ISO 2 – 2/1 EURO Pallet
   *
   * Rec21
   */
  PalletIso221EuroPallet = "XOI",
  /**
   * 1/4 EURO Pallet
   *
   * Rec21
   */
  _14EuroPallet = "XOJ",
  /**
   * Block
   *
   * rec21
   */
  Block = "XOK",
  /**
   * 1/8 EURO Pallet
   *
   * Rec21
   */
  _18EuroPallet = "XOL",
  /**
   * Synthetic pallet ISO 1
   *
   * Rec21
   */
  SyntheticPalletIso1 = "XOM",
  /**
   * Synthetic pallet ISO 2
   *
   * Rec21
   */
  SyntheticPalletIso2 = "XON",
  /**
   * Wholesaler pallet
   *
   * Rec21
   */
  WholesalerPallet = "XOP",
  /**
   * Pallet 80 X 100 cm
   *
   * Rec21
   */
  Pallet80X100Cm = "XOQ",
  /**
   * Pallet 60 X 100 cm
   *
   * Rec21
   */
  Pallet60X100Cm = "XOR",
  /**
   * Oneway pallet
   *
   * Rec21
   */
  OnewayPallet = "XOS",
  /**
   * Octabin
   *
   * rec21
   */
  Octabin = "XOT",
  /**
   * Container, outer
   *
   * rec21
   */
  ContainerOuter = "XOU",
  /**
   * Returnable pallet
   *
   * Rec21
   */
  ReturnablePallet = "XOV",
  /**
   * Large bag, pallet sized
   *
   * Rec21
   */
  LargeBagPalletSized = "XOW",
  /**
   * A wheeled pallet with raised rim (81 x 67 x 135)
   *
   * Rec21
   */
  AWheeledPalletWithRaisedRim81X67X135 = "XOX",
  /**
   * A Wheeled pallet with raised rim (81 x 72 x 135)
   *
   * Rec21
   */
  AWheeledPalletWithRaisedRim81X72X135 = "XOY",
  /**
   * Wheeled pallet with raised rim ( 81 x 60 x 16)
   *
   * Rec21
   */
  WheeledPalletWithRaisedRim81X60X16 = "XOZ",
  /**
   * CHEP pallet 60 cm x 80 cm
   *
   * Rec21
   */
  ChepPallet60CmX80Cm = "XP1",
  /**
   * Pan
   *
   * rec21
   */
  Pan = "XP2",
  /**
   * LPR pallet 60 cm x 80 cm
   *
   * Rec21
   */
  LprPallet60CmX80Cm = "XP3",
  /**
   * LPR pallet 80 cm x 120 cm
   *
   * Rec21
   */
  LprPallet80CmX120Cm = "XP4",
  /**
   * Packet
   *
   * rec21
   */
  Packet = "XPA",
  /**
   * Pallet, box Combined open-ended box and pallet
   *
   * rec21
   */
  PalletBoxCombinedOpenEndedBoxAndPallet = "XPB",
  /**
   * Parcel
   *
   * rec21
   */
  Parcel = "XPC",
  /**
   * Pallet, modular, collars 80cms * 100cms
   *
   * rec21
   */
  PalletModularCollars80cms100cms = "XPD",
  /**
   * Pallet, modular, collars 80cms * 120cms
   *
   * rec21
   */
  PalletModularCollars80cms120cms = "XPE",
  /**
   * Pen
   *
   * rec21
   */
  Pen = "XPF",
  /**
   * Plate
   *
   * rec21
   */
  Plate = "XPG",
  /**
   * Pitcher
   *
   * rec21
   */
  Pitcher = "XPH",
  /**
   * Pipe
   *
   * rec21
   */
  Pipe = "XPI",
  /**
   * Punnet
   *
   * rec21
   */
  Punnet = "XPJ",
  /**
   * Package
   *
   * rec21
   */
  Package = "XPK",
  /**
   * Pail
   *
   * rec21
   */
  Pail = "XPL",
  /**
   * Plank
   *
   * rec21
   */
  Plank = "XPN",
  /**
   * Pouch
   *
   * rec21
   */
  Pouch = "XPO",
  /**
   * Piece
   *
   * rec21
   */
  Piece_Dup = "XPP",
  /**
   * Receptacle, plastic
   *
   * rec21
   */
  ReceptaclePlastic = "XPR",
  /**
   * Pot
   *
   * rec21
   */
  Pot = "XPT",
  /**
   * Tray
   *
   * rec21
   */
  Tray = "XPU",
  /**
   * Pipes, in bundle/bunch/truss
   *
   * rec21
   */
  PipesInBundleBunchTruss = "XPV",
  /**
   * Pallet
   *
   * rec21
   */
  Pallet = "XPX",
  /**
   * Plates, in bundle/bunch/truss
   *
   * rec21
   */
  PlatesInBundleBunchTruss = "XPY",
  /**
   * Planks, in bundle/bunch/truss
   *
   * rec21
   */
  PlanksInBundleBunchTruss = "XPZ",
  /**
   * Drum, steel, non-removable head
   *
   * rec21
   */
  DrumSteelNonRemovableHead = "XQA",
  /**
   * Drum, steel, removable head
   *
   * rec21
   */
  DrumSteelRemovableHead = "XQB",
  /**
   * Drum, aluminium, non-removable head
   *
   * rec21
   */
  DrumAluminiumNonRemovableHead = "XQC",
  /**
   * Drum, aluminium, removable head
   *
   * rec21
   */
  DrumAluminiumRemovableHead = "XQD",
  /**
   * Drum, plastic, non-removable head
   *
   * rec21
   */
  DrumPlasticNonRemovableHead = "XQF",
  /**
   * Drum, plastic, removable head
   *
   * rec21
   */
  DrumPlasticRemovableHead = "XQG",
  /**
   * Barrel, wooden, bung type
   *
   * rec21
   */
  BarrelWoodenBungType = "XQH",
  /**
   * Barrel, wooden, removable head
   *
   * rec21
   */
  BarrelWoodenRemovableHead = "XQJ",
  /**
   * Jerrican, steel, non-removable head
   *
   * rec21
   */
  JerricanSteelNonRemovableHead = "XQK",
  /**
   * Jerrican, steel, removable head
   *
   * rec21
   */
  JerricanSteelRemovableHead = "XQL",
  /**
   * Jerrican, plastic, non-removable head
   *
   * rec21
   */
  JerricanPlasticNonRemovableHead = "XQM",
  /**
   * Jerrican, plastic, removable head
   *
   * rec21
   */
  JerricanPlasticRemovableHead = "XQN",
  /**
   * Box, wooden, natural wood, ordinary
   *
   * rec21
   */
  BoxWoodenNaturalWoodOrdinary = "XQP",
  /**
   * Box, wooden, natural wood, with sift proof walls
   *
   * rec21
   */
  BoxWoodenNaturalWoodWithSiftProofWalls = "XQQ",
  /**
   * Box, plastic, expanded
   *
   * rec21
   */
  BoxPlasticExpanded = "XQR",
  /**
   * Box, plastic, solid
   *
   * rec21
   */
  BoxPlasticSolid = "XQS",
  /**
   * Rod
   *
   * rec21
   */
  Rod = "XRD",
  /**
   * Ring
   *
   * rec21
   */
  Ring = "XRG",
  /**
   * Rack, clothing hanger
   *
   * rec21
   */
  RackClothingHanger = "XRJ",
  /**
   * Rack
   *
   * rec21
   */
  Rack = "XRK",
  /**
   * Reel
   *
   * rec21
   */
  Reel = "XRL",
  /**
   * Roll
   *
   * rec21
   */
  Roll = "XRO",
  /**
   * Rednet
   *
   * rec21
   */
  Rednet = "XRT",
  /**
   * Rods, in bundle/bunch/truss
   *
   * rec21
   */
  RodsInBundleBunchTruss = "XRZ",
  /**
   * Sack
   *
   * rec21
   */
  Sack = "XSA",
  /**
   * Slab
   *
   * rec21
   */
  Slab = "XSB",
  /**
   * Crate, shallow
   *
   * rec21
   */
  CrateShallow = "XSC",
  /**
   * Spindle
   *
   * rec21
   */
  Spindle = "XSD",
  /**
   * Sea-chest
   *
   * rec21
   */
  SeaChest = "XSE",
  /**
   * Sachet
   *
   * rec21
   */
  Sachet = "XSH",
  /**
   * Skid
   *
   * rec21
   */
  Skid = "XSI",
  /**
   * Case, skeleton
   *
   * rec21
   */
  CaseSkeleton = "XSK",
  /**
   * Slipsheet
   *
   * rec21
   */
  Slipsheet = "XSL",
  /**
   * Sheetmetal
   *
   * rec21
   */
  Sheetmetal = "XSM",
  /**
   * Spool
   *
   * rec21
   */
  Spool = "XSO",
  /**
   * Sheet, plastic wrapping
   *
   * rec21
   */
  SheetPlasticWrapping = "XSP",
  /**
   * Case, steel
   *
   * rec21
   */
  CaseSteel = "XSS",
  /**
   * Sheet
   *
   * rec21
   */
  Sheet = "XST",
  /**
   * Suitcase
   *
   * rec21
   */
  Suitcase = "XSU",
  /**
   * Envelope, steel
   *
   * rec21
   */
  EnvelopeSteel = "XSV",
  /**
   * Shrinkwrapped
   *
   * rec21
   */
  Shrinkwrapped = "XSW",
  /**
   * Set
   *
   * Rec21
   */
  Set_Dup = "XSX",
  /**
   * Sleeve
   *
   * rec21
   */
  Sleeve = "XSY",
  /**
   * Sheets, in bundle/bunch/truss
   *
   * rec21
   */
  SheetsInBundleBunchTruss = "XSZ",
  /**
   * Tablet
   *
   * rec21
   */
  Tablet_Dup = "XT1",
  /**
   * Tub
   *
   * rec21
   */
  Tub = "XTB",
  /**
   * Tea-chest
   *
   * rec21
   */
  TeaChest = "XTC",
  /**
   * Tube, collapsible
   *
   * rec21
   */
  TubeCollapsible = "XTD",
  /**
   * Tyre
   *
   * rec21
   */
  Tyre_Dup = "XTE",
  /**
   * Tank container, generic
   *
   * rec21
   */
  TankContainerGeneric = "XTG",
  /**
   * Tierce
   *
   * rec21
   */
  Tierce = "XTI",
  /**
   * Tank, rectangular
   *
   * rec21
   */
  TankRectangular = "XTK",
  /**
   * Tub, with lid
   *
   * rec21
   */
  TubWithLid = "XTL",
  /**
   * Tin
   *
   * rec21
   */
  Tin = "XTN",
  /**
   * Tun
   *
   * rec21
   */
  Tun = "XTO",
  /**
   * Trunk
   *
   * rec21
   */
  Trunk = "XTR",
  /**
   * Truss
   *
   * rec21
   */
  Truss = "XTS",
  /**
   * Bag, tote
   *
   * rec21
   */
  BagTote = "XTT",
  /**
   * Tube
   *
   * rec21
   */
  Tube = "XTU",
  /**
   * Tube, with nozzle
   *
   * rec21
   */
  TubeWithNozzle = "XTV",
  /**
   * Pallet, triwall
   *
   * rec21
   */
  PalletTriwall = "XTW",
  /**
   * Tank, cylindrical
   *
   * rec21
   */
  TankCylindrical = "XTY",
  /**
   * Tubes, in bundle/bunch/truss
   *
   * rec21
   */
  TubesInBundleBunchTruss = "XTZ",
  /**
   * Uncaged
   *
   * rec21
   */
  Uncaged = "XUC",
  /**
   * Unit
   *
   * rec21
   */
  Unit = "XUN",
  /**
   * Vat
   *
   * rec21
   */
  Vat = "XVA",
  /**
   * Bulk, gas (at 1031 mbar and 15°C)
   *
   * rec21
   */
  BulkGasAt1031MbarAnd15C = "XVG",
  /**
   * Vial
   *
   * rec21
   */
  Vial = "XVI",
  /**
   * Vanpack
   *
   * rec21
   */
  Vanpack = "XVK",
  /**
   * Bulk, liquid
   *
   * rec21
   */
  BulkLiquid = "XVL",
  /**
   * Vehicle
   *
   * rec21
   */
  Vehicle = "XVN",
  /**
   * Bulk, solid, large particles (“nodules”)
   *
   * rec21
   */
  BulkSolidLargeParticlesNodules = "XVO",
  /**
   * Vacuum-packed
   *
   * rec21
   */
  VacuumPacked = "XVP",
  /**
   * Bulk, liquefied gas (at abnormal temperature/pressure)
   *
   * rec21
   */
  BulkLiquefiedGasAtAbnormalTemperaturePressure = "XVQ",
  /**
   * Bulk, solid, granular particles (“grains”)
   *
   * rec21
   */
  BulkSolidGranularParticlesGrains = "XVR",
  /**
   * Bulk, scrap metal
   *
   * rec21
   */
  BulkScrapMetal = "XVS",
  /**
   * Bulk, solid, fine particles (“powders”)
   *
   * rec21
   */
  BulkSolidFineParticlesPowders = "XVY",
  /**
   * Intermediate bulk container
   *
   * rec21
   */
  IntermediateBulkContainer = "XWA",
  /**
   * Wickerbottle
   *
   * rec21
   */
  Wickerbottle = "XWB",
  /**
   * Intermediate bulk container, steel
   *
   * rec21
   */
  IntermediateBulkContainerSteel = "XWC",
  /**
   * Intermediate bulk container, aluminium
   *
   * rec21
   */
  IntermediateBulkContainerAluminium = "XWD",
  /**
   * Intermediate bulk container, metal
   *
   * rec21
   */
  IntermediateBulkContainerMetal = "XWF",
  /**
   * Intermediate bulk container, steel, pressurised > 10 kpa
   *
   * rec21
   */
  IntermediateBulkContainerSteelPressurised10Kpa = "XWG",
  /**
   * Intermediate bulk container, aluminium, pressurised > 10 kpa
   *
   * rec21
   */
  IntermediateBulkContainerAluminiumPressurised10Kpa = "XWH",
  /**
   * Intermediate bulk container, metal, pressure 10 kpa
   *
   * rec21
   */
  IntermediateBulkContainerMetalPressure10Kpa = "XWJ",
  /**
   * Intermediate bulk container, steel, liquid
   *
   * rec21
   */
  IntermediateBulkContainerSteelLiquid = "XWK",
  /**
   * Intermediate bulk container, aluminium, liquid
   *
   * rec21
   */
  IntermediateBulkContainerAluminiumLiquid = "XWL",
  /**
   * Intermediate bulk container, metal, liquid
   *
   * rec21
   */
  IntermediateBulkContainerMetalLiquid = "XWM",
  /**
   * Intermediate bulk container, woven plastic, without coat/liner
   *
   * rec21
   */
  IntermediateBulkContainerWovenPlasticWithoutCoatLiner = "XWN",
  /**
   * Intermediate bulk container, woven plastic, coated
   *
   * rec21
   */
  IntermediateBulkContainerWovenPlasticCoated = "XWP",
  /**
   * Intermediate bulk container, woven plastic, with liner
   *
   * rec21
   */
  IntermediateBulkContainerWovenPlasticWithLiner = "XWQ",
  /**
   * Intermediate bulk container, woven plastic, coated and liner
   *
   * rec21
   */
  IntermediateBulkContainerWovenPlasticCoatedAndLiner = "XWR",
  /**
   * Intermediate bulk container, plastic film
   *
   * rec21
   */
  IntermediateBulkContainerPlasticFilm = "XWS",
  /**
   * Intermediate bulk container, textile with out coat/liner
   *
   * rec21
   */
  IntermediateBulkContainerTextileWithOutCoatLiner = "XWT",
  /**
   * Intermediate bulk container, natural wood, with inner liner
   *
   * rec21
   */
  IntermediateBulkContainerNaturalWoodWithInnerLiner = "XWU",
  /**
   * Intermediate bulk container, textile, coated
   *
   * rec21
   */
  IntermediateBulkContainerTextileCoated = "XWV",
  /**
   * Intermediate bulk container, textile, with liner
   *
   * rec21
   */
  IntermediateBulkContainerTextileWithLiner = "XWW",
  /**
   * Intermediate bulk container, textile, coated and liner
   *
   * rec21
   */
  IntermediateBulkContainerTextileCoatedAndLiner = "XWX",
  /**
   * Intermediate bulk container, plywood, with inner liner
   *
   * rec21
   */
  IntermediateBulkContainerPlywoodWithInnerLiner = "XWY",
  /**
   * Intermediate bulk container, reconstituted wood, with inner liner
   *
   * rec21
   */
  IntermediateBulkContainerReconstitutedWoodWithInnerLiner = "XWZ",
  /**
   * Bag, woven plastic, without inner coat/liner
   *
   * rec21
   */
  BagWovenPlasticWithoutInnerCoatLiner = "XXA",
  /**
   * Bag, woven plastic, sift proof
   *
   * rec21
   */
  BagWovenPlasticSiftProof = "XXB",
  /**
   * Bag, woven plastic, water resistant
   *
   * rec21
   */
  BagWovenPlasticWaterResistant = "XXC",
  /**
   * Bag, plastics film
   *
   * rec21
   */
  BagPlasticsFilm = "XXD",
  /**
   * Bag, textile, without inner coat/liner
   *
   * rec21
   */
  BagTextileWithoutInnerCoatLiner = "XXF",
  /**
   * Bag, textile, sift proof
   *
   * rec21
   */
  BagTextileSiftProof = "XXG",
  /**
   * Bag, textile, water resistant
   *
   * rec21
   */
  BagTextileWaterResistant = "XXH",
  /**
   * Bag, paper, multi-wall
   *
   * rec21
   */
  BagPaperMultiWall = "XXJ",
  /**
   * Bag, paper, multi-wall, water resistant
   *
   * rec21
   */
  BagPaperMultiWallWaterResistant = "XXK",
  /**
   * Composite packaging, plastic receptacle in steel drum
   *
   * rec21
   */
  CompositePackagingPlasticReceptacleInSteelDrum = "XYA",
  /**
   * Composite packaging, plastic receptacle in steel crate box
   *
   * rec21
   */
  CompositePackagingPlasticReceptacleInSteelCrateBox = "XYB",
  /**
   * Composite packaging, plastic receptacle in aluminium drum
   *
   * rec21
   */
  CompositePackagingPlasticReceptacleInAluminiumDrum = "XYC",
  /**
   * Composite packaging, plastic receptacle in aluminium crate
   *
   * rec21
   */
  CompositePackagingPlasticReceptacleInAluminiumCrate = "XYD",
  /**
   * Composite packaging, plastic receptacle in wooden box
   *
   * rec21
   */
  CompositePackagingPlasticReceptacleInWoodenBox = "XYF",
  /**
   * Composite packaging, plastic receptacle in plywood drum
   *
   * rec21
   */
  CompositePackagingPlasticReceptacleInPlywoodDrum = "XYG",
  /**
   * Composite packaging, plastic receptacle in plywood box
   *
   * rec21
   */
  CompositePackagingPlasticReceptacleInPlywoodBox = "XYH",
  /**
   * Composite packaging, plastic receptacle in fibre drum
   *
   * rec21
   */
  CompositePackagingPlasticReceptacleInFibreDrum = "XYJ",
  /**
   * Composite packaging, plastic receptacle in fibreboard box
   *
   * rec21
   */
  CompositePackagingPlasticReceptacleInFibreboardBox = "XYK",
  /**
   * Composite packaging, plastic receptacle in plastic drum
   *
   * rec21
   */
  CompositePackagingPlasticReceptacleInPlasticDrum = "XYL",
  /**
   * Composite packaging, plastic receptacle in solid plastic box
   *
   * rec21
   */
  CompositePackagingPlasticReceptacleInSolidPlasticBox = "XYM",
  /**
   * Composite packaging, glass receptacle in steel drum
   *
   * rec21
   */
  CompositePackagingGlassReceptacleInSteelDrum = "XYN",
  /**
   * Composite packaging, glass receptacle in steel crate box
   *
   * rec21
   */
  CompositePackagingGlassReceptacleInSteelCrateBox = "XYP",
  /**
   * Composite packaging, glass receptacle in aluminium drum
   *
   * rec21
   */
  CompositePackagingGlassReceptacleInAluminiumDrum = "XYQ",
  /**
   * Composite packaging, glass receptacle in aluminium crate
   *
   * rec21
   */
  CompositePackagingGlassReceptacleInAluminiumCrate = "XYR",
  /**
   * Composite packaging, glass receptacle in wooden box
   *
   * rec21
   */
  CompositePackagingGlassReceptacleInWoodenBox = "XYS",
  /**
   * Composite packaging, glass receptacle in plywood drum
   *
   * rec21
   */
  CompositePackagingGlassReceptacleInPlywoodDrum = "XYT",
  /**
   * Composite packaging, glass receptacle in wickerwork hamper
   *
   * rec21
   */
  CompositePackagingGlassReceptacleInWickerworkHamper = "XYV",
  /**
   * Composite packaging, glass receptacle in fibre drum
   *
   * rec21
   */
  CompositePackagingGlassReceptacleInFibreDrum = "XYW",
  /**
   * Composite packaging, glass receptacle in fibreboard box
   *
   * rec21
   */
  CompositePackagingGlassReceptacleInFibreboardBox = "XYX",
  /**
   * Composite packaging, glass receptacle in expandable plastic pack
   *
   * rec21
   */
  CompositePackagingGlassReceptacleInExpandablePlasticPack = "XYY",
  /**
   * Composite packaging, glass receptacle in solid plastic pack
   *
   * rec21
   */
  CompositePackagingGlassReceptacleInSolidPlasticPack = "XYZ",
  /**
   * Intermediate bulk container, paper, multi-wall
   *
   * rec21
   */
  IntermediateBulkContainerPaperMultiWall = "XZA",
  /**
   * Bag, large
   *
   * rec21
   */
  BagLarge = "XZB",
  /**
   * Intermediate bulk container, paper, multi-wall, water resistant
   *
   * rec21
   */
  IntermediateBulkContainerPaperMultiWallWaterResistant = "XZC",
  /**
   * Intermediate bulk container, rigid plastic, with structural equipment, solids
   *
   * rec21
   */
  IntermediateBulkContainerRigidPlasticWithStructuralEquipmentSolids = "XZD",
  /**
   * Intermediate bulk container, rigid plastic, freestanding, solids
   *
   * rec21
   */
  IntermediateBulkContainerRigidPlasticFreestandingSolids = "XZF",
  /**
   * Intermediate bulk container, rigid plastic, with structural equipment, pressurised
   *
   * rec21
   */
  IntermediateBulkContainerRigidPlasticWithStructuralEquipmentPressurised = "XZG",
  /**
   * Intermediate bulk container, rigid plastic, freestanding, pressurised
   *
   * rec21
   */
  IntermediateBulkContainerRigidPlasticFreestandingPressurised = "XZH",
  /**
   * Intermediate bulk container, rigid plastic, with structural equipment, liquids
   *
   * rec21
   */
  IntermediateBulkContainerRigidPlasticWithStructuralEquipmentLiquids = "XZJ",
  /**
   * Intermediate bulk container, rigid plastic, freestanding, liquids
   *
   * rec21
   */
  IntermediateBulkContainerRigidPlasticFreestandingLiquids = "XZK",
  /**
   * Intermediate bulk container, composite, rigid plastic, solids
   *
   * rec21
   */
  IntermediateBulkContainerCompositeRigidPlasticSolids = "XZL",
  /**
   * Intermediate bulk container, composite, flexible plastic, solids
   *
   * rec21
   */
  IntermediateBulkContainerCompositeFlexiblePlasticSolids = "XZM",
  /**
   * Intermediate bulk container, composite, rigid plastic, pressurised
   *
   * rec21
   */
  IntermediateBulkContainerCompositeRigidPlasticPressurised = "XZN",
  /**
   * Intermediate bulk container, composite, flexible plastic, pressurised
   *
   * rec21
   */
  IntermediateBulkContainerCompositeFlexiblePlasticPressurised = "XZP",
  /**
   * Intermediate bulk container, composite, rigid plastic, liquids
   *
   * rec21
   */
  IntermediateBulkContainerCompositeRigidPlasticLiquids = "XZQ",
  /**
   * Intermediate bulk container, composite, flexible plastic, liquids
   *
   * rec21
   */
  IntermediateBulkContainerCompositeFlexiblePlasticLiquids = "XZR",
  /**
   * Intermediate bulk container, composite
   *
   * rec21
   */
  IntermediateBulkContainerComposite = "XZS",
  /**
   * Intermediate bulk container, fibreboard
   *
   * rec21
   */
  IntermediateBulkContainerFibreboard = "XZT",
  /**
   * Intermediate bulk container, flexible
   *
   * rec21
   */
  IntermediateBulkContainerFlexible = "XZU",
  /**
   * Intermediate bulk container, metal, other than steel
   *
   * rec21
   */
  IntermediateBulkContainerMetalOtherThanSteel = "XZV",
  /**
   * Intermediate bulk container, natural wood
   *
   * rec21
   */
  IntermediateBulkContainerNaturalWood = "XZW",
  /**
   * Intermediate bulk container, plywood
   *
   * rec21
   */
  IntermediateBulkContainerPlywood = "XZX",
  /**
   * Intermediate bulk container, reconstituted wood
   *
   * rec21
   */
  IntermediateBulkContainerReconstitutedWood = "XZY",
  /**
   * Mutually defined
   *
   * rec21
   */
  MutuallyDefined_Dup = "XZZ",
}

export function description(value: Unit): string {
  switch (value) {
    case Unit.Group:
      return "group";
    case Unit.Outfit:
      return "outfit";
    case Unit.Ration:
      return "ration";
    case Unit.Shot:
      return "shot";
    case Unit.StickMilitary:
      return "stick, military";
    case Unit.TwentyFootContainer:
      return "twenty foot container";
    case Unit.FortyFootContainer:
      return "forty foot container";
    case Unit.DecilitrePerGram:
      return "decilitre per gram";
    case Unit.GramPerCubicCentimetre:
      return "gram per cubic centimetre";
    case Unit.TheoreticalPound:
      return "theoretical pound";
    case Unit.GramPerSquareCentimetre:
      return "gram per square centimetre";
    case Unit.TheoreticalTon:
      return "theoretical ton";
    case Unit.KilogramPerSquareMetre:
      return "kilogram per square metre";
    case Unit.KilopascalSquareMetrePerGram:
      return "kilopascal square metre per gram";
    case Unit.KilopascalPerMillimetre:
      return "kilopascal per millimetre";
    case Unit.MillilitrePerSquareCentimetreSecond:
      return "millilitre per square centimetre second";
    case Unit.OuncePerSquareFoot:
      return "ounce per square foot";
    case Unit.OuncePerSquareFootPer001inch:
      return "ounce per square foot per 0,01inch";
    case Unit.MillilitrePerSecond:
      return "millilitre per second";
    case Unit.MillilitrePerMinute:
      return "millilitre per minute";
    case Unit.Sitas:
      return "sitas";
    case Unit.Mesh:
      return "mesh";
    case Unit.NetKilogram:
      return "net kilogram";
    case Unit.PartPerMillion:
      return "part per million";
    case Unit.PercentWeight:
      return "percent weight";
    case Unit.PartPerBillionUs:
      return "part per billion (US)";
    case Unit.Millipascal:
      return "millipascal";
    case Unit.MilliInch:
      return "milli-inch";
    case Unit.PoundPerSquareInchAbsolute:
      return "pound per square inch absolute";
    case Unit.Henry:
      return "henry";
    case Unit.FootPoundForce:
      return "foot pound-force";
    case Unit.PoundPerCubicFoot:
      return "pound per cubic foot";
    case Unit.Poise:
      return "poise";
    case Unit.Stokes:
      return "stokes";
    case Unit.FixedRate:
      return "fixed rate";
    case Unit.RadianPerSecond:
      return "radian per second";
    case Unit.RadianPerSecondSquared:
      return "radian per second squared";
    case Unit.Roentgen:
      return "roentgen";
    case Unit.VoltAc:
      return "volt AC";
    case Unit.VoltDc:
      return "volt DC";
    case Unit.BritishThermalUnitInternationalTablePerHour:
      return "British thermal unit (international table) per hour";
    case Unit.CubicCentimetrePerSecond:
      return "cubic centimetre per second";
    case Unit.CubicFootPerHour:
      return "cubic foot per hour";
    case Unit.CubicFootPerMinute:
      return "cubic foot per minute";
    case Unit.CentimetrePerSecond:
      return "centimetre per second";
    case Unit.Decibel:
      return "decibel";
    case Unit.Kilobyte:
      return "kilobyte";
    case Unit.Kilobecquerel:
      return "kilobecquerel";
    case Unit.Kilocurie:
      return "kilocurie";
    case Unit.Megagram:
      return "megagram";
    case Unit.MetrePerMinute:
      return "metre per minute";
    case Unit.Milliroentgen:
      return "milliroentgen";
    case Unit.Millivolt:
      return "millivolt";
    case Unit.Megajoule:
      return "megajoule";
    case Unit.Manmonth:
      return "manmonth";
    case Unit.Centistokes:
      return "centistokes";
    case Unit.Microlitre:
      return "microlitre";
    case Unit.MicrometreMicron:
      return "micrometre (micron)";
    case Unit.Milliampere:
      return "milliampere";
    case Unit.Megabyte:
      return "megabyte";
    case Unit.MilligramPerHour:
      return "milligram per hour";
    case Unit.Megabecquerel:
      return "megabecquerel";
    case Unit.Microfarad:
      return "microfarad";
    case Unit.NewtonPerMetre:
      return "newton per metre";
    case Unit.OunceInch:
      return "ounce inch";
    case Unit.OunceFoot:
      return "ounce foot";
    case Unit.Picofarad:
      return "picofarad";
    case Unit.PoundPerHour:
      return "pound per hour";
    case Unit.TonUsPerHour:
      return "ton (US) per hour";
    case Unit.KilolitrePerHour:
      return "kilolitre per hour";
    case Unit.BarrelUsPerMinute:
      return "barrel (US) per minute";
    case Unit.Batch:
      return "batch";
    case Unit.MmscfDay:
      return "MMSCF/day";
    case Unit.HydraulicHorsePower:
      return "hydraulic horse power";
    case Unit.AmpereSquareMetrePerJouleSecond:
      return "ampere square metre per joule second";
    case Unit.Angstrom:
      return "angstrom";
    case Unit.AstronomicalUnit:
      return "astronomical unit";
    case Unit.Attojoule:
      return "attojoule";
    case Unit.Barn:
      return "barn";
    case Unit.BarnPerElectronvolt:
      return "barn per electronvolt";
    case Unit.BarnPerSteradianElectronvolt:
      return "barn per steradian electronvolt";
    case Unit.BarnPerSteradian:
      return "barn per steradian";
    case Unit.BecquerelPerKilogram:
      return "becquerel per kilogram";
    case Unit.BecquerelPerCubicMetre:
      return "becquerel per cubic metre";
    case Unit.AmperePerCentimetre:
      return "ampere per centimetre";
    case Unit.BritishThermalUnitInternationalTablePerSecondSquareFootDegreeRankine:
      return "British thermal unit (international table) per second square foot degree Rankine";
    case Unit.BritishThermalUnitInternationalTablePerPoundDegreeRankine:
      return "British thermal unit (international table) per pound degree Rankine";
    case Unit.BritishThermalUnitInternationalTablePerSecondFootDegreeRankine:
      return "British thermal unit (international table) per second foot degree Rankine";
    case Unit.BritishThermalUnitInternationalTablePerHourSquareFootDegreeRankine:
      return "British thermal unit (international table) per hour square foot degree Rankine";
    case Unit.CandelaPerSquareMetre:
      return "candela per square metre";
    case Unit.CoulombMetre:
      return "coulomb metre";
    case Unit.CoulombMetreSquaredPerVolt:
      return "coulomb metre squared per volt";
    case Unit.CoulombPerCubicCentimetre:
      return "coulomb per cubic centimetre";
    case Unit.CoulombPerCubicMetre:
      return "coulomb per cubic metre";
    case Unit.AmperePerMillimetre:
      return "ampere per millimetre";
    case Unit.CoulombPerCubicMillimetre:
      return "coulomb per cubic millimetre";
    case Unit.CoulombPerKilogramSecond:
      return "coulomb per kilogram second";
    case Unit.CoulombPerMole:
      return "coulomb per mole";
    case Unit.CoulombPerSquareCentimetre:
      return "coulomb per square centimetre";
    case Unit.CoulombPerSquareMetre:
      return "coulomb per square metre";
    case Unit.CoulombPerSquareMillimetre:
      return "coulomb per square millimetre";
    case Unit.CubicCentimetrePerMole:
      return "cubic centimetre per mole";
    case Unit.CubicDecimetrePerMole:
      return "cubic decimetre per mole";
    case Unit.CubicMetrePerCoulomb:
      return "cubic metre per coulomb";
    case Unit.CubicMetrePerKilogram:
      return "cubic metre per kilogram";
    case Unit.AmperePerSquareCentimetre:
      return "ampere per square centimetre";
    case Unit.CubicMetrePerMole:
      return "cubic metre per mole";
    case Unit.AmperePerSquareMetre:
      return "ampere per square metre";
    case Unit.CuriePerKilogram:
      return "curie per kilogram";
    case Unit.DeadweightTonnage:
      return "deadweight tonnage";
    case Unit.Decalitre:
      return "decalitre";
    case Unit.Decametre:
      return "decametre";
    case Unit.Decitex:
      return "decitex";
    case Unit.DegreeRankine:
      return "degree Rankine";
    case Unit.Denier:
      return "denier";
    case Unit.AmpereSquareMetre:
      return "ampere square metre";
    case Unit.Electronvolt:
      return "electronvolt";
    case Unit.ElectronvoltPerMetre:
      return "electronvolt per metre";
    case Unit.ElectronvoltSquareMetre:
      return "electronvolt square metre";
    case Unit.ElectronvoltSquareMetrePerKilogram:
      return "electronvolt square metre per kilogram";
    case Unit._8PartCloudCover:
      return "8-part cloud cover";
    case Unit.AmperePerSquareMetreKelvinSquared:
      return "ampere per square metre kelvin squared";
    case Unit.Exajoule:
      return "exajoule";
    case Unit.FaradPerMetre:
      return "farad per metre";
    case Unit.AmperePerSquareMillimetre:
      return "ampere per square millimetre";
    case Unit.Femtojoule:
      return "femtojoule";
    case Unit.Femtometre:
      return "femtometre";
    case Unit.FootPerSecondSquared:
      return "foot per second squared";
    case Unit.FootPoundForcePerSecond:
      return "foot pound-force per second";
    case Unit.FreightTon:
      return "freight ton";
    case Unit.Gal:
      return "gal";
    case Unit.AmpereSecond:
      return "ampere second";
    case Unit.GigacoulombPerCubicMetre:
      return "gigacoulomb per cubic metre";
    case Unit.Gigaelectronvolt:
      return "gigaelectronvolt";
    case Unit.Gigahertz:
      return "gigahertz";
    case Unit.Gigaohm:
      return "gigaohm";
    case Unit.GigaohmMetre:
      return "gigaohm metre";
    case Unit.Gigapascal:
      return "gigapascal";
    case Unit.Rate:
      return "rate";
    case Unit.Gigawatt:
      return "gigawatt";
    case Unit.Gon:
      return "gon";
    case Unit.GramPerCubicMetre:
      return "gram per cubic metre";
    case Unit.GramPerMole:
      return "gram per mole";
    case Unit.Gray:
      return "gray";
    case Unit.GrayPerSecond:
      return "gray per second";
    case Unit.Hectopascal:
      return "hectopascal";
    case Unit.HenryPerMetre:
      return "henry per metre";
    case Unit.Bit:
      return "bit";
    case Unit.Ball:
      return "ball";
    case Unit.BulkPack:
      return "bulk pack";
    case Unit.Acre:
      return "acre";
    case Unit.Activity:
      return "activity";
    case Unit.Byte:
      return "byte";
    case Unit.AmperePerMetre:
      return "ampere per metre";
    case Unit.AdditionalMinute:
      return "additional minute";
    case Unit.AverageMinutePerCall:
      return "average minute per call";
    case Unit.Fathom:
      return "fathom";
    case Unit.AccessLine:
      return "access line";
    case Unit.AmpereHour:
      return "ampere hour";
    case Unit.Ampere:
      return "ampere";
    case Unit.Year:
      return "year";
    case Unit.TroyOunceOrApothecaryOunce:
      return "troy ounce or apothecary ounce";
    case Unit.AntiHemophilicFactorAhfUnit:
      return "anti-hemophilic factor (AHF) unit";
    case Unit.Assortment:
      return "assortment";
    case Unit.AlcoholicStrengthByMass:
      return "alcoholic strength by mass";
    case Unit.AlcoholicStrengthByVolume:
      return "alcoholic strength by volume";
    case Unit.StandardAtmosphere:
      return "standard atmosphere";
    case Unit.AmericanWireGauge:
      return "american wire gauge";
    case Unit.Assembly:
      return "assembly";
    case Unit.BritishThermalUnitInternationalTablePerPound:
      return "British thermal unit (international table) per pound";
    case Unit.BarrelUsPerDay:
      return "barrel (US) per day";
    case Unit.BitPerSecond:
      return "bit per second";
    case Unit.JoulePerKilogramKelvin:
      return "joule per kilogram kelvin";
    case Unit.JoulePerMetre:
      return "joule per metre";
    case Unit.JoulePerSquareMetre:
      return "joule per square metre";
    case Unit.JoulePerMetreToFourthPower:
      return "joule per metre to the fourth power";
    case Unit.JoulePerMole:
      return "joule per mole";
    case Unit.JoulePerMoleKelvin:
      return "joule per mole kelvin";
    case Unit.Credit:
      return "credit";
    case Unit.JouleSecond:
      return "joule second";
    case Unit.Digit:
      return "digit";
    case Unit.JouleSquareMetrePerKilogram:
      return "joule square metre per kilogram";
    case Unit.KelvinPerWatt:
      return "kelvin per watt";
    case Unit.Kiloampere:
      return "kiloampere";
    case Unit.KiloamperePerSquareMetre:
      return "kiloampere per square metre";
    case Unit.KiloamperePerMetre:
      return "kiloampere per metre";
    case Unit.KilobecquerelPerKilogram:
      return "kilobecquerel per kilogram";
    case Unit.Kilocoulomb:
      return "kilocoulomb";
    case Unit.KilocoulombPerCubicMetre:
      return "kilocoulomb per cubic metre";
    case Unit.KilocoulombPerSquareMetre:
      return "kilocoulomb per square metre";
    case Unit.Kiloelectronvolt:
      return "kiloelectronvolt";
    case Unit.BattingPound:
      return "batting pound";
    case Unit.Gibibit:
      return "gibibit";
    case Unit.KilogramMetrePerSecond:
      return "kilogram metre per second";
    case Unit.KilogramMetreSquared:
      return "kilogram metre squared";
    case Unit.KilogramMetreSquaredPerSecond:
      return "kilogram metre squared per second";
    case Unit.KilogramPerCubicDecimetre:
      return "kilogram per cubic decimetre";
    case Unit.KilogramPerLitre:
      return "kilogram per litre";
    case Unit.BarrelImperial:
      return "barrel, imperial";
    case Unit.KilojoulePerKelvin:
      return "kilojoule per kelvin";
    case Unit.KilojoulePerKilogram:
      return "kilojoule per kilogram";
    case Unit.KilojoulePerKilogramKelvin:
      return "kilojoule per kilogram kelvin";
    case Unit.KilojoulePerMole:
      return "kilojoule per mole";
    case Unit.Kilomole:
      return "kilomole";
    case Unit.KilomolePerCubicMetre:
      return "kilomole per cubic metre";
    case Unit.Kilonewton:
      return "kilonewton";
    case Unit.KilonewtonMetre:
      return "kilonewton metre";
    case Unit.Kiloohm:
      return "kiloohm";
    case Unit.KiloohmMetre:
      return "kiloohm metre";
    case Unit.Kilosecond:
      return "kilosecond";
    case Unit.Kilosiemens:
      return "kilosiemens";
    case Unit.KilosiemensPerMetre:
      return "kilosiemens per metre";
    case Unit.KilovoltPerMetre:
      return "kilovolt per metre";
    case Unit.KiloweberPerMetre:
      return "kiloweber per metre";
    case Unit.LightYear:
      return "light year";
    case Unit.LitrePerMole:
      return "litre per mole";
    case Unit.LumenHour:
      return "lumen hour";
    case Unit.LumenPerSquareMetre:
      return "lumen per square metre";
    case Unit.LumenPerWatt:
      return "lumen per watt";
    case Unit.LumenSecond:
      return "lumen second";
    case Unit.LuxHour:
      return "lux hour";
    case Unit.LuxSecond:
      return "lux second";
    case Unit.MegaamperePerSquareMetre:
      return "megaampere per square metre";
    case Unit.MegabecquerelPerKilogram:
      return "megabecquerel per kilogram";
    case Unit.Gigabit:
      return "gigabit";
    case Unit.MegacoulombPerCubicMetre:
      return "megacoulomb per cubic metre";
    case Unit.Cycle:
      return "cycle";
    case Unit.MegacoulombPerSquareMetre:
      return "megacoulomb per square metre";
    case Unit.Megaelectronvolt:
      return "megaelectronvolt";
    case Unit.MegagramPerCubicMetre:
      return "megagram per cubic metre";
    case Unit.Meganewton:
      return "meganewton";
    case Unit.MeganewtonMetre:
      return "meganewton metre";
    case Unit.Megaohm:
      return "megaohm";
    case Unit.MegaohmMetre:
      return "megaohm metre";
    case Unit.MegasiemensPerMetre:
      return "megasiemens per metre";
    case Unit.Megavolt:
      return "megavolt";
    case Unit.MegavoltPerMetre:
      return "megavolt per metre";
    case Unit.JoulePerCubicMetre:
      return "joule per cubic metre";
    case Unit.GigabitPerSecond:
      return "gigabit per second";
    case Unit.ReciprocalMetreSquaredReciprocalSecond:
      return "reciprocal metre squared reciprocal second";
    case Unit.InchPerLinearFoot:
      return "inch per linear foot";
    case Unit.MetreToFourthPower:
      return "metre to the fourth power";
    case Unit.Microampere:
      return "microampere";
    case Unit.Microbar:
      return "microbar";
    case Unit.Microcoulomb:
      return "microcoulomb";
    case Unit.MicrocoulombPerCubicMetre:
      return "microcoulomb per cubic metre";
    case Unit.MicrocoulombPerSquareMetre:
      return "microcoulomb per square metre";
    case Unit.MicrofaradPerMetre:
      return "microfarad per metre";
    case Unit.Microhenry:
      return "microhenry";
    case Unit.MicrohenryPerMetre:
      return "microhenry per metre";
    case Unit.Micronewton:
      return "micronewton";
    case Unit.MicronewtonMetre:
      return "micronewton metre";
    case Unit.Microohm:
      return "microohm";
    case Unit.MicroohmMetre:
      return "microohm metre";
    case Unit.Micropascal:
      return "micropascal";
    case Unit.Microradian:
      return "microradian";
    case Unit.Microsecond:
      return "microsecond";
    case Unit.Microsiemens:
      return "microsiemens";
    case Unit.BarUnitPressure:
      return "bar [unit of pressure]";
    case Unit.BaseBox:
      return "base box";
    case Unit.BoardFoot:
      return "board foot";
    case Unit.BrakeHorsePower:
      return "brake horse power";
    case Unit.BillionEur:
      return "billion (EUR)";
    case Unit.DryBarrelUs:
      return "dry barrel (US)";
    case Unit.BarrelUs:
      return "barrel (US)";
    case Unit.HundredBoardFoot:
      return "hundred board foot";
    case Unit.BeatsPerMinute:
      return "beats per minute";
    case Unit.Becquerel:
      return "becquerel";
    case Unit.BritishThermalUnitInternationalTable:
      return "British thermal unit (international table)";
    case Unit.BushelUs:
      return "bushel (US)";
    case Unit.BushelUk:
      return "bushel (UK)";
    case Unit.Call:
      return "call";
    case Unit.Millifarad:
      return "millifarad";
    case Unit.Milligal:
      return "milligal";
    case Unit.MilligramPerMetre:
      return "milligram per metre";
    case Unit.Milligray:
      return "milligray";
    case Unit.Millihenry:
      return "millihenry";
    case Unit.Millijoule:
      return "millijoule";
    case Unit.MillimetrePerSecond:
      return "millimetre per second";
    case Unit.MillimetreSquaredPerSecond:
      return "millimetre squared per second";
    case Unit.Millimole:
      return "millimole";
    case Unit.MolePerKilogram:
      return "mole per kilogram";
    case Unit.Millinewton:
      return "millinewton";
    case Unit.Kibibit:
      return "kibibit";
    case Unit.MillinewtonPerMetre:
      return "millinewton per metre";
    case Unit.MilliohmMetre:
      return "milliohm metre";
    case Unit.MillipascalSecond:
      return "millipascal second";
    case Unit.Milliradian:
      return "milliradian";
    case Unit.Millisecond:
      return "millisecond";
    case Unit.Millisiemens:
      return "millisiemens";
    case Unit.Millisievert:
      return "millisievert";
    case Unit.Millitesla:
      return "millitesla";
    case Unit.MicrovoltPerMetre:
      return "microvolt per metre";
    case Unit.MillivoltPerMetre:
      return "millivolt per metre";
    case Unit.Milliwatt:
      return "milliwatt";
    case Unit.MilliwattPerSquareMetre:
      return "milliwatt per square metre";
    case Unit.Milliweber:
      return "milliweber";
    case Unit.Mole:
      return "mole";
    case Unit.MolePerCubicDecimetre:
      return "mole per cubic decimetre";
    case Unit.MolePerCubicMetre:
      return "mole per cubic metre";
    case Unit.Kilobit:
      return "kilobit";
    case Unit.MolePerLitre:
      return "mole per litre";
    case Unit.Nanoampere:
      return "nanoampere";
    case Unit.Nanocoulomb:
      return "nanocoulomb";
    case Unit.Nanofarad:
      return "nanofarad";
    case Unit.NanofaradPerMetre:
      return "nanofarad per metre";
    case Unit.Nanohenry:
      return "nanohenry";
    case Unit.NanohenryPerMetre:
      return "nanohenry per metre";
    case Unit.Nanometre:
      return "nanometre";
    case Unit.NanoohmMetre:
      return "nanoohm metre";
    case Unit.Nanosecond:
      return "nanosecond";
    case Unit.Nanotesla:
      return "nanotesla";
    case Unit.Nanowatt:
      return "nanowatt";
    case Unit.Neper:
      return "neper";
    case Unit.NeperPerSecond:
      return "neper per second";
    case Unit.Picometre:
      return "picometre";
    case Unit.NewtonMetreSecond:
      return "newton metre second";
    case Unit.NewtonMetreSquaredPerKilogramSquared:
      return "newton metre squared per kilogram squared";
    case Unit.NewtonPerSquareMetre:
      return "newton per square metre";
    case Unit.NewtonPerSquareMillimetre:
      return "newton per square millimetre";
    case Unit.NewtonSecond:
      return "newton second";
    case Unit.NewtonSecondPerMetre:
      return "newton second per metre";
    case Unit.Octave:
      return "octave";
    case Unit.OhmCentimetre:
      return "ohm centimetre";
    case Unit.OhmMetre:
      return "ohm metre";
    case Unit.One:
      return "one";
    case Unit.Parsec:
      return "parsec";
    case Unit.PascalPerKelvin:
      return "pascal per kelvin";
    case Unit.PascalSecond:
      return "pascal second";
    case Unit.PascalSecondPerCubicMetre:
      return "pascal second per cubic metre";
    case Unit.PascalSecondPerMetre:
      return "pascal second per metre";
    case Unit.Petajoule:
      return "petajoule";
    case Unit.Phon:
      return "phon";
    case Unit.Centipoise:
      return "centipoise";
    case Unit.Picoampere:
      return "picoampere";
    case Unit.Picocoulomb:
      return "picocoulomb";
    case Unit.PicofaradPerMetre:
      return "picofarad per metre";
    case Unit.Picohenry:
      return "picohenry";
    case Unit.KilobitPerSecond:
      return "kilobit per second";
    case Unit.Picowatt:
      return "picowatt";
    case Unit.PicowattPerSquareMetre:
      return "picowatt per square metre";
    case Unit.PoundForce:
      return "pound-force";
    case Unit.KilovoltAmpereHour:
      return "kilovolt ampere hour";
    case Unit.MillicoulombPerKilogram:
      return "millicoulomb per kilogram";
    case Unit.Rad:
      return "rad";
    case Unit.Radian:
      return "radian";
    case Unit.RadianSquareMetrePerMole:
      return "radian square metre per mole";
    case Unit.RadianSquareMetrePerKilogram:
      return "radian square metre per kilogram";
    case Unit.RadianPerMetre:
      return "radian per metre";
    case Unit.ReciprocalAngstrom:
      return "reciprocal angstrom";
    case Unit.ReciprocalCubicMetre:
      return "reciprocal cubic metre";
    case Unit.ReciprocalCubicMetrePerSecond:
      return "reciprocal cubic metre per second";
    case Unit.ReciprocalElectronVoltPerCubicMetre:
      return "reciprocal electron volt per cubic metre";
    case Unit.ReciprocalHenry:
      return "reciprocal henry";
    case Unit.CoilGroup:
      return "coil group";
    case Unit.ReciprocalJoulePerCubicMetre:
      return "reciprocal joule per cubic metre";
    case Unit.ReciprocalKelvinOrKelvinToPowerMinusOne:
      return "reciprocal kelvin or kelvin to the power minus one";
    case Unit.ReciprocalMetre:
      return "reciprocal metre";
    case Unit.ReciprocalSquareMetre:
      return "reciprocal square metre";
    case Unit.ReciprocalMinute:
      return "reciprocal minute";
    case Unit.ReciprocalMole:
      return "reciprocal mole";
    case Unit.ReciprocalPascalOrPascalToPowerMinusOne:
      return "reciprocal pascal or pascal to the power minus one";
    case Unit.ReciprocalSecond:
      return "reciprocal second";
    case Unit.ReciprocalSecondPerMetreSquared:
      return "reciprocal second per metre squared";
    case Unit.CarryingCapacityInMetricTon:
      return "carrying capacity in metric ton";
    case Unit.Candela:
      return "candela";
    case Unit.DegreeCelsius:
      return "degree Celsius";
    case Unit.Hundred:
      return "hundred";
    case Unit.Card:
      return "card";
    case Unit.Centigram:
      return "centigram";
    case Unit.CoulombPerKilogram:
      return "coulomb per kilogram";
    case Unit.HundredLeave:
      return "hundred leave";
    case Unit.Centilitre:
      return "centilitre";
    case Unit.SquareCentimetre:
      return "square centimetre";
    case Unit.CubicCentimetre:
      return "cubic centimetre";
    case Unit.Centimetre:
      return "centimetre";
    case Unit.HundredPack:
      return "hundred pack";
    case Unit.CentalUk:
      return "cental (UK)";
    case Unit.Coulomb:
      return "coulomb";
    case Unit.ContentGram:
      return "content gram";
    case Unit.MetricCarat:
      return "metric carat";
    case Unit.ContentTonMetric:
      return "content ton (metric)";
    case Unit.Curie:
      return "curie";
    case Unit.HundredPoundCwtHundredWeightUs:
      return "hundred pound (cwt) / hundred weight (US)";
    case Unit.HundredWeightUk:
      return "hundred weight (UK)";
    case Unit.KilowattHourPerHour:
      return "kilowatt hour per hour";
    case Unit.LotUnitWeight:
      return "lot [unit of weight]";
    case Unit.ReciprocalSecondPerSteradian:
      return "reciprocal second per steradian";
    case Unit.SiemensPerMetre:
      return "siemens per metre";
    case Unit.Mebibit:
      return "mebibit";
    case Unit.SiemensSquareMetrePerMole:
      return "siemens square metre per mole";
    case Unit.Sievert:
      return "sievert";
    case Unit.Sone:
      return "sone";
    case Unit.SquareCentimetrePerErg:
      return "square centimetre per erg";
    case Unit.SquareCentimetrePerSteradianErg:
      return "square centimetre per steradian erg";
    case Unit.MetreKelvin:
      return "metre kelvin";
    case Unit.SquareMetreKelvinPerWatt:
      return "square metre kelvin per watt";
    case Unit.ReciprocalSecondPerSteradianMetreSquared:
      return "reciprocal second per steradian metre squared";
    case Unit.SquareMetrePerJoule:
      return "square metre per joule";
    case Unit.SquareMetrePerKilogram:
      return "square metre per kilogram";
    case Unit.SquareMetrePerMole:
      return "square metre per mole";
    case Unit.PenGramProtein:
      return "pen gram (protein)";
    case Unit.SquareMetrePerSteradian:
      return "square metre per steradian";
    case Unit.SquareMetrePerSteradianJoule:
      return "square metre per steradian joule";
    case Unit.SquareMetrePerVoltSecond:
      return "square metre per volt second";
    case Unit.Steradian:
      return "steradian";
    case Unit.Terahertz:
      return "terahertz";
    case Unit.Terajoule:
      return "terajoule";
    case Unit.Terawatt:
      return "terawatt";
    case Unit.TerawattHour:
      return "terawatt hour";
    case Unit.Tesla:
      return "tesla";
    case Unit.Tex:
      return "tex";
    case Unit.Megabit:
      return "megabit";
    case Unit.TonnePerCubicMetre:
      return "tonne per cubic metre";
    case Unit.TropicalYear:
      return "tropical year";
    case Unit.UnifiedAtomicMassUnit:
      return "unified atomic mass unit";
    case Unit.Var:
      return "var";
    case Unit.VoltSquaredPerKelvinSquared:
      return "volt squared per kelvin squared";
    case Unit.VoltAmpere:
      return "volt - ampere";
    case Unit.VoltPerCentimetre:
      return "volt per centimetre";
    case Unit.VoltPerKelvin:
      return "volt per kelvin";
    case Unit.MillivoltPerKelvin:
      return "millivolt per kelvin";
    case Unit.KilogramPerSquareCentimetre:
      return "kilogram per square centimetre";
    case Unit.VoltPerMetre:
      return "volt per metre";
    case Unit.VoltPerMillimetre:
      return "volt per millimetre";
    case Unit.WattPerKelvin:
      return "watt per kelvin";
    case Unit.WattPerMetreKelvin:
      return "watt per metre kelvin";
    case Unit.WattPerSquareMetre:
      return "watt per square metre";
    case Unit.WattPerSquareMetreKelvin:
      return "watt per square metre kelvin";
    case Unit.WattPerSquareMetreKelvinToFourthPower:
      return "watt per square metre kelvin to the fourth power";
    case Unit.WattPerSteradian:
      return "watt per steradian";
    case Unit.WattPerSteradianSquareMetre:
      return "watt per steradian square metre";
    case Unit.WeberPerMetre:
      return "weber per metre";
    case Unit.RoentgenPerSecond:
      return "roentgen per second";
    case Unit.WeberPerMillimetre:
      return "weber per millimetre";
    case Unit.MinuteUnitAngle:
      return "minute [unit of angle]";
    case Unit.SecondUnitAngle:
      return "second [unit of angle]";
    case Unit.Book:
      return "book";
    case Unit.Round:
      return "round";
    case Unit.NumberWords:
      return "number of words";
    case Unit.InchToFourthPower:
      return "inch to the fourth power";
    case Unit.JouleSquareMetre:
      return "joule square metre";
    case Unit.KilogramPerMole:
      return "kilogram per mole";
    case Unit.Megacoulomb:
      return "megacoulomb";
    case Unit.MegajoulePerSecond:
      return "megajoule per second";
    case Unit.Microwatt:
      return "microwatt";
    case Unit.Microtesla:
      return "microtesla";
    case Unit.Microvolt:
      return "microvolt";
    case Unit.MillinewtonMetre:
      return "millinewton metre";
    case Unit.MicrowattPerSquareMetre:
      return "microwatt per square metre";
    case Unit.Millicoulomb:
      return "millicoulomb";
    case Unit.MillimolePerKilogram:
      return "millimole per kilogram";
    case Unit.MillicoulombPerCubicMetre:
      return "millicoulomb per cubic metre";
    case Unit.MillicoulombPerSquareMetre:
      return "millicoulomb per square metre";
    case Unit.Rem:
      return "rem";
    case Unit.SecondPerCubicMetre:
      return "second per cubic metre";
    case Unit.SecondPerCubicMetreRadian:
      return "second per cubic metre radian";
    case Unit.JoulePerGram:
      return "joule per gram";
    case Unit.Decare:
      return "decare";
    case Unit.TenDay:
      return "ten day";
    case Unit.Day:
      return "day";
    case Unit.DryPound:
      return "dry pound";
    case Unit.DecibelMilliwatts:
      return "Decibel-milliwatts";
    case Unit.DecibelWatt:
      return "Decibel watt";
    case Unit.DegreeUnitAngle:
      return "degree [unit of angle]";
    case Unit.Decade:
      return "decade";
    case Unit.Decigram:
      return "decigram";
    case Unit.Decagram:
      return "decagram";
    case Unit.Decilitre:
      return "decilitre";
    case Unit.CubicDecametre:
      return "cubic decametre";
    case Unit.SquareDecimetre:
      return "square decimetre";
    case Unit.StandardKilolitre:
      return "standard kilolitre";
    case Unit.CubicDecimetre:
      return "cubic decimetre";
    case Unit.Decimetre:
      return "decimetre";
    case Unit.DecinewtonMetre:
      return "decinewton metre";
    case Unit.DozenPiece:
      return "dozen piece";
    case Unit.DozenPair:
      return "dozen pair";
    case Unit.DisplacementTonnage:
      return "displacement tonnage";
    case Unit.DramUs:
      return "dram (US)";
    case Unit.DramUk:
      return "dram (UK)";
    case Unit.DozenRoll:
      return "dozen roll";
    case Unit.DryTon:
      return "dry ton";
    case Unit.Decitonne:
      return "decitonne";
    case Unit.Pennyweight:
      return "pennyweight";
    case Unit.Dozen:
      return "dozen";
    case Unit.DozenPack:
      return "dozen pack";
    case Unit.NewtonPerSquareCentimetre:
      return "newton per square centimetre";
    case Unit.MegawattHourPerHour:
      return "megawatt hour per hour";
    case Unit.MegawattPerHertz:
      return "megawatt per hertz";
    case Unit.MilliampereHour:
      return "milliampere hour";
    case Unit.DegreeDay:
      return "degree day";
    case Unit.Mille:
      return "mille";
    case Unit.KilocalorieInternationalTable:
      return "kilocalorie (international table)";
    case Unit.KilocalorieThermochemicalPerHour:
      return "kilocalorie (thermochemical) per hour";
    case Unit.MillionBtuItPerHour:
      return "million Btu(IT) per hour";
    case Unit.CubicFootPerSecond:
      return "cubic foot per second";
    case Unit.TonnePerHour:
      return "tonne per hour";
    case Unit.Ping:
      return "ping";
    case Unit.MegabitPerSecond:
      return "megabit per second";
    case Unit.Shares:
      return "shares";
    case Unit.Teu:
      return "TEU";
    case Unit.Tyre:
      return "tyre";
    case Unit.ActiveUnit:
      return "active unit";
    case Unit.Dose:
      return "dose";
    case Unit.AirDryTon:
      return "air dry ton";
    case Unit.Strand:
      return "strand";
    case Unit.SquareMetrePerLitre:
      return "square metre per litre";
    case Unit.LitrePerHour:
      return "litre per hour";
    case Unit.FootPerThousand:
      return "foot per thousand";
    case Unit.Gigabyte:
      return "gigabyte";
    case Unit.Terabyte:
      return "terabyte";
    case Unit.Petabyte:
      return "petabyte";
    case Unit.Pixel:
      return "pixel";
    case Unit.Megapixel:
      return "megapixel";
    case Unit.DotsPerInch:
      return "dots per inch";
    case Unit.GrossKilogram:
      return "gross kilogram";
    case Unit.PartPerHundredThousand:
      return "part per hundred thousand";
    case Unit.KilogramForcePerSquareMillimetre:
      return "kilogram-force per square millimetre";
    case Unit.KilogramForcePerSquareCentimetre:
      return "kilogram-force per square centimetre";
    case Unit.JoulePerSquareCentimetre:
      return "joule per square centimetre";
    case Unit.KilogramForceMetrePerSquareCentimetre:
      return "kilogram-force metre per square centimetre";
    case Unit.Milliohm:
      return "milliohm";
    case Unit.KilowattHourPerCubicMetre:
      return "kilowatt hour per cubic metre";
    case Unit.KilowattHourPerKelvin:
      return "kilowatt hour per kelvin";
    case Unit.ServiceUnit:
      return "service unit";
    case Unit.WorkingDay:
      return "working day";
    case Unit.AccountingUnit:
      return "accounting unit";
    case Unit.Job:
      return "job";
    case Unit.RunFoot:
      return "run foot";
    case Unit.Test:
      return "test";
    case Unit.Trip:
      return "trip";
    case Unit.Use:
      return "use";
    case Unit.Well:
      return "well";
    case Unit.Zone:
      return "zone";
    case Unit.ExabitPerSecond:
      return "exabit per second";
    case Unit.Exbibyte:
      return "exbibyte";
    case Unit.Pebibyte:
      return "pebibyte";
    case Unit.Tebibyte:
      return "tebibyte";
    case Unit.Gibibyte:
      return "gibibyte";
    case Unit.Mebibyte:
      return "mebibyte";
    case Unit.Kibibyte:
      return "kibibyte";
    case Unit.ExbibitPerMetre:
      return "exbibit per metre";
    case Unit.ExbibitPerSquareMetre:
      return "exbibit per square metre";
    case Unit.ExbibitPerCubicMetre:
      return "exbibit per cubic metre";
    case Unit.GigabytePerSecond:
      return "gigabyte per second";
    case Unit.GibibitPerMetre:
      return "gibibit per metre";
    case Unit.GibibitPerSquareMetre:
      return "gibibit per square metre";
    case Unit.GibibitPerCubicMetre:
      return "gibibit per cubic metre";
    case Unit.KibibitPerMetre:
      return "kibibit per metre";
    case Unit.KibibitPerSquareMetre:
      return "kibibit per square metre";
    case Unit.KibibitPerCubicMetre:
      return "kibibit per cubic metre";
    case Unit.MebibitPerMetre:
      return "mebibit per metre";
    case Unit.MebibitPerSquareMetre:
      return "mebibit per square metre";
    case Unit.MebibitPerCubicMetre:
      return "mebibit per cubic metre";
    case Unit.Petabit:
      return "petabit";
    case Unit.PetabitPerSecond:
      return "petabit per second";
    case Unit.PebibitPerMetre:
      return "pebibit per metre";
    case Unit.PebibitPerSquareMetre:
      return "pebibit per square metre";
    case Unit.PebibitPerCubicMetre:
      return "pebibit per cubic metre";
    case Unit.Terabit:
      return "terabit";
    case Unit.TerabitPerSecond:
      return "terabit per second";
    case Unit.TebibitPerMetre:
      return "tebibit per metre";
    case Unit.TebibitPerCubicMetre:
      return "tebibit per cubic metre";
    case Unit.TebibitPerSquareMetre:
      return "tebibit per square metre";
    case Unit.BitPerMetre:
      return "bit per metre";
    case Unit.BitPerSquareMetre:
      return "bit per square metre";
    case Unit.ReciprocalCentimetre:
      return "reciprocal centimetre";
    case Unit.ReciprocalDay:
      return "reciprocal day";
    case Unit.CubicDecimetrePerHour:
      return "cubic decimetre per hour";
    case Unit.KilogramPerHour:
      return "kilogram per hour";
    case Unit.KilomolePerSecond:
      return "kilomole per second";
    case Unit.MolePerSecond:
      return "mole per second";
    case Unit.DegreePerSecond:
      return "degree per second";
    case Unit.MillimetrePerDegreeCelciusMetre:
      return "millimetre per degree Celcius metre";
    case Unit.DegreeCelsiusPerKelvin:
      return "degree Celsius per kelvin";
    case Unit.HectopascalPerBar:
      return "hectopascal per bar";
    case Unit.Each:
      return "each";
    case Unit.ElectronicMailBox:
      return "electronic mail box";
    case Unit.EquivalentGallon:
      return "equivalent gallon";
    case Unit.BitPerCubicMetre:
      return "bit per cubic metre";
    case Unit.KelvinPerKelvin:
      return "kelvin per kelvin";
    case Unit.KilopascalPerBar:
      return "kilopascal per bar";
    case Unit.MillibarPerBar:
      return "millibar per bar";
    case Unit.MegapascalPerBar:
      return "megapascal per bar";
    case Unit.PoisePerBar:
      return "poise per bar";
    case Unit.PascalPerBar:
      return "pascal per bar";
    case Unit.MilliamperePerInch:
      return "milliampere per inch";
    case Unit.KelvinPerHour:
      return "kelvin per hour";
    case Unit.KelvinPerMinute:
      return "kelvin per minute";
    case Unit.KelvinPerSecond:
      return "kelvin per second";
    case Unit.Slug:
      return "slug";
    case Unit.GramPerKelvin:
      return "gram per kelvin";
    case Unit.KilogramPerKelvin:
      return "kilogram per kelvin";
    case Unit.MilligramPerKelvin:
      return "milligram per kelvin";
    case Unit.PoundForcePerFoot:
      return "pound-force per foot";
    case Unit.KilogramSquareCentimetre:
      return "kilogram square centimetre";
    case Unit.KilogramSquareMillimetre:
      return "kilogram square millimetre";
    case Unit.PoundInchSquared:
      return "pound inch squared";
    case Unit.PoundForceInch:
      return "pound-force inch";
    case Unit.PoundForceFootPerAmpere:
      return "pound-force foot per ampere";
    case Unit.GramPerCubicDecimetre:
      return "gram per cubic decimetre";
    case Unit.KilogramPerKilomol:
      return "kilogram per kilomol";
    case Unit.GramPerHertz:
      return "gram per hertz";
    case Unit.GramPerDay:
      return "gram per day";
    case Unit.GramPerHour:
      return "gram per hour";
    case Unit.GramPerMinute:
      return "gram per minute";
    case Unit.GramPerSecond:
      return "gram per second";
    case Unit.KilogramPerDay:
      return "kilogram per day";
    case Unit.KilogramPerMinute:
      return "kilogram per minute";
    case Unit.MilligramPerDay:
      return "milligram per day";
    case Unit.MilligramPerMinute:
      return "milligram per minute";
    case Unit.MilligramPerSecond:
      return "milligram per second";
    case Unit.GramPerDayKelvin:
      return "gram per day kelvin";
    case Unit.GramPerHourKelvin:
      return "gram per hour kelvin";
    case Unit.GramPerMinuteKelvin:
      return "gram per minute kelvin";
    case Unit.GramPerSecondKelvin:
      return "gram per second kelvin";
    case Unit.KilogramPerDayKelvin:
      return "kilogram per day kelvin";
    case Unit.KilogramPerHourKelvin:
      return "kilogram per hour kelvin";
    case Unit.KilogramPerMinuteKelvin:
      return "kilogram per minute kelvin";
    case Unit.KilogramPerSecondKelvin:
      return "kilogram per second kelvin";
    case Unit.MilligramPerDayKelvin:
      return "milligram per day kelvin";
    case Unit.MilligramPerHourKelvin:
      return "milligram per hour kelvin";
    case Unit.MilligramPerMinuteKelvin:
      return "milligram per minute kelvin";
    case Unit.MilligramPerSecondKelvin:
      return "milligram per second kelvin";
    case Unit.NewtonPerMillimetre:
      return "newton per millimetre";
    case Unit.PoundForcePerInch:
      return "pound-force per inch";
    case Unit.RodUnitDistance:
      return "rod [unit of distance]";
    case Unit.MicrometrePerKelvin:
      return "micrometre per kelvin";
    case Unit.CentimetrePerKelvin:
      return "centimetre per kelvin";
    case Unit.MetrePerKelvin:
      return "metre per kelvin";
    case Unit.MillimetrePerKelvin:
      return "millimetre per kelvin";
    case Unit.MilliohmPerMetre:
      return "milliohm per metre";
    case Unit.OhmPerMileStatuteMile:
      return "ohm per mile (statute mile)";
    case Unit.OhmPerKilometre:
      return "ohm per kilometre";
    case Unit.MilliamperePerPoundForcePerSquareInch:
      return "milliampere per pound-force per square inch";
    case Unit.ReciprocalBar:
      return "reciprocal bar";
    case Unit.MilliamperePerBar:
      return "milliampere per bar";
    case Unit.DegreeCelsiusPerBar:
      return "degree Celsius per bar";
    case Unit.KelvinPerBar:
      return "kelvin per bar";
    case Unit.GramPerDayBar:
      return "gram per day bar";
    case Unit.GramPerHourBar:
      return "gram per hour bar";
    case Unit.GramPerMinuteBar:
      return "gram per minute bar";
    case Unit.GramPerSecondBar:
      return "gram per second bar";
    case Unit.KilogramPerDayBar:
      return "kilogram per day bar";
    case Unit.KilogramPerHourBar:
      return "kilogram per hour bar";
    case Unit.KilogramPerMinuteBar:
      return "kilogram per minute bar";
    case Unit.KilogramPerSecondBar:
      return "kilogram per second bar";
    case Unit.MilligramPerDayBar:
      return "milligram per day bar";
    case Unit.MilligramPerHourBar:
      return "milligram per hour bar";
    case Unit.MilligramPerMinuteBar:
      return "milligram per minute bar";
    case Unit.MilligramPerSecondBar:
      return "milligram per second bar";
    case Unit.GramPerBar:
      return "gram per bar";
    case Unit.MilligramPerBar:
      return "milligram per bar";
    case Unit.MilliamperePerMillimetre:
      return "milliampere per millimetre";
    case Unit.PascalSecondPerKelvin:
      return "pascal second per kelvin";
    case Unit.InchWater:
      return "inch of water";
    case Unit.InchMercury:
      return "inch of mercury";
    case Unit.WaterHorsePower:
      return "water horse power";
    case Unit.BarPerKelvin:
      return "bar per kelvin";
    case Unit.HectopascalPerKelvin:
      return "hectopascal per kelvin";
    case Unit.KilopascalPerKelvin:
      return "kilopascal per kelvin";
    case Unit.MillibarPerKelvin:
      return "millibar per kelvin";
    case Unit.MegapascalPerKelvin:
      return "megapascal per kelvin";
    case Unit.PoisePerKelvin:
      return "poise per kelvin";
    case Unit.VoltPerLitreMinute:
      return "volt per litre minute";
    case Unit.NewtonCentimetre:
      return "newton centimetre";
    case Unit.NewtonMetrePerDegree:
      return "newton metre per degree";
    case Unit.NewtonMetrePerAmpere:
      return "newton metre per ampere";
    case Unit.BarLitrePerSecond:
      return "bar litre per second";
    case Unit.BarCubicMetrePerSecond:
      return "bar cubic metre per second";
    case Unit.HectopascalLitrePerSecond:
      return "hectopascal litre per second";
    case Unit.HectopascalCubicMetrePerSecond:
      return "hectopascal cubic metre per second";
    case Unit.MillibarLitrePerSecond:
      return "millibar litre per second";
    case Unit.MillibarCubicMetrePerSecond:
      return "millibar cubic metre per second";
    case Unit.MegapascalLitrePerSecond:
      return "megapascal litre per second";
    case Unit.MegapascalCubicMetrePerSecond:
      return "megapascal cubic metre per second";
    case Unit.PascalLitrePerSecond:
      return "pascal litre per second";
    case Unit.DegreeFahrenheit:
      return "degree Fahrenheit";
    case Unit.Farad:
      return "farad";
    case Unit.FibreMetre:
      return "fibre metre";
    case Unit.ThousandCubicFoot:
      return "thousand cubic foot";
    case Unit.HundredCubicMetre:
      return "hundred cubic metre";
    case Unit.Micromole:
      return "micromole";
    case Unit.FailuresInTime:
      return "failures in time";
    case Unit.FlakeTon:
      return "flake ton";
    case Unit.FormazinNephelometricUnit:
      return "Formazin nephelometric unit";
    case Unit.Foot:
      return "foot";
    case Unit.PoundPerSquareFoot:
      return "pound per square foot";
    case Unit.FootPerMinute:
      return "foot per minute";
    case Unit.FootPerSecond:
      return "foot per second";
    case Unit.SquareFoot:
      return "square foot";
    case Unit.CubicFoot:
      return "cubic foot";
    case Unit.PascalCubicMetrePerSecond:
      return "pascal cubic metre per second";
    case Unit.CentimetrePerBar:
      return "centimetre per bar";
    case Unit.MetrePerBar:
      return "metre per bar";
    case Unit.MillimetrePerBar:
      return "millimetre per bar";
    case Unit.SquareInchPerSecond:
      return "square inch per second";
    case Unit.SquareMetrePerSecondKelvin:
      return "square metre per second kelvin";
    case Unit.StokesPerKelvin:
      return "stokes per kelvin";
    case Unit.GramPerCubicCentimetreBar:
      return "gram per cubic centimetre bar";
    case Unit.GramPerCubicDecimetreBar:
      return "gram per cubic decimetre bar";
    case Unit.GramPerLitreBar:
      return "gram per litre bar";
    case Unit.GramPerCubicMetreBar:
      return "gram per cubic metre bar";
    case Unit.GramPerMillilitreBar:
      return "gram per millilitre bar";
    case Unit.KilogramPerCubicCentimetreBar:
      return "kilogram per cubic centimetre bar";
    case Unit.KilogramPerLitreBar:
      return "kilogram per litre bar";
    case Unit.KilogramPerCubicMetreBar:
      return "kilogram per cubic metre bar";
    case Unit.NewtonMetrePerKilogram:
      return "newton metre per kilogram";
    case Unit.UsGallonPerMinute:
      return "US gallon per minute";
    case Unit.PoundForceFootPerPound:
      return "pound-force foot per pound";
    case Unit.CupUnitVolume:
      return "cup [unit of volume]";
    case Unit.Peck:
      return "peck";
    case Unit.TablespoonUs:
      return "tablespoon (US)";
    case Unit.TeaspoonUs:
      return "teaspoon (US)";
    case Unit.Stere:
      return "stere";
    case Unit.CubicCentimetrePerKelvin:
      return "cubic centimetre per kelvin";
    case Unit.LitrePerKelvin:
      return "litre per kelvin";
    case Unit.CubicMetrePerKelvin:
      return "cubic metre per kelvin";
    case Unit.ImperialGallonPerMinute:
      return "Imperial gallon per minute";
    case Unit.MillilitrePerKelvin:
      return "millilitre per kelvin";
    case Unit.KilogramPerCubicCentimetre:
      return "kilogram per cubic centimetre";
    case Unit.OunceAvoirdupoisPerCubicYard:
      return "ounce (avoirdupois) per cubic yard";
    case Unit.GramPerCubicCentimetreKelvin:
      return "gram per cubic centimetre kelvin";
    case Unit.GramPerCubicDecimetreKelvin:
      return "gram per cubic decimetre kelvin";
    case Unit.GramPerLitreKelvin:
      return "gram per litre kelvin";
    case Unit.GramPerCubicMetreKelvin:
      return "gram per cubic metre kelvin";
    case Unit.GramPerMillilitreKelvin:
      return "gram per millilitre kelvin";
    case Unit.KilogramPerCubicCentimetreKelvin:
      return "kilogram per cubic centimetre kelvin";
    case Unit.KilogramPerLitreKelvin:
      return "kilogram per litre kelvin";
    case Unit.KilogramPerCubicMetreKelvin:
      return "kilogram per cubic metre kelvin";
    case Unit.SquareMetrePerSecondBar:
      return "square metre per second bar";
    case Unit.MicrosiemensPerCentimetre:
      return "microsiemens per centimetre";
    case Unit.MicrosiemensPerMetre:
      return "microsiemens per metre";
    case Unit.NanosiemensPerCentimetre:
      return "nanosiemens per centimetre";
    case Unit.NanosiemensPerMetre:
      return "nanosiemens per metre";
    case Unit.StokesPerBar:
      return "stokes per bar";
    case Unit.CubicCentimetrePerDay:
      return "cubic centimetre per day";
    case Unit.CubicCentimetrePerHour:
      return "cubic centimetre per hour";
    case Unit.CubicCentimetrePerMinute:
      return "cubic centimetre per minute";
    case Unit.GallonUsPerHour:
      return "gallon (US) per hour";
    case Unit.LitrePerSecond:
      return "litre per second";
    case Unit.CubicMetrePerDay:
      return "cubic metre per day";
    case Unit.CubicMetrePerMinute:
      return "cubic metre per minute";
    case Unit.MillilitrePerDay:
      return "millilitre per day";
    case Unit.MillilitrePerHour:
      return "millilitre per hour";
    case Unit.CubicInchPerHour:
      return "cubic inch per hour";
    case Unit.CubicInchPerMinute:
      return "cubic inch per minute";
    case Unit.CubicInchPerSecond:
      return "cubic inch per second";
    case Unit.MilliamperePerLitreMinute:
      return "milliampere per litre minute";
    case Unit.VoltPerBar:
      return "volt per bar";
    case Unit.CubicCentimetrePerDayKelvin:
      return "cubic centimetre per day kelvin";
    case Unit.CubicCentimetrePerHourKelvin:
      return "cubic centimetre per hour kelvin";
    case Unit.CubicCentimetrePerMinuteKelvin:
      return "cubic centimetre per minute kelvin";
    case Unit.CubicCentimetrePerSecondKelvin:
      return "cubic centimetre per second kelvin";
    case Unit.LitrePerDayKelvin:
      return "litre per day kelvin";
    case Unit.LitrePerHourKelvin:
      return "litre per hour kelvin";
    case Unit.LitrePerMinuteKelvin:
      return "litre per minute kelvin";
    case Unit.LitrePerSecondKelvin:
      return "litre per second kelvin";
    case Unit.CubicMetrePerDayKelvin:
      return "cubic metre per day kelvin";
    case Unit.CubicMetrePerHourKelvin:
      return "cubic metre per hour kelvin";
    case Unit.CubicMetrePerMinuteKelvin:
      return "cubic metre per minute kelvin";
    case Unit.CubicMetrePerSecondKelvin:
      return "cubic metre per second kelvin";
    case Unit.MillilitrePerDayKelvin:
      return "millilitre per day kelvin";
    case Unit.MillilitrePerHourKelvin:
      return "millilitre per hour kelvin";
    case Unit.MillilitrePerMinuteKelvin:
      return "millilitre per minute kelvin";
    case Unit.MillilitrePerSecondKelvin:
      return "millilitre per second kelvin";
    case Unit.MillimetreToFourthPower:
      return "millimetre to the fourth power";
    case Unit.CubicCentimetrePerDayBar:
      return "cubic centimetre per day bar";
    case Unit.CubicCentimetrePerHourBar:
      return "cubic centimetre per hour bar";
    case Unit.CubicCentimetrePerMinuteBar:
      return "cubic centimetre per minute bar";
    case Unit.CubicCentimetrePerSecondBar:
      return "cubic centimetre per second bar";
    case Unit.LitrePerDayBar:
      return "litre per day bar";
    case Unit.LitrePerHourBar:
      return "litre per hour bar";
    case Unit.LitrePerMinuteBar:
      return "litre per minute bar";
    case Unit.LitrePerSecondBar:
      return "litre per second bar";
    case Unit.CubicMetrePerDayBar:
      return "cubic metre per day bar";
    case Unit.CubicMetrePerHourBar:
      return "cubic metre per hour bar";
    case Unit.CubicMetrePerMinuteBar:
      return "cubic metre per minute bar";
    case Unit.CubicMetrePerSecondBar:
      return "cubic metre per second bar";
    case Unit.MillilitrePerDayBar:
      return "millilitre per day bar";
    case Unit.MillilitrePerHourBar:
      return "millilitre per hour bar";
    case Unit.MillilitrePerMinuteBar:
      return "millilitre per minute bar";
    case Unit.MillilitrePerSecondBar:
      return "millilitre per second bar";
    case Unit.CubicCentimetrePerBar:
      return "cubic centimetre per bar";
    case Unit.LitrePerBar:
      return "litre per bar";
    case Unit.CubicMetrePerBar:
      return "cubic metre per bar";
    case Unit.MillilitrePerBar:
      return "millilitre per bar";
    case Unit.MicrohenryPerKiloohm:
      return "microhenry per kiloohm";
    case Unit.MicrohenryPerOhm:
      return "microhenry per ohm";
    case Unit.GallonUsPerDay:
      return "gallon (US) per day";
    case Unit.Gigabecquerel:
      return "gigabecquerel";
    case Unit.GramDryWeight:
      return "gram, dry weight";
    case Unit.PoundPerGallonUs:
      return "pound per gallon (US)";
    case Unit.GramPerMetreGramPer100Centimetres:
      return "gram per metre (gram per 100 centimetres)";
    case Unit.GramFissileIsotope:
      return "gram of fissile isotope";
    case Unit.GreatGross:
      return "great gross";
    case Unit.GillUs:
      return "gill (US)";
    case Unit.GramIncludingContainer:
      return "gram, including container";
    case Unit.GillUk:
      return "gill (UK)";
    case Unit.GramIncludingInnerPackaging:
      return "gram, including inner packaging";
    case Unit.GramPerMillilitre:
      return "gram per millilitre";
    case Unit.GramPerLitre:
      return "gram per litre";
    case Unit.DryGallonUs:
      return "dry gallon (US)";
    case Unit.GallonUk:
      return "gallon (UK)";
    case Unit.GallonUs:
      return "gallon (US)";
    case Unit.GramPerSquareMetre:
      return "gram per square metre";
    case Unit.MilligramPerSquareMetre:
      return "milligram per square metre";
    case Unit.MilligramPerCubicMetre:
      return "milligram per cubic metre";
    case Unit.MicrogramPerCubicMetre:
      return "microgram per cubic metre";
    case Unit.Gram:
      return "gram";
    case Unit.Grain:
      return "grain";
    case Unit.Gross:
      return "gross";
    case Unit.Gigajoule:
      return "gigajoule";
    case Unit.GigawattHour:
      return "gigawatt hour";
    case Unit.HenryPerKiloohm:
      return "henry per kiloohm";
    case Unit.HenryPerOhm:
      return "henry per ohm";
    case Unit.MillihenryPerKiloohm:
      return "millihenry per kiloohm";
    case Unit.MillihenryPerOhm:
      return "millihenry per ohm";
    case Unit.PascalSecondPerBar:
      return "pascal second per bar";
    case Unit.Microbecquerel:
      return "microbecquerel";
    case Unit.ReciprocalYear:
      return "reciprocal year";
    case Unit.ReciprocalHour:
      return "reciprocal hour";
    case Unit.ReciprocalMonth:
      return "reciprocal month";
    case Unit.DegreeCelsiusPerHour:
      return "degree Celsius per hour";
    case Unit.DegreeCelsiusPerMinute:
      return "degree Celsius per minute";
    case Unit.DegreeCelsiusPerSecond:
      return "degree Celsius per second";
    case Unit.SquareCentimetrePerGram:
      return "square centimetre per gram";
    case Unit.SquareDecametre:
      return "square decametre";
    case Unit.SquareHectometre:
      return "square hectometre";
    case Unit.CubicHectometre:
      return "cubic hectometre";
    case Unit.CubicKilometre:
      return "cubic kilometre";
    case Unit.Blank:
      return "blank";
    case Unit.VoltSquareInchPerPoundForce:
      return "volt square inch per pound-force";
    case Unit.VoltPerInch:
      return "volt per inch";
    case Unit.VoltPerMicrosecond:
      return "volt per microsecond";
    case Unit.PercentPerKelvin:
      return "percent per kelvin";
    case Unit.OhmPerMetre:
      return "ohm per metre";
    case Unit.DegreePerMetre:
      return "degree per metre";
    case Unit.MicrofaradPerKilometre:
      return "microfarad per kilometre";
    case Unit.MicrogramPerLitre:
      return "microgram per litre";
    case Unit.SquareMicrometreSquareMicron:
      return "square micrometre (square micron)";
    case Unit.AmperePerKilogram:
      return "ampere per kilogram";
    case Unit.AmpereSquaredSecond:
      return "ampere squared second";
    case Unit.FaradPerKilometre:
      return "farad per kilometre";
    case Unit.HertzMetre:
      return "hertz metre";
    case Unit.KelvinMetrePerWatt:
      return "kelvin metre per watt";
    case Unit.MegaohmPerKilometre:
      return "megaohm per kilometre";
    case Unit.MegaohmPerMetre:
      return "megaohm per metre";
    case Unit.Megaampere:
      return "megaampere";
    case Unit.MegahertzKilometre:
      return "megahertz kilometre";
    case Unit.NewtonPerAmpere:
      return "newton per ampere";
    case Unit.NewtonMetreWattToPowerMinus05:
      return "newton metre watt to the power minus 0,5";
    case Unit.PascalPerMetre:
      return "pascal per metre";
    case Unit.SiemensPerCentimetre:
      return "siemens per centimetre";
    case Unit.Teraohm:
      return "teraohm";
    case Unit.VoltSecondPerMetre:
      return "volt second per metre";
    case Unit.VoltPerSecond:
      return "volt per second";
    case Unit.WattPerCubicMetre:
      return "watt per cubic metre";
    case Unit.Attofarad:
      return "attofarad";
    case Unit.CentimetrePerHour:
      return "centimetre per hour";
    case Unit.ReciprocalCubicCentimetre:
      return "reciprocal cubic centimetre";
    case Unit.DecibelPerKilometre:
      return "decibel per kilometre";
    case Unit.DecibelPerMetre:
      return "decibel per metre";
    case Unit.KilogramPerBar:
      return "kilogram per bar";
    case Unit.KilogramPerCubicDecimetreKelvin:
      return "kilogram per cubic decimetre kelvin";
    case Unit.KilogramPerCubicDecimetreBar:
      return "kilogram per cubic decimetre bar";
    case Unit.KilogramPerSquareMetreSecond:
      return "kilogram per square metre second";
    case Unit.InchPerTwoPiRadiant:
      return "inch per two pi radiant";
    case Unit.MetrePerVoltSecond:
      return "metre per volt second";
    case Unit.SquareMetrePerNewton:
      return "square metre per newton";
    case Unit.CubicMetrePerCubicMetre:
      return "cubic metre per cubic metre";
    case Unit.MillisiemensPerCentimetre:
      return "millisiemens per centimetre";
    case Unit.MillivoltPerMinute:
      return "millivolt per minute";
    case Unit.MilligramPerSquareCentimetre:
      return "milligram per square centimetre";
    case Unit.MilligramPerGram:
      return "milligram per gram";
    case Unit.MillilitrePerCubicMetre:
      return "millilitre per cubic metre";
    case Unit.MillimetrePerYear:
      return "millimetre per year";
    case Unit.MillimetrePerHour:
      return "millimetre per hour";
    case Unit.MillimolePerGram:
      return "millimole per gram";
    case Unit.PicopascalPerKilometre:
      return "picopascal per kilometre";
    case Unit.Picosecond:
      return "picosecond";
    case Unit.PercentPerMonth:
      return "percent per month";
    case Unit.PercentPerHectobar:
      return "percent per hectobar";
    case Unit.PercentPerDecakelvin:
      return "percent per decakelvin";
    case Unit.WattPerMetre:
      return "watt per metre";
    case Unit.Decapascal:
      return "decapascal";
    case Unit.GramPerMillimetre:
      return "gram per millimetre";
    case Unit.ModuleWidth:
      return "module width";
    case Unit.FrenchGauge:
      return "French gauge";
    case Unit.RackUnit:
      return "rack unit";
    case Unit.MillimetrePerMinute:
      return "millimetre per minute";
    case Unit.BigPoint:
      return "big point";
    case Unit.LitrePerKilogram:
      return "litre per kilogram";
    case Unit.GramMillimetre:
      return "gram millimetre";
    case Unit.ReciprocalWeek:
      return "reciprocal week";
    case Unit.Piece:
      return "piece";
    case Unit.MegaohmKilometre:
      return "megaohm kilometre";
    case Unit.PercentPerOhm:
      return "percent per ohm";
    case Unit.PercentPerDegree:
      return "percent per degree";
    case Unit.PercentPerTenThousand:
      return "percent per ten thousand";
    case Unit.PercentPerOneHundredThousand:
      return "percent per one hundred thousand";
    case Unit.PercentPerHundred:
      return "percent per hundred";
    case Unit.PercentPerThousand:
      return "percent per thousand";
    case Unit.PercentPerVolt:
      return "percent per volt";
    case Unit.PercentPerBar:
      return "percent per bar";
    case Unit.PercentPerInch:
      return "percent per inch";
    case Unit.PercentPerMetre:
      return "percent per metre";
    case Unit.Hank:
      return "hank";
    case Unit.PieceDay:
      return "Piece Day";
    case Unit.Hectobar:
      return "hectobar";
    case Unit.HundredBoxes:
      return "hundred boxes";
    case Unit.HundredCount:
      return "hundred count";
    case Unit.HundredKilogramDryWeight:
      return "hundred kilogram, dry weight";
    case Unit.Head:
      return "head";
    case Unit.Hectogram:
      return "hectogram";
    case Unit.HundredCubicFoot:
      return "hundred cubic foot";
    case Unit.HundredInternationalUnit:
      return "hundred international unit";
    case Unit.HundredKilogramNetMass:
      return "hundred kilogram, net mass";
    case Unit.Hectolitre:
      return "hectolitre";
    case Unit.MilePerHourStatuteMile:
      return "mile per hour (statute mile)";
    case Unit.PieceMonth:
      return "Piece Month";
    case Unit.MillionCubicMetre:
      return "million cubic metre";
    case Unit.Hectometre:
      return "hectometre";
    case Unit.HectolitrePureAlcohol:
      return "hectolitre of pure alcohol";
    case Unit.Hertz:
      return "hertz";
    case Unit.Hour:
      return "hour";
    case Unit.PieceWeek:
      return "Piece Week";
    case Unit.InchPoundPoundInch:
      return "inch pound (pound inch)";
    case Unit.Person:
      return "person";
    case Unit.Inch:
      return "inch";
    case Unit.SquareInch:
      return "square inch";
    case Unit.CubicInch:
      return "cubic inch";
    case Unit.InternationalSugarDegree:
      return "international sugar degree";
    case Unit.InchPerSecond:
      return "inch per second";
    case Unit.InternationalUnitPerGram:
      return "international unit per gram";
    case Unit.InchPerSecondSquared:
      return "inch per second squared";
    case Unit.PercentPerMillimetre:
      return "percent per millimetre";
    case Unit.PerMillePerPsi:
      return "per mille per psi";
    case Unit.DegreeApi:
      return "degree API";
    case Unit.DegreeBaumeOriginScale:
      return "degree Baume (origin scale)";
    case Unit.DegreeBaumeUsHeavy:
      return "degree Baume (US heavy)";
    case Unit.DegreeBaumeUsLight:
      return "degree Baume (US light)";
    case Unit.DegreeBalling:
      return "degree Balling";
    case Unit.DegreeBrix:
      return "degree Brix";
    case Unit.DegreeFahrenheitHourSquareFootPerBritishThermalUnitThermochemical:
      return "degree Fahrenheit hour square foot per British thermal unit (thermochemical)";
    case Unit.JoulePerKilogram:
      return "joule per kilogram";
    case Unit.DegreeFahrenheitPerKelvin:
      return "degree Fahrenheit per kelvin";
    case Unit.DegreeFahrenheitPerBar:
      return "degree Fahrenheit per bar";
    case Unit.DegreeFahrenheitHourSquareFootPerBritishThermalUnitInternationalTable:
      return "degree Fahrenheit hour square foot per British thermal unit (international table)";
    case Unit.DegreeFahrenheitPerHour:
      return "degree Fahrenheit per hour";
    case Unit.DegreeFahrenheitPerMinute:
      return "degree Fahrenheit per minute";
    case Unit.DegreeFahrenheitPerSecond:
      return "degree Fahrenheit per second";
    case Unit.ReciprocalDegreeFahrenheit:
      return "reciprocal degree Fahrenheit";
    case Unit.DegreeOechsle:
      return "degree Oechsle";
    case Unit.DegreeRankinePerHour:
      return "degree Rankine per hour";
    case Unit.DegreeRankinePerMinute:
      return "degree Rankine per minute";
    case Unit.DegreeRankinePerSecond:
      return "degree Rankine per second";
    case Unit.DegreeTwaddell:
      return "degree Twaddell";
    case Unit.Micropoise:
      return "micropoise";
    case Unit.MicrogramPerKilogram:
      return "microgram per kilogram";
    case Unit.MicrogramPerCubicMetreKelvin:
      return "microgram per cubic metre kelvin";
    case Unit.MicrogramPerCubicMetreBar:
      return "microgram per cubic metre bar";
    case Unit.MicrolitrePerLitre:
      return "microlitre per litre";
    case Unit.Baud:
      return "baud";
    case Unit.BritishThermalUnitMean:
      return "British thermal unit (mean)";
    case Unit.BritishThermalUnitInternationalTableFootPerHourSquareFootDegreeFahrenheit:
      return "British thermal unit (international table) foot per hour square foot degree Fahrenheit";
    case Unit.BritishThermalUnitInternationalTableInchPerHourSquareFootDegreeFahrenheit:
      return "British thermal unit (international table) inch per hour square foot degree Fahrenheit";
    case Unit.BritishThermalUnitInternationalTableInchPerSecondSquareFootDegreeFahrenheit:
      return "British thermal unit (international table) inch per second square foot degree Fahrenheit";
    case Unit.BritishThermalUnitInternationalTablePerPoundDegreeFahrenheit:
      return "British thermal unit (international table) per pound degree Fahrenheit";
    case Unit.BritishThermalUnitInternationalTablePerMinute:
      return "British thermal unit (international table) per minute";
    case Unit.BritishThermalUnitInternationalTablePerSecond:
      return "British thermal unit (international table) per second";
    case Unit.BritishThermalUnitThermochemicalFootPerHourSquareFootDegreeFahrenheit:
      return "British thermal unit (thermochemical) foot per hour square foot degree Fahrenheit";
    case Unit.BritishThermalUnitThermochemicalPerHour:
      return "British thermal unit (thermochemical) per hour";
    case Unit.BritishThermalUnitThermochemicalInchPerHourSquareFootDegreeFahrenheit:
      return "British thermal unit (thermochemical) inch per hour square foot degree Fahrenheit";
    case Unit.BritishThermalUnitThermochemicalInchPerSecondSquareFootDegreeFahrenheit:
      return "British thermal unit (thermochemical) inch per second square foot degree Fahrenheit";
    case Unit.BritishThermalUnitThermochemicalPerPoundDegreeFahrenheit:
      return "British thermal unit (thermochemical) per pound degree Fahrenheit";
    case Unit.BritishThermalUnitThermochemicalPerMinute:
      return "British thermal unit (thermochemical) per minute";
    case Unit.BritishThermalUnitThermochemicalPerSecond:
      return "British thermal unit (thermochemical) per second";
    case Unit.CoulombSquareMetrePerKilogram:
      return "coulomb square metre per kilogram";
    case Unit.Megabaud:
      return "megabaud";
    case Unit.WattSecond:
      return "watt second";
    case Unit.BarPerBar:
      return "bar per bar";
    case Unit.BarrelUkPetroleum:
      return "barrel (UK petroleum)";
    case Unit.BarrelUkPetroleumPerMinute:
      return "barrel (UK petroleum) per minute";
    case Unit.BarrelUkPetroleumPerDay:
      return "barrel (UK petroleum) per day";
    case Unit.BarrelUkPetroleumPerHour:
      return "barrel (UK petroleum) per hour";
    case Unit.BarrelUkPetroleumPerSecond:
      return "barrel (UK petroleum) per second";
    case Unit.BarrelUsPetroleumPerHour:
      return "barrel (US petroleum) per hour";
    case Unit.BarrelUsPetroleumPerSecond:
      return "barrel (US petroleum) per second";
    case Unit.BushelUkPerDay:
      return "bushel (UK) per day";
    case Unit.BushelUkPerHour:
      return "bushel (UK) per hour";
    case Unit.BushelUkPerMinute:
      return "bushel (UK) per minute";
    case Unit.BushelUkPerSecond:
      return "bushel (UK) per second";
    case Unit.BushelUsDryPerDay:
      return "bushel (US dry) per day";
    case Unit.BushelUsDryPerHour:
      return "bushel (US dry) per hour";
    case Unit.BushelUsDryPerMinute:
      return "bushel (US dry) per minute";
    case Unit.BushelUsDryPerSecond:
      return "bushel (US dry) per second";
    case Unit.CentinewtonMetre:
      return "centinewton metre";
    case Unit.CentipoisePerKelvin:
      return "centipoise per kelvin";
    case Unit.CentipoisePerBar:
      return "centipoise per bar";
    case Unit.CalorieMean:
      return "calorie (mean)";
    case Unit.CalorieInternationalTablePerGramDegreeCelsius:
      return "calorie (international table) per gram degree Celsius";
    case Unit.CalorieThermochemicalPerCentimetreSecondDegreeCelsius:
      return "calorie (thermochemical) per centimetre second degree Celsius";
    case Unit.CalorieThermochemicalPerGramDegreeCelsius:
      return "calorie (thermochemical) per gram degree Celsius";
    case Unit.CalorieThermochemicalPerMinute:
      return "calorie (thermochemical) per minute";
    case Unit.CalorieThermochemicalPerSecond:
      return "calorie (thermochemical) per second";
    case Unit.Clo:
      return "clo";
    case Unit.CentimetrePerSecondKelvin:
      return "centimetre per second kelvin";
    case Unit.CentimetrePerSecondBar:
      return "centimetre per second bar";
    case Unit.CubicCentimetrePerCubicMetre:
      return "cubic centimetre per cubic metre";
    case Unit.CubicDecimetrePerDay:
      return "cubic decimetre per day";
    case Unit.CubicDecimetrePerCubicMetre:
      return "cubic decimetre per cubic metre";
    case Unit.CubicDecimetrePerMinute:
      return "cubic decimetre per minute";
    case Unit.CubicDecimetrePerSecond:
      return "cubic decimetre per second";
    case Unit.OunceUkFluidPerDay:
      return "ounce (UK fluid) per day";
    case Unit.OunceUkFluidPerHour:
      return "ounce (UK fluid) per hour";
    case Unit.OunceUkFluidPerMinute:
      return "ounce (UK fluid) per minute";
    case Unit.OunceUkFluidPerSecond:
      return "ounce (UK fluid) per second";
    case Unit.OunceUsFluidPerDay:
      return "ounce (US fluid) per day";
    case Unit.JoulePerKelvin:
      return "joule per kelvin";
    case Unit.MegajoulePerKilogram:
      return "megajoule per kilogram";
    case Unit.MegajoulePerCubicMetre:
      return "megajoule per cubic metre";
    case Unit.PipelineJoint:
      return "pipeline joint";
    case Unit.Joule:
      return "joule";
    case Unit.HundredMetre:
      return "hundred metre";
    case Unit.NumberJewels:
      return "number of jewels";
    case Unit.KilowattDemand:
      return "kilowatt demand";
    case Unit.OunceUsFluidPerHour:
      return "ounce (US fluid) per hour";
    case Unit.OunceUsFluidPerMinute:
      return "ounce (US fluid) per minute";
    case Unit.OunceUsFluidPerSecond:
      return "ounce (US fluid) per second";
    case Unit.FootPerDegreeFahrenheit:
      return "foot per degree Fahrenheit";
    case Unit.FootPerHour:
      return "foot per hour";
    case Unit.FootPoundForcePerHour:
      return "foot pound-force per hour";
    case Unit.FootPoundForcePerMinute:
      return "foot pound-force per minute";
    case Unit.FootPerPsi:
      return "foot per psi";
    case Unit.FootPerSecondDegreeFahrenheit:
      return "foot per second degree Fahrenheit";
    case Unit.FootPerSecondPsi:
      return "foot per second psi";
    case Unit.KilovoltAmpereReactiveDemand:
      return "kilovolt ampere reactive demand";
    case Unit.ReciprocalCubicFoot:
      return "reciprocal cubic foot";
    case Unit.CubicFootPerDegreeFahrenheit:
      return "cubic foot per degree Fahrenheit";
    case Unit.CubicFootPerDay:
      return "cubic foot per day";
    case Unit.CubicFootPerPsi:
      return "cubic foot per psi";
    case Unit.GallonUkPerDay:
      return "gallon (UK) per day";
    case Unit.GallonUkPerHour:
      return "gallon (UK) per hour";
    case Unit.GallonUkPerSecond:
      return "gallon (UK) per second";
    case Unit.KilovoltAmpereReactiveHour:
      return "kilovolt ampere reactive hour";
    case Unit.GallonUsLiquidPerSecond:
      return "gallon (US liquid) per second";
    case Unit.GramForcePerSquareCentimetre:
      return "gram-force per square centimetre";
    case Unit.GillUkPerDay:
      return "gill (UK) per day";
    case Unit.GillUkPerHour:
      return "gill (UK) per hour";
    case Unit.GillUkPerMinute:
      return "gill (UK) per minute";
    case Unit.GillUkPerSecond:
      return "gill (UK) per second";
    case Unit.GillUsPerDay:
      return "gill (US) per day";
    case Unit.GillUsPerHour:
      return "gill (US) per hour";
    case Unit.GillUsPerMinute:
      return "gill (US) per minute";
    case Unit.GillUsPerSecond:
      return "gill (US) per second";
    case Unit.StandardAccelerationFreeFall:
      return "standard acceleration of free fall";
    case Unit.GrainPerGallonUs:
      return "grain per gallon (US)";
    case Unit.HorsepowerBoiler:
      return "horsepower (boiler)";
    case Unit.HorsepowerElectric:
      return "horsepower (electric)";
    case Unit.InchPerDegreeFahrenheit:
      return "inch per degree Fahrenheit";
    case Unit.InchPerPsi:
      return "inch per psi";
    case Unit.InchPerSecondDegreeFahrenheit:
      return "inch per second degree Fahrenheit";
    case Unit.InchPerSecondPsi:
      return "inch per second psi";
    case Unit.ReciprocalCubicInch:
      return "reciprocal cubic inch";
    case Unit.Kilobaud:
      return "kilobaud";
    case Unit.KilocalorieMean:
      return "kilocalorie (mean)";
    case Unit.KilocalorieInternationalTablePerHourMetreDegreeCelsius:
      return "kilocalorie (international table) per hour metre degree Celsius";
    case Unit.KilocalorieThermochemical:
      return "kilocalorie (thermochemical)";
    case Unit.KilocalorieThermochemicalPerMinute:
      return "kilocalorie (thermochemical) per minute";
    case Unit.KilocalorieThermochemicalPerSecond:
      return "kilocalorie (thermochemical) per second";
    case Unit.KilomolePerHour:
      return "kilomole per hour";
    case Unit.KilomolePerCubicMetreKelvin:
      return "kilomole per cubic metre kelvin";
    case Unit.Kilolitre:
      return "kilolitre";
    case Unit.KilomolePerCubicMetreBar:
      return "kilomole per cubic metre bar";
    case Unit.KilomolePerMinute:
      return "kilomole per minute";
    case Unit.LitrePerLitre:
      return "litre per litre";
    case Unit.ReciprocalLitre:
      return "reciprocal litre";
    case Unit.PoundAvoirdupoisPerDegreeFahrenheit:
      return "pound (avoirdupois) per degree Fahrenheit";
    case Unit.PoundAvoirdupoisSquareFoot:
      return "pound (avoirdupois) square foot";
    case Unit.PoundAvoirdupoisPerDay:
      return "pound (avoirdupois) per day";
    case Unit.PoundPerFootHour:
      return "pound per foot hour";
    case Unit.PoundPerFootSecond:
      return "pound per foot second";
    case Unit.PoundAvoirdupoisPerCubicFootDegreeFahrenheit:
      return "pound (avoirdupois) per cubic foot degree Fahrenheit";
    case Unit.PoundAvoirdupoisPerCubicFootPsi:
      return "pound (avoirdupois) per cubic foot psi";
    case Unit.PoundAvoirdupoisPerGallonUk:
      return "pound (avoirdupois) per gallon (UK)";
    case Unit.PoundAvoirdupoisPerHourDegreeFahrenheit:
      return "pound (avoirdupois) per hour degree Fahrenheit";
    case Unit.PoundAvoirdupoisPerHourPsi:
      return "pound (avoirdupois) per hour psi";
    case Unit.PoundAvoirdupoisPerCubicInchDegreeFahrenheit:
      return "pound (avoirdupois) per cubic inch degree Fahrenheit";
    case Unit.PoundAvoirdupoisPerCubicInchPsi:
      return "pound (avoirdupois) per cubic inch psi";
    case Unit.PoundAvoirdupoisPerPsi:
      return "pound (avoirdupois) per psi";
    case Unit.PoundAvoirdupoisPerMinute:
      return "pound (avoirdupois) per minute";
    case Unit.PoundAvoirdupoisPerMinuteDegreeFahrenheit:
      return "pound (avoirdupois) per minute degree Fahrenheit";
    case Unit.PoundAvoirdupoisPerMinutePsi:
      return "pound (avoirdupois) per minute psi";
    case Unit.PoundAvoirdupoisPerSecond:
      return "pound (avoirdupois) per second";
    case Unit.PoundAvoirdupoisPerSecondDegreeFahrenheit:
      return "pound (avoirdupois) per second degree Fahrenheit";
    case Unit.PoundAvoirdupoisPerSecondPsi:
      return "pound (avoirdupois) per second psi";
    case Unit.PoundPerCubicYard:
      return "pound per cubic yard";
    case Unit.PoundForcePerSquareFoot:
      return "pound-force per square foot";
    case Unit.PoundForcePerSquareInchDegreeFahrenheit:
      return "pound-force per square inch degree Fahrenheit";
    case Unit.PsiCubicInchPerSecond:
      return "psi cubic inch per second";
    case Unit.PsiLitrePerSecond:
      return "psi litre per second";
    case Unit.PsiCubicMetrePerSecond:
      return "psi cubic metre per second";
    case Unit.PsiCubicYardPerSecond:
      return "psi cubic yard per second";
    case Unit.PoundForceSecondPerSquareFoot:
      return "pound-force second per square foot";
    case Unit.PoundForceSecondPerSquareInch:
      return "pound-force second per square inch";
    case Unit.ReciprocalPsi:
      return "reciprocal psi";
    case Unit.QuartUkLiquidPerDay:
      return "quart (UK liquid) per day";
    case Unit.QuartUkLiquidPerHour:
      return "quart (UK liquid) per hour";
    case Unit.QuartUkLiquidPerMinute:
      return "quart (UK liquid) per minute";
    case Unit.QuartUkLiquidPerSecond:
      return "quart (UK liquid) per second";
    case Unit.QuartUsLiquidPerDay:
      return "quart (US liquid) per day";
    case Unit.QuartUsLiquidPerHour:
      return "quart (US liquid) per hour";
    case Unit.Cake:
      return "cake";
    case Unit.Katal:
      return "katal";
    case Unit.Kilocharacter:
      return "kilocharacter";
    case Unit.Kilobar:
      return "kilobar";
    case Unit.KilogramCholineChloride:
      return "kilogram of choline chloride";
    case Unit.KilogramDrainedNetWeight:
      return "kilogram drained net weight";
    case Unit.Kelvin:
      return "kelvin";
    case Unit.Kilogram:
      return "kilogram";
    case Unit.KilogramPerSecond:
      return "kilogram per second";
    case Unit.KilogramHydrogenPeroxide:
      return "kilogram of hydrogen peroxide";
    case Unit.Kilohertz:
      return "kilohertz";
    case Unit.KilogramPerMillimetreWidth:
      return "kilogram per millimetre width";
    case Unit.KilogramIncludingContainer:
      return "kilogram, including container";
    case Unit.KilogramIncludingInnerPackaging:
      return "kilogram, including inner packaging";
    case Unit.Kilosegment:
      return "kilosegment";
    case Unit.Kilojoule:
      return "kilojoule";
    case Unit.KilogramPerMetre:
      return "kilogram per metre";
    case Unit.LacticDryMaterialPercentage:
      return "lactic dry material percentage";
    case Unit.Kilolux:
      return "kilolux";
    case Unit.KilogramMethylamine:
      return "kilogram of methylamine";
    case Unit.KilometrePerHour:
      return "kilometre per hour";
    case Unit.SquareKilometre:
      return "square kilometre";
    case Unit.KilogramPerCubicMetre:
      return "kilogram per cubic metre";
    case Unit.Kilometre:
      return "kilometre";
    case Unit.KilogramNitrogen:
      return "kilogram of nitrogen";
    case Unit.KilonewtonPerSquareMetre:
      return "kilonewton per square metre";
    case Unit.KilogramNamedSubstance:
      return "kilogram named substance";
    case Unit.Knot:
      return "knot";
    case Unit.MilliequivalenceCausticPotashPerGramProduct:
      return "milliequivalence caustic potash per gram of product";
    case Unit.Kilopascal:
      return "kilopascal";
    case Unit.KilogramPotassiumHydroxideCausticPotash:
      return "kilogram of potassium hydroxide (caustic potash)";
    case Unit.KilogramPotassiumOxide:
      return "kilogram of potassium oxide";
    case Unit.KilogramPhosphorusPentoxidePhosphoricAnhydride:
      return "kilogram of phosphorus pentoxide (phosphoric anhydride)";
    case Unit.Kiloroentgen:
      return "kiloroentgen";
    case Unit.KilogramSubstance90Dry:
      return "kilogram of substance 90 % dry";
    case Unit.KilogramSodiumHydroxideCausticSoda:
      return "kilogram of sodium hydroxide (caustic soda)";
    case Unit.Kit:
      return "kit";
    case Unit.Kilotonne:
      return "kilotonne";
    case Unit.KilogramUranium:
      return "kilogram of uranium";
    case Unit.KilovoltAmpere:
      return "kilovolt - ampere";
    case Unit.Kilovar:
      return "kilovar";
    case Unit.Kilovolt:
      return "kilovolt";
    case Unit.KilogramPerMillimetre:
      return "kilogram per millimetre";
    case Unit.KilowattHour:
      return "kilowatt hour";
    case Unit.KilowattHourPerNormalizedCubicMetre:
      return "Kilowatt hour per normalized cubic metre";
    case Unit.KilogramTungstenTrioxide:
      return "kilogram of tungsten trioxide";
    case Unit.KilowattHourPerStandardCubicMetre:
      return "Kilowatt hour per standard cubic metre";
    case Unit.Kilowatt:
      return "kilowatt";
    case Unit.KilowattYear:
      return "kilowatt year";
    case Unit.MillilitrePerKilogram:
      return "millilitre per kilogram";
    case Unit.QuartUsLiquidPerMinute:
      return "quart (US liquid) per minute";
    case Unit.QuartUsLiquidPerSecond:
      return "quart (US liquid) per second";
    case Unit.MetrePerSecondKelvin:
      return "metre per second kelvin";
    case Unit.MetrePerSecondBar:
      return "metre per second bar";
    case Unit.SquareMetreHourDegreeCelsiusPerKilocalorieInternationalTable:
      return "square metre hour degree Celsius per kilocalorie (international table)";
    case Unit.MillipascalSecondPerKelvin:
      return "millipascal second per kelvin";
    case Unit.MillipascalSecondPerBar:
      return "millipascal second per bar";
    case Unit.MilligramPerCubicMetreKelvin:
      return "milligram per cubic metre kelvin";
    case Unit.MilligramPerCubicMetreBar:
      return "milligram per cubic metre bar";
    case Unit.MillilitrePerLitre:
      return "millilitre per litre";
    case Unit.LitrePerMinute:
      return "litre per minute";
    case Unit.ReciprocalCubicMillimetre:
      return "reciprocal cubic millimetre";
    case Unit.CubicMillimetrePerCubicMetre:
      return "cubic millimetre per cubic metre";
    case Unit.MolePerHour:
      return "mole per hour";
    case Unit.MolePerKilogramKelvin:
      return "mole per kilogram kelvin";
    case Unit.MolePerKilogramBar:
      return "mole per kilogram bar";
    case Unit.MolePerLitreKelvin:
      return "mole per litre kelvin";
    case Unit.MolePerLitreBar:
      return "mole per litre bar";
    case Unit.MolePerCubicMetreKelvin:
      return "mole per cubic metre kelvin";
    case Unit.MolePerCubicMetreBar:
      return "mole per cubic metre bar";
    case Unit.MolePerMinute:
      return "mole per minute";
    case Unit.MilliroentgenAequivalentMen:
      return "milliroentgen aequivalent men";
    case Unit.NanogramPerKilogram:
      return "nanogram per kilogram";
    case Unit.OunceAvoirdupoisPerDay:
      return "ounce (avoirdupois) per day";
    case Unit.OunceAvoirdupoisPerHour:
      return "ounce (avoirdupois) per hour";
    case Unit.OunceAvoirdupoisPerMinute:
      return "ounce (avoirdupois) per minute";
    case Unit.OunceAvoirdupoisPerSecond:
      return "ounce (avoirdupois) per second";
    case Unit.OunceAvoirdupoisPerGallonUk:
      return "ounce (avoirdupois) per gallon (UK)";
    case Unit.OunceAvoirdupoisPerGallonUs:
      return "ounce (avoirdupois) per gallon (US)";
    case Unit.OunceAvoirdupoisPerCubicInch:
      return "ounce (avoirdupois) per cubic inch";
    case Unit.OunceAvoirdupoisForce:
      return "ounce (avoirdupois)-force";
    case Unit.OunceAvoirdupoisForceInch:
      return "ounce (avoirdupois)-force inch";
    case Unit.PicosiemensPerMetre:
      return "picosiemens per metre";
    case Unit.PeckUk:
      return "peck (UK)";
    case Unit.PeckUkPerDay:
      return "peck (UK) per day";
    case Unit.PeckUkPerHour:
      return "peck (UK) per hour";
    case Unit.PeckUkPerMinute:
      return "peck (UK) per minute";
    case Unit.PeckUkPerSecond:
      return "peck (UK) per second";
    case Unit.PeckUsDryPerDay:
      return "peck (US dry) per day";
    case Unit.PeckUsDryPerHour:
      return "peck (US dry) per hour";
    case Unit.PeckUsDryPerMinute:
      return "peck (US dry) per minute";
    case Unit.PeckUsDryPerSecond:
      return "peck (US dry) per second";
    case Unit.PsiPerPsi:
      return "psi per psi";
    case Unit.PintUkPerDay:
      return "pint (UK) per day";
    case Unit.PintUkPerHour:
      return "pint (UK) per hour";
    case Unit.PintUkPerMinute:
      return "pint (UK) per minute";
    case Unit.PintUkPerSecond:
      return "pint (UK) per second";
    case Unit.PintUsLiquidPerDay:
      return "pint (US liquid) per day";
    case Unit.PintUsLiquidPerHour:
      return "pint (US liquid) per hour";
    case Unit.PintUsLiquidPerMinute:
      return "pint (US liquid) per minute";
    case Unit.PintUsLiquidPerSecond:
      return "pint (US liquid) per second";
    case Unit.SlugPerDay:
      return "slug per day";
    case Unit.SlugPerFootSecond:
      return "slug per foot second";
    case Unit.SlugPerCubicFoot:
      return "slug per cubic foot";
    case Unit.SlugPerHour:
      return "slug per hour";
    case Unit.SlugPerMinute:
      return "slug per minute";
    case Unit.SlugPerSecond:
      return "slug per second";
    case Unit.TonnePerKelvin:
      return "tonne per kelvin";
    case Unit.TonnePerBar:
      return "tonne per bar";
    case Unit.TonnePerDay:
      return "tonne per day";
    case Unit.TonnePerDayKelvin:
      return "tonne per day kelvin";
    case Unit.TonnePerDayBar:
      return "tonne per day bar";
    case Unit.TonnePerHourKelvin:
      return "tonne per hour kelvin";
    case Unit.TonnePerHourBar:
      return "tonne per hour bar";
    case Unit.TonnePerCubicMetreKelvin:
      return "tonne per cubic metre kelvin";
    case Unit.TonnePerCubicMetreBar:
      return "tonne per cubic metre bar";
    case Unit.TonnePerMinute:
      return "tonne per minute";
    case Unit.TonnePerMinuteKelvin:
      return "tonne per minute kelvin";
    case Unit.TonnePerMinuteBar:
      return "tonne per minute bar";
    case Unit.TonnePerSecond:
      return "tonne per second";
    case Unit.TonnePerSecondKelvin:
      return "tonne per second kelvin";
    case Unit.TonnePerSecondBar:
      return "tonne per second bar";
    case Unit.TonUkShipping:
      return "ton (UK shipping)";
    case Unit.TonLongPerDay:
      return "ton long per day";
    case Unit.TonUsShipping:
      return "ton (US shipping)";
    case Unit.TonShortPerDegreeFahrenheit:
      return "ton short per degree Fahrenheit";
    case Unit.TonShortPerDay:
      return "ton short per day";
    case Unit.TonShortPerHourDegreeFahrenheit:
      return "ton short per hour degree Fahrenheit";
    case Unit.TonShortPerHourPsi:
      return "ton short per hour psi";
    case Unit.TonShortPerPsi:
      return "ton short per psi";
    case Unit.TonUkLongPerCubicYard:
      return "ton (UK long) per cubic yard";
    case Unit.TonUsShortPerCubicYard:
      return "ton (US short) per cubic yard";
    case Unit.TonForceUsShort:
      return "ton-force (US short)";
    case Unit.CommonYear:
      return "common year";
    case Unit.SiderealYear:
      return "sidereal year";
    case Unit.YardPerDegreeFahrenheit:
      return "yard per degree Fahrenheit";
    case Unit.YardPerPsi:
      return "yard per psi";
    case Unit.PoundPerCubicInch:
      return "pound per cubic inch";
    case Unit.LactoseExcessPercentage:
      return "lactose excess percentage";
    case Unit.Pound:
      return "pound";
    case Unit.TroyPoundUs:
      return "troy pound (US)";
    case Unit.LitrePerDay:
      return "litre per day";
    case Unit.Leaf:
      return "leaf";
    case Unit.LinearFoot:
      return "linear foot";
    case Unit.LabourHour:
      return "labour hour";
    case Unit.Link:
      return "link";
    case Unit.LinearMetre:
      return "linear metre";
    case Unit.Length:
      return "length";
    case Unit.LotUnitProcurement:
      return "lot [unit of procurement]";
    case Unit.LiquidPound:
      return "liquid pound";
    case Unit.LitrePureAlcohol:
      return "litre of pure alcohol";
    case Unit.Layer:
      return "layer";
    case Unit.LumpSum:
      return "lump sum";
    case Unit.TonUkOrLongTonUs:
      return "ton (UK) or long ton (US)";
    case Unit.Litre:
      return "litre";
    case Unit.MetricTonLubricatingOil:
      return "metric ton, lubricating oil";
    case Unit.Lumen:
      return "lumen";
    case Unit.Lux:
      return "lux";
    case Unit.LinearYard:
      return "linear yard";
    case Unit.MilligramPerLitre:
      return "milligram per litre";
    case Unit.ReciprocalCubicYard:
      return "reciprocal cubic yard";
    case Unit.CubicYardPerDegreeFahrenheit:
      return "cubic yard per degree Fahrenheit";
    case Unit.CubicYardPerDay:
      return "cubic yard per day";
    case Unit.CubicYardPerHour:
      return "cubic yard per hour";
    case Unit.CubicYardPerPsi:
      return "cubic yard per psi";
    case Unit.CubicYardPerMinute:
      return "cubic yard per minute";
    case Unit.CubicYardPerSecond:
      return "cubic yard per second";
    case Unit.KilohertzMetre:
      return "kilohertz metre";
    case Unit.GigahertzMetre:
      return "gigahertz metre";
    case Unit.Beaufort:
      return "Beaufort";
    case Unit.ReciprocalMegakelvinOrMegakelvinToPowerMinusOne:
      return "reciprocal megakelvin or megakelvin to the power minus one";
    case Unit.ReciprocalKilovoltAmpereReciprocalHour:
      return "reciprocal kilovolt - ampere reciprocal hour";
    case Unit.MillilitrePerSquareCentimetreMinute:
      return "millilitre per square centimetre minute";
    case Unit.NewtonPerCentimetre:
      return "newton per centimetre";
    case Unit.OhmKilometre:
      return "ohm kilometre";
    case Unit.PercentPerDegreeCelsius:
      return "percent per degree Celsius";
    case Unit.GigaohmPerMetre:
      return "gigaohm per metre";
    case Unit.MegahertzMetre:
      return "megahertz metre";
    case Unit.KilogramPerKilogram:
      return "kilogram per kilogram";
    case Unit.ReciprocalVoltAmpereReciprocalSecond:
      return "reciprocal volt - ampere reciprocal second";
    case Unit.KilogramPerKilometre:
      return "kilogram per kilometre";
    case Unit.PascalSecondPerLitre:
      return "pascal second per litre";
    case Unit.MillimolePerLitre:
      return "millimole per litre";
    case Unit.NewtonMetrePerSquareMetre:
      return "newton metre per square metre";
    case Unit.MillivoltAmpere:
      return "millivolt - ampere";
    case Unit._30DayMonth:
      return "30-day month";
    case Unit.Actual360:
      return "actual/360";
    case Unit.KilometrePerSecondSquared:
      return "kilometre per second squared";
    case Unit.CentimetrePerSecondSquared:
      return "centimetre per second squared";
    case Unit.MonetaryValue:
      return "monetary value";
    case Unit.YardPerSecondSquared:
      return "yard per second squared";
    case Unit.MillimetrePerSecondSquared:
      return "millimetre per second squared";
    case Unit.MileStatuteMilePerSecondSquared:
      return "mile (statute mile) per second squared";
    case Unit.Mil:
      return "mil";
    case Unit.Revolution:
      return "revolution";
    case Unit.DegreeUnitAnglePerSecondSquared:
      return "degree [unit of angle] per second squared";
    case Unit.RevolutionPerMinute:
      return "revolution per minute ";
    case Unit.CircularMil:
      return "circular mil ";
    case Unit.SquareMileBasedOnUSSurveyFoot:
      return "square mile (based on U.S. survey foot) ";
    case Unit.ChainBasedOnUSSurveyFoot:
      return "chain (based on U.S. survey foot)";
    case Unit.Microcurie:
      return "microcurie";
    case Unit.Furlong:
      return "furlong";
    case Unit.FootUSSurvey:
      return "foot (U.S. survey) ";
    case Unit.MileBasedOnUSSurveyFoot:
      return "mile (based on U.S. survey foot) ";
    case Unit.MetrePerPascal:
      return "metre per pascal";
    case Unit.MetrePerRadiant:
      return "metre per radiant";
    case Unit.Shake:
      return "shake";
    case Unit.MilePerMinute:
      return "mile per minute ";
    case Unit.MilePerSecond:
      return "mile per second ";
    case Unit.MetrePerSecondPascal:
      return "metre per second pascal";
    case Unit.MetrePerHour:
      return "metre per hour";
    case Unit.InchPerYear:
      return "inch per year";
    case Unit.KilometrePerSecond:
      return "kilometre per second ";
    case Unit.InchPerMinute:
      return "inch per minute";
    case Unit.YardPerSecond:
      return "yard per second";
    case Unit.YardPerMinute:
      return "yard per minute";
    case Unit.YardPerHour:
      return "yard per hour";
    case Unit.AcreFootBasedOnUSSurveyFoot:
      return "acre-foot (based on U.S. survey foot)";
    case Unit.Cord128Ft3:
      return "cord (128 ft3)";
    case Unit.CubicMileUkStatute:
      return "cubic mile (UK statute)";
    case Unit.MicroInch:
      return "micro-inch";
    case Unit.TonRegister:
      return "ton, register ";
    case Unit.CubicMetrePerPascal:
      return "cubic metre per pascal";
    case Unit.Bel:
      return "bel";
    case Unit.KilogramPerCubicMetrePascal:
      return "kilogram per cubic metre pascal";
    case Unit.KilogramPerPascal:
      return "kilogram per pascal";
    case Unit.KilopoundForce:
      return "kilopound-force";
    case Unit.Poundal:
      return "poundal";
    case Unit.KilogramMetrePerSecondSquared:
      return "kilogram metre per second squared";
    case Unit.Pond:
      return "pond";
    case Unit.SquareFootPerHour:
      return "square foot per hour ";
    case Unit.StokesPerPascal:
      return "stokes per pascal";
    case Unit.SquareCentimetrePerSecond:
      return "square centimetre per second";
    case Unit.SquareMetrePerSecondPascal:
      return "square metre per second pascal";
    case Unit.Denier_Dup:
      return "denier ";
    case Unit.PoundPerYard:
      return "pound per yard ";
    case Unit.TonAssay:
      return "ton, assay";
    case Unit.Pfund:
      return "pfund";
    case Unit.KilogramPerSecondPascal:
      return "kilogram per second pascal";
    case Unit.TonnePerMonth:
      return "tonne per month";
    case Unit.TonnePerYear:
      return "tonne per year";
    case Unit.MillionBtuPer1000CubicFoot:
      return "million Btu per 1000 cubic foot";
    case Unit.KilopoundPerHour:
      return "kilopound per hour";
    case Unit.PoundPerPound:
      return "pound per pound";
    case Unit.PoundForceFoot:
      return "pound-force foot";
    case Unit.NewtonMetrePerRadian:
      return "newton metre per radian";
    case Unit.KilogramMetre:
      return "kilogram metre";
    case Unit.PoundalFoot:
      return "poundal foot";
    case Unit.PoundalInch:
      return "poundal inch";
    case Unit.DyneMetre:
      return "dyne metre";
    case Unit.KilogramCentimetrePerSecond:
      return "kilogram centimetre per second";
    case Unit.GramCentimetrePerSecond:
      return "gram centimetre per second";
    case Unit.MegavoltAmpereReactiveHour:
      return "megavolt ampere reactive hour";
    case Unit.Megalitre:
      return "megalitre";
    case Unit.Megametre:
      return "megametre";
    case Unit.Megavar:
      return "megavar";
    case Unit.Megawatt:
      return "megawatt";
    case Unit.ThousandStandardBrickEquivalent:
      return "thousand standard brick equivalent";
    case Unit.ThousandBoardFoot:
      return "thousand board foot";
    case Unit.Millibar:
      return "millibar";
    case Unit.Microgram:
      return "microgram";
    case Unit.Millicurie:
      return "millicurie";
    case Unit.AirDryMetricTon:
      return "air dry metric ton";
    case Unit.Milligram:
      return "milligram";
    case Unit.Megahertz:
      return "megahertz";
    case Unit.SquareMileStatuteMile:
      return "square mile (statute mile)";
    case Unit.Thousand:
      return "thousand";
    case Unit.MinuteUnitTime:
      return "minute [unit of time]";
    case Unit.Million:
      return "million";
    case Unit.MillionInternationalUnit:
      return "million international unit";
    case Unit.SquareMetreDay:
      return "Square Metre Day";
    case Unit.SquareMetreMonth:
      return "Square Metre Month";
    case Unit.SquareMetreWeek:
      return "Square Metre Week";
    case Unit.Milliard:
      return "milliard";
    case Unit.Millilitre:
      return "millilitre";
    case Unit.SquareMillimetre:
      return "square millimetre";
    case Unit.CubicMillimetre:
      return "cubic millimetre";
    case Unit.Millimetre:
      return "millimetre";
    case Unit.KilogramDryWeight:
      return "kilogram, dry weight";
    case Unit.MegaJoulePerNormalisedCubicMetre:
      return "Mega Joule per Normalised cubic Metre";
    case Unit.Month:
      return "month";
    case Unit.Megapascal:
      return "megapascal";
    case Unit.CubicMetreDay:
      return "Cubic Metre Day";
    case Unit.CubicMetrePerHour:
      return "cubic metre per hour";
    case Unit.CubicMetreMonth:
      return "Cubic Metre Month";
    case Unit.CubicMetrePerSecond:
      return "cubic metre per second";
    case Unit.CubicMetreWeek:
      return "Cubic Metre Week";
    case Unit.MetreDay:
      return "Metre Day";
    case Unit.MetreMonth:
      return "Metre Month";
    case Unit.MetreWeek:
      return "Metre Week";
    case Unit.MetrePerSecondSquared:
      return "metre per second squared";
    case Unit.SquareMetre:
      return "square metre";
    case Unit.CubicMetre:
      return "cubic metre";
    case Unit.Metre:
      return "metre";
    case Unit.MetrePerSecond:
      return "metre per second";
    case Unit.Milihertz:
      return "milihertz";
    case Unit.MegavoltAmpere:
      return "megavolt - ampere";
    case Unit.MegawattHour1000KwH:
      return "megawatt hour (1000 kW.h)";
    case Unit.PenCalorie:
      return "pen calorie";
    case Unit.PoundFootPerSecond:
      return "pound foot per second";
    case Unit.PoundInchPerSecond:
      return "pound inch per second";
    case Unit.Pferdestaerke:
      return "Pferdestaerke";
    case Unit.CentimetreMercury0Oc:
      return "centimetre of mercury (0 ºC)";
    case Unit.CentimetreWater4Oc:
      return "centimetre of water (4 ºC)";
    case Unit.FootWater392Of:
      return "foot of water (39.2 ºF)";
    case Unit.InchMercury32Of:
      return "inch of mercury (32 ºF)";
    case Unit.InchMercury60Of:
      return "inch of mercury (60 ºF)";
    case Unit.InchWater392Of:
      return "inch of water (39.2 ºF)";
    case Unit.InchWater60Of:
      return "inch of water (60 ºF)";
    case Unit.KipPerSquareInch:
      return "kip per square inch";
    case Unit.PoundalPerSquareFoot:
      return "poundal per square foot ";
    case Unit.OunceAvoirdupoisPerSquareInch:
      return "ounce (avoirdupois) per square inch ";
    case Unit.ConventionalMetreWater:
      return "conventional metre of water";
    case Unit.GramPerSquareMillimetre:
      return "gram per square millimetre";
    case Unit.PoundPerSquareYard:
      return "pound per square yard";
    case Unit.PoundalPerSquareInch:
      return "poundal per square inch";
    case Unit.FootToFourthPower:
      return "foot to the fourth power ";
    case Unit.CubicDecimetrePerKilogram:
      return "cubic decimetre per kilogram";
    case Unit.CubicFootPerPound:
      return "cubic foot per pound";
    case Unit.PrintPoint:
      return "print point";
    case Unit.CubicInchPerPound:
      return "cubic inch per pound";
    case Unit.KilonewtonPerMetre:
      return "kilonewton per metre";
    case Unit.PoundalPerInch:
      return "poundal per inch";
    case Unit.PoundForcePerYard:
      return "pound-force per yard";
    case Unit.PoundalSecondPerSquareFoot:
      return "poundal second per square foot ";
    case Unit.PoisePerPascal:
      return "poise per pascal";
    case Unit.NewtonSecondPerSquareMetre:
      return "newton second per square metre";
    case Unit.KilogramPerMetreSecond:
      return "kilogram per metre second";
    case Unit.KilogramPerMetreMinute:
      return "kilogram per metre minute";
    case Unit.KilogramPerMetreDay:
      return "kilogram per metre day";
    case Unit.KilogramPerMetreHour:
      return "kilogram per metre hour";
    case Unit.GramPerCentimetreSecond:
      return "gram per centimetre second";
    case Unit.PoundalSecondPerSquareInch:
      return "poundal second per square inch";
    case Unit.PoundPerFootMinute:
      return "pound per foot minute";
    case Unit.PoundPerFootDay:
      return "pound per foot day";
    case Unit.CubicMetrePerSecondPascal:
      return "cubic metre per second pascal";
    case Unit.FootPoundal:
      return "foot poundal";
    case Unit.InchPoundal:
      return "inch poundal";
    case Unit.WattPerSquareCentimetre:
      return "watt per square centimetre ";
    case Unit.WattPerSquareInch:
      return "watt per square inch ";
    case Unit.BritishThermalUnitInternationalTablePerSquareFootHour:
      return "British thermal unit (international table) per square foot hour";
    case Unit.BritishThermalUnitThermochemicalPerSquareFootHour:
      return "British thermal unit (thermochemical) per square foot hour";
    case Unit.BritishThermalUnitThermochemicalPerSquareFootMinute:
      return "British thermal unit (thermochemical) per square foot minute";
    case Unit.BritishThermalUnitInternationalTablePerSquareFootSecond:
      return "British thermal unit (international table) per square foot second";
    case Unit.BritishThermalUnitThermochemicalPerSquareFootSecond:
      return "British thermal unit (thermochemical) per square foot second";
    case Unit.BritishThermalUnitInternationalTablePerSquareInchSecond:
      return "British thermal unit (international table) per square inch second";
    case Unit.CalorieThermochemicalPerSquareCentimetreMinute:
      return "calorie (thermochemical) per square centimetre minute";
    case Unit.CalorieThermochemicalPerSquareCentimetreSecond:
      return "calorie (thermochemical) per square centimetre second";
    case Unit.BritishThermalUnitInternationalTablePerCubicFoot:
      return "British thermal unit (international table) per cubic foot ";
    case Unit.BritishThermalUnitThermochemicalPerCubicFoot:
      return "British thermal unit (thermochemical) per cubic foot";
    case Unit.BritishThermalUnitInternationalTablePerDegreeFahrenheit:
      return "British thermal unit (international table) per degree Fahrenheit";
    case Unit.BritishThermalUnitThermochemicalPerDegreeFahrenheit:
      return "British thermal unit (thermochemical) per degree Fahrenheit";
    case Unit.BritishThermalUnitInternationalTablePerDegreeRankine:
      return "British thermal unit (international table) per degree Rankine";
    case Unit.BritishThermalUnitThermochemicalPerDegreeRankine:
      return "British thermal unit (thermochemical) per degree Rankine";
    case Unit.BritishThermalUnitThermochemicalPerPoundDegreeRankine:
      return "British thermal unit (thermochemical) per pound degree Rankine";
    case Unit.KilocalorieInternationalTablePerGramKelvin:
      return "kilocalorie (international table) per gram kelvin";
    case Unit.BritishThermalUnit39Of:
      return "British thermal unit (39 ºF) ";
    case Unit.BritishThermalUnit59Of:
      return "British thermal unit (59 ºF)";
    case Unit.BritishThermalUnit60Of:
      return "British thermal unit (60 ºF) ";
    case Unit.Calorie20Oc:
      return "calorie (20 ºC) ";
    case Unit.Quad1015Btuit:
      return "quad (1015 BtuIT)";
    case Unit.ThermEc:
      return "therm (EC)";
    case Unit.ThermUS:
      return "therm (U.S.)";
    case Unit.BritishThermalUnitThermochemicalPerPound:
      return "British thermal unit (thermochemical) per pound";
    case Unit.BritishThermalUnitInternationalTablePerHourSquareFootDegreeFahrenheit:
      return "British thermal unit (international table) per hour square foot degree Fahrenheit";
    case Unit.BritishThermalUnitThermochemicalPerHourSquareFootDegreeFahrenheit:
      return "British thermal unit (thermochemical) per hour square foot degree Fahrenheit";
    case Unit.BritishThermalUnitInternationalTablePerSecondSquareFootDegreeFahrenheit:
      return "British thermal unit (international table) per second square foot degree Fahrenheit";
    case Unit.BritishThermalUnitThermochemicalPerSecondSquareFootDegreeFahrenheit:
      return "British thermal unit (thermochemical) per second square foot degree Fahrenheit";
    case Unit.KilowattPerSquareMetreKelvin:
      return "kilowatt per square metre kelvin";
    case Unit.KelvinPerPascal:
      return "kelvin per pascal";
    case Unit.WattPerMetreDegreeCelsius:
      return "watt per metre degree Celsius";
    case Unit.KilowattPerMetreKelvin:
      return "kilowatt per metre kelvin";
    case Unit.KilowattPerMetreDegreeCelsius:
      return "kilowatt per metre degree Celsius";
    case Unit.MetrePerDegreeCelciusMetre:
      return "metre per degree Celcius metre";
    case Unit.DegreeFahrenheitHourPerBritishThermalUnitInternationalTable:
      return "degree Fahrenheit hour per British thermal unit (international table)";
    case Unit.DegreeFahrenheitHourPerBritishThermalUnitThermochemical:
      return "degree Fahrenheit hour per British thermal unit (thermochemical)";
    case Unit.DegreeFahrenheitSecondPerBritishThermalUnitInternationalTable:
      return "degree Fahrenheit second per British thermal unit (international table)";
    case Unit.DegreeFahrenheitSecondPerBritishThermalUnitThermochemical:
      return "degree Fahrenheit second per British thermal unit (thermochemical)";
    case Unit.DegreeFahrenheitHourSquareFootPerBritishThermalUnitInternationalTableInch:
      return "degree Fahrenheit hour square foot per British thermal unit (international table) inch";
    case Unit.DegreeFahrenheitHourSquareFootPerBritishThermalUnitThermochemicalInch:
      return "degree Fahrenheit hour square foot per British thermal unit (thermochemical) inch";
    case Unit.Kilofarad:
      return "kilofarad";
    case Unit.ReciprocalJoule:
      return "reciprocal joule";
    case Unit.Picosiemens:
      return "picosiemens";
    case Unit.AmperePerPascal:
      return "ampere per pascal";
    case Unit.Franklin:
      return "franklin";
    case Unit.AmpereMinute:
      return "ampere minute";
    case Unit.Biot:
      return "biot";
    case Unit.Gilbert:
      return "gilbert";
    case Unit.VoltPerPascal:
      return "volt per pascal";
    case Unit.Picovolt:
      return "picovolt";
    case Unit.MilligramPerKilogram:
      return "milligram per kilogram";
    case Unit.NumberArticles:
      return "number of articles";
    case Unit.NumberCells:
      return "number of cells";
    case Unit.Newton:
      return "newton";
    case Unit.Message:
      return "message";
    case Unit.Nil:
      return "nil";
    case Unit.NumberInternationalUnits:
      return "number of international units";
    case Unit.Load:
      return "load";
    case Unit.NormalisedCubicMetre:
      return "Normalised cubic metre";
    case Unit.NauticalMile:
      return "nautical mile";
    case Unit.NumberPacks:
      return "number of packs";
    case Unit.NumberParts:
      return "number of parts";
    case Unit.NetTon:
      return "net ton";
    case Unit.NephelometricTurbidityUnit:
      return "Nephelometric turbidity unit";
    case Unit.NewtonMetre:
      return "newton metre";
    case Unit.PartPerThousand:
      return "part per thousand";
    case Unit.Panel:
      return "panel";
    case Unit.OzoneDepletionEquivalent:
      return "ozone depletion equivalent";
    case Unit.OdsGrams:
      return "ODS Grams";
    case Unit.OdsKilograms:
      return "ODS Kilograms";
    case Unit.OdsMilligrams:
      return "ODS Milligrams";
    case Unit.Ohm:
      return "ohm";
    case Unit.OuncePerSquareYard:
      return "ounce per square yard";
    case Unit.OunceAvoirdupois:
      return "ounce (avoirdupois)";
    case Unit.OscillationsPerMinute:
      return "oscillations per minute";
    case Unit.OvertimeHour:
      return "overtime hour";
    case Unit.FluidOunceUs:
      return "fluid ounce (US)";
    case Unit.FluidOunceUk:
      return "fluid ounce (UK)";
    case Unit.Percent:
      return "percent";
    case Unit.CoulombPerMetre:
      return "coulomb per metre";
    case Unit.Kiloweber:
      return "kiloweber";
    case Unit.Gamma:
      return "gamma";
    case Unit.Kilotesla:
      return "kilotesla";
    case Unit.JoulePerSecond:
      return "joule per second";
    case Unit.JoulePerMinute:
      return "joule per minute";
    case Unit.JoulePerHour:
      return "joule per hour";
    case Unit.JoulePerDay:
      return "joule per day";
    case Unit.KilojoulePerSecond:
      return "kilojoule per second";
    case Unit.KilojoulePerMinute:
      return "kilojoule per minute";
    case Unit.PoundPerFoot:
      return "pound per foot";
    case Unit.KilojoulePerHour:
      return "kilojoule per hour";
    case Unit.KilojoulePerDay:
      return "kilojoule per day";
    case Unit.Nanoohm:
      return "nanoohm";
    case Unit.OhmCircularMilPerFoot:
      return "ohm circular-mil per foot ";
    case Unit.Kilohenry:
      return "kilohenry";
    case Unit.LumenPerSquareFoot:
      return "lumen per square foot ";
    case Unit.Phot:
      return "phot";
    case Unit.Footcandle:
      return "footcandle";
    case Unit.CandelaPerSquareInch:
      return "candela per square inch ";
    case Unit.Footlambert:
      return "footlambert";
    case Unit.Lambert:
      return "lambert";
    case Unit.Stilb:
      return "stilb";
    case Unit.CandelaPerSquareFoot:
      return "candela per square foot";
    case Unit.Kilocandela:
      return "kilocandela";
    case Unit.Millicandela:
      return "millicandela";
    case Unit.HefnerKerze:
      return "Hefner-Kerze";
    case Unit.InternationalCandle:
      return "international candle ";
    case Unit.BritishThermalUnitInternationalTablePerSquareFoot:
      return "British thermal unit (international table) per square foot";
    case Unit.BritishThermalUnitThermochemicalPerSquareFoot:
      return "British thermal unit (thermochemical) per square foot";
    case Unit.CalorieThermochemicalPerSquareCentimetre:
      return "calorie (thermochemical) per square centimetre ";
    case Unit.Langley:
      return "langley";
    case Unit.DecadeLogarithmic:
      return "decade (logarithmic)";
    case Unit.PascalSquaredSecond:
      return "pascal squared second";
    case Unit.BelPerMetre:
      return "bel per metre";
    case Unit.PoundMole:
      return "pound mole";
    case Unit.PoundMolePerSecond:
      return "pound mole per second";
    case Unit.PoundMolePerMinute:
      return "pound mole per minute";
    case Unit.KilomolePerKilogram:
      return "kilomole per kilogram";
    case Unit.PoundMolePerPound:
      return "pound mole per pound";
    case Unit.NewtonSquareMetrePerAmpere:
      return "newton square metre per ampere";
    case Unit.FivePack:
      return "five pack";
    case Unit.WeberMetre:
      return "weber metre";
    case Unit.MolPerKilogramPascal:
      return "mol per kilogram pascal";
    case Unit.MolPerCubicMetrePascal:
      return "mol per cubic metre pascal";
    case Unit.UnitPole:
      return "unit pole ";
    case Unit.MilligrayPerSecond:
      return "milligray per second";
    case Unit.MicrograyPerSecond:
      return "microgray per second";
    case Unit.NanograyPerSecond:
      return "nanogray per second";
    case Unit.GrayPerMinute:
      return "gray per minute";
    case Unit.MilligrayPerMinute:
      return "milligray per minute";
    case Unit.MicrograyPerMinute:
      return "microgray per minute";
    case Unit.NanograyPerMinute:
      return "nanogray per minute";
    case Unit.GrayPerHour:
      return "gray per hour";
    case Unit.MilligrayPerHour:
      return "milligray per hour";
    case Unit.MicrograyPerHour:
      return "microgray per hour";
    case Unit.NanograyPerHour:
      return "nanogray per hour";
    case Unit.SievertPerSecond:
      return "sievert per second";
    case Unit.MillisievertPerSecond:
      return "millisievert per second";
    case Unit.MicrosievertPerSecond:
      return "microsievert per second";
    case Unit.NanosievertPerSecond:
      return "nanosievert per second";
    case Unit.RemPerSecond:
      return "rem per second";
    case Unit.SievertPerHour:
      return "sievert per hour";
    case Unit.MillisievertPerHour:
      return "millisievert per hour";
    case Unit.MicrosievertPerHour:
      return "microsievert per hour";
    case Unit.NanosievertPerHour:
      return "nanosievert per hour";
    case Unit.SievertPerMinute:
      return "sievert per minute";
    case Unit.MillisievertPerMinute:
      return "millisievert per minute";
    case Unit.MicrosievertPerMinute:
      return "microsievert per minute";
    case Unit.NanosievertPerMinute:
      return "nanosievert per minute";
    case Unit.ReciprocalSquareInch:
      return "reciprocal square inch";
    case Unit.PascalSquareMetrePerKilogram:
      return "pascal square metre per kilogram";
    case Unit.MillipascalPerMetre:
      return "millipascal per metre";
    case Unit.KilopascalPerMetre:
      return "kilopascal per metre";
    case Unit.HectopascalPerMetre:
      return "hectopascal per metre";
    case Unit.StandardAtmospherePerMetre:
      return "standard atmosphere per metre";
    case Unit.TechnicalAtmospherePerMetre:
      return "technical atmosphere per metre";
    case Unit.TorrPerMetre:
      return "torr per metre";
    case Unit.PsiPerInch:
      return "psi per inch";
    case Unit.CubicMetrePerSecondSquareMetre:
      return "cubic metre per second square metre";
    case Unit.Rhe:
      return "rhe";
    case Unit.PoundForceFootPerInch:
      return "pound-force foot per inch";
    case Unit.PoundForceInchPerInch:
      return "pound-force inch per inch ";
    case Unit.Perm0Oc:
      return "perm (0 ºC) ";
    case Unit.Perm23Oc:
      return "perm (23 ºC) ";
    case Unit.BytePerSecond:
      return "byte per second";
    case Unit.KilobytePerSecond:
      return "kilobyte per second";
    case Unit.MegabytePerSecond:
      return "megabyte per second";
    case Unit.ReciprocalVolt:
      return "reciprocal volt";
    case Unit.ReciprocalRadian:
      return "reciprocal radian";
    case Unit.PascalToPowerSumStoichiometricNumbers:
      return "pascal to the power sum of stoichiometric numbers";
    case Unit.MolePerCubivMetreToPowerSumStoichiometricNumbers:
      return "mole per cubiv metre to the power sum of stoichiometric numbers";
    case Unit.Pascal:
      return "pascal";
    case Unit.Pad:
      return "pad";
    case Unit.ProofLitre:
      return "proof litre";
    case Unit.ProofGallon:
      return "proof gallon";
    case Unit.Pitch:
      return "pitch";
    case Unit.DegreePlato:
      return "degree Plato";
    case Unit.PoundPerInchLength:
      return "pound per inch of length";
    case Unit.PagePerInch:
      return "page per inch";
    case Unit.Pair:
      return "pair";
    case Unit.PoundForcePerSquareInch:
      return "pound-force per square inch";
    case Unit.DryPintUs:
      return "dry pint (US)";
    case Unit.PintUk:
      return "pint (UK)";
    case Unit.LiquidPintUs:
      return "liquid pint (US)";
    case Unit.Portion:
      return "portion";
    case Unit.JoulePerTesla:
      return "joule per tesla";
    case Unit.Erlang:
      return "erlang";
    case Unit.Octet:
      return "octet";
    case Unit.OctetPerSecond:
      return "octet per second";
    case Unit.Shannon:
      return "shannon";
    case Unit.Hartley:
      return "hartley";
    case Unit.NaturalUnitInformation:
      return "natural unit of information";
    case Unit.ShannonPerSecond:
      return "shannon per second";
    case Unit.HartleyPerSecond:
      return "hartley per second";
    case Unit.NaturalUnitInformationPerSecond:
      return "natural unit of information per second";
    case Unit.SecondPerKilogramm:
      return "second per kilogramm";
    case Unit.WattSquareMetre:
      return "watt square metre";
    case Unit.SecondPerRadianCubicMetre:
      return "second per radian cubic metre";
    case Unit.WeberToPowerMinusOne:
      return "weber to the power minus one";
    case Unit.ReciprocalInch:
      return "reciprocal inch";
    case Unit.Dioptre:
      return "dioptre";
    case Unit.OnePerOne:
      return "one per one";
    case Unit.NewtonMetrePerMetre:
      return "newton metre per metre";
    case Unit.KilogramPerSquareMetrePascalSecond:
      return "kilogram per square metre pascal second";
    case Unit.MicrogramPerHectogram:
      return "microgram per hectogram";
    case Unit.Meal:
      return "meal";
    case Unit.PhPotentialHydrogen:
      return "pH (potential of Hydrogen)";
    case Unit.KilojoulePerGram:
      return "kilojoule per gram";
    case Unit.Femtolitre:
      return "femtolitre";
    case Unit.Picolitre:
      return "picolitre";
    case Unit.Nanolitre:
      return "nanolitre";
    case Unit.MegawattsPerMinute:
      return "megawatts per minute";
    case Unit.SquareMetrePerCubicMetre:
      return "square metre per cubic metre";
    case Unit.StandardCubicMetrePerDay:
      return "Standard cubic metre per day";
    case Unit.StandardCubicMetrePerHour:
      return "Standard cubic metre per hour";
    case Unit.NormalizedCubicMetrePerDay:
      return "Normalized cubic metre per day";
    case Unit.NormalizedCubicMetrePerHour:
      return "Normalized cubic metre per hour";
    case Unit.JoulePerNormalisedCubicMetre:
      return "Joule per normalised cubic metre";
    case Unit.JoulePerStandardCubicMetre:
      return "Joule per standard cubic metre";
    case Unit.PageFacsimile:
      return "page - facsimile";
    case Unit.QuarterAYear:
      return "quarter (of a year)";
    case Unit.PageHardcopy:
      return "page - hardcopy";
    case Unit.Quire:
      return "quire";
    case Unit.DryQuartUs:
      return "dry quart (US)";
    case Unit.QuartUk:
      return "quart (UK)";
    case Unit.LiquidQuartUs:
      return "liquid quart (US)";
    case Unit.QuarterUk:
      return "quarter (UK)";
    case Unit.Pica:
      return "pica";
    case Unit.ThousandCubicMetre:
      return "thousand cubic metre";
    case Unit.RunningOrOperatingHour:
      return "running or operating hour";
    case Unit.Ream:
      return "ream";
    case Unit.Room:
      return "room";
    case Unit.PoundPerReam:
      return "pound per ream";
    case Unit.RevolutionsPerMinute:
      return "revolutions per minute";
    case Unit.RevolutionsPerSecond:
      return "revolutions per second";
    case Unit.RevenueTonMile:
      return "revenue ton mile";
    case Unit.SquareFootPerSecond:
      return "square foot per second";
    case Unit.SquareMetrePerSecond:
      return "square metre per second";
    case Unit.HalfYear6Months:
      return "half year (6 months)";
    case Unit.Score:
      return "score";
    case Unit.Scruple:
      return "scruple";
    case Unit.SecondUnitTime:
      return "second [unit of time]";
    case Unit.Set:
      return "set";
    case Unit.Segment:
      return "segment";
    case Unit.Siemens:
      return "siemens";
    case Unit.StandardCubicMetre:
      return "Standard cubic metre";
    case Unit.MileStatuteMile:
      return "mile (statute mile)";
    case Unit.Square:
      return "square";
    case Unit.SquareRoofing:
      return "square, roofing";
    case Unit.Strip:
      return "strip";
    case Unit.Stick:
      return "stick";
    case Unit.StoneUk:
      return "stone (UK)";
    case Unit.StickCigarette:
      return "stick, cigarette";
    case Unit.StandardLitre:
      return "standard litre";
    case Unit.TonUsOrShortTonUkUs:
      return "ton (US) or short ton (UK/US)";
    case Unit.Straw:
      return "straw";
    case Unit.Skein:
      return "skein";
    case Unit.Shipment:
      return "shipment";
    case Unit.Syringe:
      return "syringe";
    case Unit.TelecommunicationLineInService:
      return "telecommunication line in service";
    case Unit.ThousandPiece:
      return "thousand piece";
    case Unit.KiloampereHourThousandAmpereHour:
      return "kiloampere hour (thousand ampere hour)";
    case Unit.TotalAcidNumber:
      return "total acid number";
    case Unit.ThousandSquareInch:
      return "thousand square inch";
    case Unit.MetricTonIncludingContainer:
      return "metric ton, including container";
    case Unit.MetricTonIncludingInnerPackaging:
      return "metric ton, including inner packaging";
    case Unit.TonneKilometre:
      return "tonne kilometre";
    case Unit.KilogramImportedMeatLessOffal:
      return "kilogram of imported meat, less offal";
    case Unit.TonneMetricTon:
      return "tonne (metric ton)";
    case Unit.TenPack:
      return "ten pack";
    case Unit.TeethPerInch:
      return "teeth per inch";
    case Unit.TenPair:
      return "ten pair";
    case Unit.ThousandCubicMetrePerDay:
      return "thousand cubic metre per day";
    case Unit.TrillionEur:
      return "trillion (EUR)";
    case Unit.TenSet:
      return "ten set";
    case Unit.TenThousandSticks:
      return "ten thousand sticks";
    case Unit.Treatment:
      return "treatment";
    case Unit.Tablet:
      return "tablet";
    case Unit.TelecommunicationLineInServiceAverage:
      return "telecommunication line in service average";
    case Unit.TelecommunicationPort:
      return "telecommunication port";
    case Unit.VoltAmperePerKilogram:
      return "volt - ampere per kilogram";
    case Unit.Volt:
      return "volt";
    case Unit.PercentVolume:
      return "percent volume";
    case Unit.WetKilo:
      return "wet kilo";
    case Unit.WattPerKilogram:
      return "watt per kilogram";
    case Unit.WetPound:
      return "wet pound";
    case Unit.Cord:
      return "cord";
    case Unit.WetTon:
      return "wet ton";
    case Unit.Weber:
      return "weber";
    case Unit.Week:
      return "week";
    case Unit.WineGallon:
      return "wine gallon";
    case Unit.WattHour:
      return "watt hour";
    case Unit.WorkingMonth:
      return "working month";
    case Unit.Standard:
      return "standard";
    case Unit.Watt:
      return "watt";
    case Unit.GuntersChain:
      return "Gunter's chain";
    case Unit.SquareYard:
      return "square yard";
    case Unit.CubicYard:
      return "cubic yard";
    case Unit.Yard:
      return "yard";
    case Unit.HangingContainer:
      return "hanging container";
    case Unit.Nanomole:
      return "nanomole";
    case Unit.Page:
      return "page";
    case Unit.MutuallyDefined:
      return "mutually defined";
    case Unit.DrumSteel:
      return "Drum, steel";
    case Unit.DrumAluminium:
      return "Drum, aluminium";
    case Unit.DrumPlywood:
      return "Drum, plywood";
    case Unit.ContainerFlexible:
      return "Container, flexible";
    case Unit.DrumFibre:
      return "Drum, fibre";
    case Unit.DrumWooden:
      return "Drum, wooden";
    case Unit.BarrelWooden:
      return "Barrel, wooden";
    case Unit.JerricanSteel:
      return "Jerrican, steel";
    case Unit.JerricanPlastic:
      return "Jerrican, plastic";
    case Unit.BagSuperBulk:
      return "Bag, super bulk";
    case Unit.BagPolybag:
      return "Bag, polybag";
    case Unit.BoxSteel:
      return "Box, steel";
    case Unit.BoxAluminium:
      return "Box, aluminium";
    case Unit.BoxNaturalWood:
      return "Box, natural wood";
    case Unit.BoxPlywood:
      return "Box, plywood";
    case Unit.BoxReconstitutedWood:
      return "Box, reconstituted wood";
    case Unit.BoxFibreboard:
      return "Box, fibreboard";
    case Unit.BoxPlastic:
      return "Box, plastic";
    case Unit.BagWovenPlastic:
      return "Bag, woven plastic";
    case Unit.BagTextile:
      return "Bag, textile ";
    case Unit.BagPaper:
      return "Bag, paper ";
    case Unit.CompositePackagingPlasticReceptacle:
      return "Composite packaging, plastic receptacle";
    case Unit.CompositePackagingGlassReceptacle:
      return "Composite packaging, glass receptacle";
    case Unit.CaseCar:
      return "Case, car";
    case Unit.CaseWooden:
      return "Case, wooden";
    case Unit.PalletWooden:
      return "Pallet, wooden";
    case Unit.CrateWooden:
      return "Crate, wooden";
    case Unit.BundleWooden:
      return "Bundle, wooden";
    case Unit.IntermediateBulkContainerRigidPlastic:
      return "Intermediate bulk container, rigid plastic";
    case Unit.ReceptacleFibre:
      return "Receptacle, fibre ";
    case Unit.ReceptaclePaper:
      return "Receptacle, paper ";
    case Unit.ReceptacleWooden:
      return "Receptacle, wooden ";
    case Unit.Aerosol:
      return "Aerosol";
    case Unit.PalletModularCollars80cms60cms:
      return "Pallet, modular, collars 80cms * 60cms ";
    case Unit.PalletShrinkwrapped:
      return "Pallet, shrinkwrapped ";
    case Unit.Pallet100cms110cms:
      return "Pallet, 100cms * 110cms ";
    case Unit.Clamshell:
      return "Clamshell";
    case Unit.Cone:
      return "Cone";
    case Unit.Ball_Dup:
      return "Ball";
    case Unit.AmpouleNonProtected:
      return "Ampoule, non-protected ";
    case Unit.AmpouleProtected:
      return "Ampoule, protected ";
    case Unit.Atomizer:
      return "Atomizer ";
    case Unit.Capsule:
      return "Capsule";
    case Unit.Belt:
      return "Belt";
    case Unit.Barrel:
      return "Barrel ";
    case Unit.Bobbin:
      return "Bobbin ";
    case Unit.BottlecrateBottlerack:
      return "Bottlecrate / bottlerack ";
    case Unit.Board:
      return "Board";
    case Unit.Bundle:
      return "Bundle ";
    case Unit.BalloonNonProtected:
      return "Balloon, non-protected ";
    case Unit.Bag:
      return "Bag";
    case Unit.Bunch:
      return "Bunch";
    case Unit.Bin:
      return "Bin";
    case Unit.Bucket:
      return "Bucket ";
    case Unit.Basket:
      return "Basket ";
    case Unit.BaleCompressed:
      return "Bale, compressed ";
    case Unit.Basin:
      return "Basin";
    case Unit.BaleNonCompressed:
      return "Bale, non-compressed ";
    case Unit.BottleNonProtectedCylindrical:
      return "Bottle, non-protected, cylindrical ";
    case Unit.BalloonProtected:
      return "Balloon, protected ";
    case Unit.BottleProtectedCylindrical:
      return "Bottle, protected cylindrical";
    case Unit.Bar:
      return "Bar";
    case Unit.BottleNonProtectedBulbous:
      return "Bottle, non-protected, bulbous ";
    case Unit.Bolt:
      return "Bolt ";
    case Unit.Butt:
      return "Butt ";
    case Unit.BottleProtectedBulbous:
      return "Bottle, protected bulbous";
    case Unit.BoxForLiquids:
      return "Box, for liquids";
    case Unit.Box:
      return "Box";
    case Unit.BoardInBundleBunchTruss:
      return "Board, in bundle/bunch/truss ";
    case Unit.BarsInBundleBunchTruss:
      return "Bars, in bundle/bunch/truss";
    case Unit.CanRectangular:
      return "Can, rectangular ";
    case Unit.CrateBeer:
      return "Crate, beer";
    case Unit.Churn:
      return "Churn";
    case Unit.CanWithHandleAndSpout:
      return "Can, with handle and spout ";
    case Unit.Creel:
      return "Creel";
    case Unit.Coffer:
      return "Coffer ";
    case Unit.Cage:
      return "Cage ";
    case Unit.Chest:
      return "Chest";
    case Unit.Canister:
      return "Canister ";
    case Unit.Coffin:
      return "Coffin ";
    case Unit.Cask:
      return "Cask ";
    case Unit.Coil:
      return "Coil ";
    case Unit.Card_Dup:
      return "Card";
    case Unit.ContainerNotOtherwiseSpecifiedAsTransportEquipment:
      return "Container, not otherwise specified as transport equipment";
    case Unit.CarboyNonProtected:
      return "Carboy, non-protected";
    case Unit.CarboyProtected:
      return "Carboy, protected";
    case Unit.Cartridge:
      return "Cartridge";
    case Unit.Crate:
      return "Crate";
    case Unit.Case:
      return "Case ";
    case Unit.Carton:
      return "Carton ";
    case Unit.Cup:
      return "Cup";
    case Unit.Cover:
      return "Cover";
    case Unit.CageRoll:
      return "Cage, roll ";
    case Unit.CanCylindrical:
      return "Can, cylindrical ";
    case Unit.Cylinder:
      return "Cylinder ";
    case Unit.Canvas:
      return "Canvas ";
    case Unit.CrateMultipleLayerPlastic:
      return "Crate, multiple layer, plastic ";
    case Unit.CrateMultipleLayerWooden:
      return "Crate, multiple layer, wooden";
    case Unit.CrateMultipleLayerCardboard:
      return "Crate, multiple layer, cardboard ";
    case Unit.CageCommonwealthHandlingEquipmentPoolChep:
      return "Cage, Commonwealth Handling Equipment Pool (CHEP)";
    case Unit.BoxCommonwealthHandlingEquipmentPoolChepEurobox:
      return "Box, Commonwealth Handling Equipment Pool (CHEP), Eurobox";
    case Unit.DrumIron:
      return "Drum, iron ";
    case Unit.DemijohnNonProtected:
      return "Demijohn, non-protected";
    case Unit.CrateBulkCardboard:
      return "Crate, bulk, cardboard ";
    case Unit.CrateBulkPlastic:
      return "Crate, bulk, plastic ";
    case Unit.CrateBulkWooden:
      return "Crate, bulk, wooden";
    case Unit.Dispenser:
      return "Dispenser";
    case Unit.DemijohnProtected:
      return "Demijohn, protected";
    case Unit.Drum:
      return "Drum ";
    case Unit.TrayOneLayerNoCoverPlastic:
      return "Tray, one layer no cover, plastic";
    case Unit.TrayOneLayerNoCoverWooden:
      return "Tray, one layer no cover, wooden ";
    case Unit.TrayOneLayerNoCoverPolystyrene:
      return "Tray, one layer no cover, polystyrene";
    case Unit.TrayOneLayerNoCoverCardboard:
      return "Tray, one layer no cover, cardboard";
    case Unit.TrayTwoLayersNoCoverPlasticTray:
      return "Tray, two layers no cover, plastic tray";
    case Unit.TrayTwoLayersNoCoverWooden:
      return "Tray, two layers no cover, wooden";
    case Unit.TrayTwoLayersNoCoverCardboard:
      return "Tray, two layers no cover, cardboard ";
    case Unit.BagPlastic:
      return "Bag, plastic ";
    case Unit.CaseWithPalletBase:
      return "Case, with pallet base ";
    case Unit.CaseWithPalletBaseWooden:
      return "Case, with pallet base, wooden ";
    case Unit.CaseWithPalletBaseCardboard:
      return "Case, with pallet base, cardboard";
    case Unit.CaseWithPalletBasePlastic:
      return "Case, with pallet base, plastic";
    case Unit.CaseWithPalletBaseMetal:
      return "Case, with pallet base, metal";
    case Unit.CaseIsothermic:
      return "Case, isothermic ";
    case Unit.Envelope:
      return "Envelope ";
    case Unit.Flexibag:
      return "Flexibag";
    case Unit.CrateFruit:
      return "Crate, fruit ";
    case Unit.CrateFramed:
      return "Crate, framed";
    case Unit.Flexitank:
      return "Flexitank";
    case Unit.Firkin:
      return "Firkin ";
    case Unit.Flask:
      return "Flask";
    case Unit.Footlocker:
      return "Footlocker ";
    case Unit.Filmpack:
      return "Filmpack ";
    case Unit.Frame:
      return "Frame";
    case Unit.Foodtainer:
      return "Foodtainer";
    case Unit.CartFlatbed:
      return "Cart, flatbed";
    case Unit.BagFlexibleContainer:
      return "Bag, flexible container";
    case Unit.BottleGas:
      return "Bottle, gas";
    case Unit.Girder:
      return "Girder ";
    case Unit.ContainerGallon:
      return "Container, gallon";
    case Unit.ReceptacleGlass:
      return "Receptacle, glass ";
    case Unit.TrayContainingHorizontallyStackedFlatItems:
      return "Tray, containing horizontally stacked flat items";
    case Unit.BagGunny:
      return "Bag, gunny";
    case Unit.GirdersInBundleBunchTruss:
      return "Girders, in bundle/bunch/truss ";
    case Unit.BasketWithHandlePlastic:
      return "Basket, with handle, plastic ";
    case Unit.BasketWithHandleWooden:
      return "Basket, with handle, wooden";
    case Unit.BasketWithHandleCardboard:
      return "Basket, with handle, cardboard ";
    case Unit.Hogshead:
      return "Hogshead ";
    case Unit.Hanger:
      return "Hanger";
    case Unit.Hamper:
      return "Hamper ";
    case Unit.PackageDisplayWooden:
      return "Package, display, wooden ";
    case Unit.PackageDisplayCardboard:
      return "Package, display, cardboard";
    case Unit.PackageDisplayPlastic:
      return "Package, display, plastic";
    case Unit.PackageDisplayMetal:
      return "Package, display, metal";
    case Unit.PackageShow:
      return "Package, show";
    case Unit.PackageFlow:
      return "Package, flow ";
    case Unit.PackagePaperWrapped:
      return "Package, paper wrapped";
    case Unit.DrumPlastic:
      return "Drum, plastic";
    case Unit.PackageCardboardWithBottleGripHoles:
      return "Package, cardboard, with bottle grip-holes ";
    case Unit.TrayRigidLiddedStackableCenTs144822002:
      return "Tray, rigid, lidded stackable (CEN TS 14482:2002)";
    case Unit.Ingot:
      return "Ingot";
    case Unit.IngotsInBundleBunchTruss:
      return "Ingots, in bundle/bunch/truss";
    case Unit.BagJumbo:
      return "Bag, jumbo";
    case Unit.JerricanRectangular:
      return "Jerrican, rectangular";
    case Unit.Jug:
      return "Jug";
    case Unit.Jar:
      return "Jar";
    case Unit.Jutebag:
      return "Jutebag";
    case Unit.JerricanCylindrical:
      return "Jerrican, cylindrical";
    case Unit.Keg:
      return "Keg";
    case Unit.Kit_Dup:
      return "Kit";
    case Unit.Luggage:
      return "Luggage";
    case Unit.Log:
      return "Log";
    case Unit.Lot:
      return "Lot";
    case Unit.Lug:
      return "Lug";
    case Unit.Liftvan:
      return "Liftvan";
    case Unit.LogsInBundleBunchTruss:
      return "Logs, in bundle/bunch/truss";
    case Unit.CrateMetal:
      return "Crate, metal";
    case Unit.BagMultiply:
      return "Bag, multiply";
    case Unit.CrateMilk:
      return "Crate, milk";
    case Unit.ContainerMetal:
      return "Container, metal";
    case Unit.ReceptacleMetal:
      return "Receptacle, metal ";
    case Unit.SackMultiWall:
      return "Sack, multi-wall ";
    case Unit.Mat:
      return "Mat";
    case Unit.ReceptaclePlasticWrapped:
      return "Receptacle, plastic wrapped ";
    case Unit.Matchbox:
      return "Matchbox ";
    case Unit.NotAvailable:
      return "Not available";
    case Unit.UnpackedOrUnpackaged:
      return "Unpacked or unpackaged ";
    case Unit.UnpackedOrUnpackagedSingleUnit:
      return "Unpacked or unpackaged, single unit";
    case Unit.UnpackedOrUnpackagedMultipleUnits:
      return "Unpacked or unpackaged, multiple units";
    case Unit.Nest:
      return "Nest ";
    case Unit.Net:
      return "Net";
    case Unit.NetTubePlastic:
      return "Net, tube, plastic ";
    case Unit.NetTubeTextile:
      return "Net, tube, textile ";
    case Unit.TwoSidedCageOnWheelsWithFixingStrap:
      return "Two sided cage on wheels with fixing strap";
    case Unit.Trolley:
      return "Trolley";
    case Unit.OnewayPalletIso012EuroPallet:
      return "Oneway pallet ISO 0 - 1/2 EURO Pallet";
    case Unit.OnewayPalletIso111EuroPallet:
      return "Oneway pallet ISO 1 - 1/1 EURO Pallet";
    case Unit.OnewayPalletIso221EuroPallet:
      return "Oneway pallet ISO 2 - 2/1 EURO Pallet";
    case Unit.PalletWithExceptionalDimensions:
      return "Pallet with exceptional dimensions";
    case Unit.WoodenPallet40CmX80Cm:
      return "Wooden pallet 40 cm x 80 cm";
    case Unit.PlasticPalletSrs60CmX80Cm:
      return "Plastic pallet SRS 60 cm x 80 cm";
    case Unit.PlasticPalletSrs80CmX120Cm:
      return "Plastic pallet SRS 80 cm x 120 cm";
    case Unit.PalletChep40CmX60Cm:
      return "Pallet, CHEP 40 cm x 60 cm";
    case Unit.PalletChep80CmX120Cm:
      return "Pallet, CHEP 80 cm x 120 cm";
    case Unit.PalletChep100CmX120Cm:
      return "Pallet, CHEP 100 cm x 120 cm";
    case Unit.PalletAs40681993:
      return "Pallet, AS 4068-1993";
    case Unit.PalletIsoT11:
      return "Pallet, ISO T11";
    case Unit.PlatformUnspecifiedWeightOrDimension:
      return "Platform, unspecified weight or dimension";
    case Unit.PalletIso012EuroPallet:
      return "Pallet ISO 0 - 1/2 EURO Pallet";
    case Unit.PalletIso111EuroPallet:
      return "Pallet ISO 1 - 1/1 EURO Pallet";
    case Unit.PalletIso221EuroPallet:
      return "Pallet ISO 2 – 2/1 EURO Pallet";
    case Unit._14EuroPallet:
      return "1/4 EURO Pallet";
    case Unit.Block:
      return "Block";
    case Unit._18EuroPallet:
      return "1/8 EURO Pallet";
    case Unit.SyntheticPalletIso1:
      return "Synthetic pallet ISO 1";
    case Unit.SyntheticPalletIso2:
      return "Synthetic pallet ISO 2";
    case Unit.WholesalerPallet:
      return "Wholesaler pallet";
    case Unit.Pallet80X100Cm:
      return "Pallet 80 X 100 cm";
    case Unit.Pallet60X100Cm:
      return "Pallet 60 X 100 cm";
    case Unit.OnewayPallet:
      return "Oneway pallet";
    case Unit.Octabin:
      return "Octabin";
    case Unit.ContainerOuter:
      return "Container, outer";
    case Unit.ReturnablePallet:
      return "Returnable pallet";
    case Unit.LargeBagPalletSized:
      return "Large bag, pallet sized";
    case Unit.AWheeledPalletWithRaisedRim81X67X135:
      return "A wheeled pallet with raised rim (81 x 67 x 135)";
    case Unit.AWheeledPalletWithRaisedRim81X72X135:
      return "A Wheeled pallet with raised rim (81 x 72 x 135)";
    case Unit.WheeledPalletWithRaisedRim81X60X16:
      return "Wheeled pallet with raised rim ( 81 x 60 x 16)";
    case Unit.ChepPallet60CmX80Cm:
      return "CHEP pallet 60 cm x 80 cm ";
    case Unit.Pan:
      return "Pan";
    case Unit.LprPallet60CmX80Cm:
      return "LPR pallet 60 cm x 80 cm";
    case Unit.LprPallet80CmX120Cm:
      return "LPR pallet 80 cm x 120 cm";
    case Unit.Packet:
      return "Packet ";
    case Unit.PalletBoxCombinedOpenEndedBoxAndPallet:
      return "Pallet, box Combined open-ended box and pallet";
    case Unit.Parcel:
      return "Parcel ";
    case Unit.PalletModularCollars80cms100cms:
      return "Pallet, modular, collars 80cms * 100cms ";
    case Unit.PalletModularCollars80cms120cms:
      return "Pallet, modular, collars 80cms * 120cms ";
    case Unit.Pen:
      return "Pen ";
    case Unit.Plate:
      return "Plate";
    case Unit.Pitcher:
      return "Pitcher";
    case Unit.Pipe:
      return "Pipe ";
    case Unit.Punnet:
      return "Punnet";
    case Unit.Package:
      return "Package";
    case Unit.Pail:
      return "Pail ";
    case Unit.Plank:
      return "Plank";
    case Unit.Pouch:
      return "Pouch";
    case Unit.Piece_Dup:
      return "Piece";
    case Unit.ReceptaclePlastic:
      return "Receptacle, plastic ";
    case Unit.Pot:
      return "Pot";
    case Unit.Tray:
      return "Tray ";
    case Unit.PipesInBundleBunchTruss:
      return "Pipes, in bundle/bunch/truss ";
    case Unit.Pallet:
      return "Pallet ";
    case Unit.PlatesInBundleBunchTruss:
      return "Plates, in bundle/bunch/truss";
    case Unit.PlanksInBundleBunchTruss:
      return "Planks, in bundle/bunch/truss";
    case Unit.DrumSteelNonRemovableHead:
      return "Drum, steel, non-removable head";
    case Unit.DrumSteelRemovableHead:
      return "Drum, steel, removable head";
    case Unit.DrumAluminiumNonRemovableHead:
      return "Drum, aluminium, non-removable head";
    case Unit.DrumAluminiumRemovableHead:
      return "Drum, aluminium, removable head";
    case Unit.DrumPlasticNonRemovableHead:
      return "Drum, plastic, non-removable head";
    case Unit.DrumPlasticRemovableHead:
      return "Drum, plastic, removable head";
    case Unit.BarrelWoodenBungType:
      return "Barrel, wooden, bung type";
    case Unit.BarrelWoodenRemovableHead:
      return "Barrel, wooden, removable head ";
    case Unit.JerricanSteelNonRemovableHead:
      return "Jerrican, steel, non-removable head";
    case Unit.JerricanSteelRemovableHead:
      return "Jerrican, steel, removable head";
    case Unit.JerricanPlasticNonRemovableHead:
      return "Jerrican, plastic, non-removable head";
    case Unit.JerricanPlasticRemovableHead:
      return "Jerrican, plastic, removable head";
    case Unit.BoxWoodenNaturalWoodOrdinary:
      return "Box, wooden, natural wood, ordinary";
    case Unit.BoxWoodenNaturalWoodWithSiftProofWalls:
      return "Box, wooden, natural wood, with sift proof walls";
    case Unit.BoxPlasticExpanded:
      return "Box, plastic, expanded ";
    case Unit.BoxPlasticSolid:
      return "Box, plastic, solid";
    case Unit.Rod:
      return "Rod";
    case Unit.Ring:
      return "Ring ";
    case Unit.RackClothingHanger:
      return "Rack, clothing hanger";
    case Unit.Rack:
      return "Rack ";
    case Unit.Reel:
      return "Reel ";
    case Unit.Roll:
      return "Roll ";
    case Unit.Rednet:
      return "Rednet ";
    case Unit.RodsInBundleBunchTruss:
      return "Rods, in bundle/bunch/truss";
    case Unit.Sack:
      return "Sack ";
    case Unit.Slab:
      return "Slab";
    case Unit.CrateShallow:
      return "Crate, shallow ";
    case Unit.Spindle:
      return "Spindle";
    case Unit.SeaChest:
      return "Sea-chest";
    case Unit.Sachet:
      return "Sachet ";
    case Unit.Skid:
      return "Skid ";
    case Unit.CaseSkeleton:
      return "Case, skeleton ";
    case Unit.Slipsheet:
      return "Slipsheet ";
    case Unit.Sheetmetal:
      return "Sheetmetal ";
    case Unit.Spool:
      return "Spool ";
    case Unit.SheetPlasticWrapping:
      return "Sheet, plastic wrapping";
    case Unit.CaseSteel:
      return "Case, steel";
    case Unit.Sheet:
      return "Sheet";
    case Unit.Suitcase:
      return "Suitcase ";
    case Unit.EnvelopeSteel:
      return "Envelope, steel";
    case Unit.Shrinkwrapped:
      return "Shrinkwrapped ";
    case Unit.Set_Dup:
      return "Set";
    case Unit.Sleeve:
      return "Sleeve";
    case Unit.SheetsInBundleBunchTruss:
      return "Sheets, in bundle/bunch/truss";
    case Unit.Tablet_Dup:
      return "Tablet";
    case Unit.Tub:
      return "Tub";
    case Unit.TeaChest:
      return "Tea-chest";
    case Unit.TubeCollapsible:
      return "Tube, collapsible";
    case Unit.Tyre_Dup:
      return "Tyre";
    case Unit.TankContainerGeneric:
      return "Tank container, generic";
    case Unit.Tierce:
      return "Tierce";
    case Unit.TankRectangular:
      return "Tank, rectangular";
    case Unit.TubWithLid:
      return "Tub, with lid";
    case Unit.Tin:
      return "Tin";
    case Unit.Tun:
      return "Tun";
    case Unit.Trunk:
      return "Trunk";
    case Unit.Truss:
      return "Truss";
    case Unit.BagTote:
      return "Bag, tote";
    case Unit.Tube:
      return "Tube ";
    case Unit.TubeWithNozzle:
      return "Tube, with nozzle ";
    case Unit.PalletTriwall:
      return "Pallet, triwall";
    case Unit.TankCylindrical:
      return "Tank, cylindrical";
    case Unit.TubesInBundleBunchTruss:
      return "Tubes, in bundle/bunch/truss ";
    case Unit.Uncaged:
      return "Uncaged ";
    case Unit.Unit:
      return "Unit";
    case Unit.Vat:
      return "Vat";
    case Unit.BulkGasAt1031MbarAnd15C:
      return "Bulk, gas (at 1031 mbar and 15°C)";
    case Unit.Vial:
      return "Vial ";
    case Unit.Vanpack:
      return "Vanpack ";
    case Unit.BulkLiquid:
      return "Bulk, liquid ";
    case Unit.Vehicle:
      return "Vehicle";
    case Unit.BulkSolidLargeParticlesNodules:
      return "Bulk, solid, large particles (“nodules”) ";
    case Unit.VacuumPacked:
      return "Vacuum-packed";
    case Unit.BulkLiquefiedGasAtAbnormalTemperaturePressure:
      return "Bulk, liquefied gas (at abnormal temperature/pressure) ";
    case Unit.BulkSolidGranularParticlesGrains:
      return "Bulk, solid, granular particles (“grains”) ";
    case Unit.BulkScrapMetal:
      return "Bulk, scrap metal";
    case Unit.BulkSolidFineParticlesPowders:
      return "Bulk, solid, fine particles (“powders”)";
    case Unit.IntermediateBulkContainer:
      return "Intermediate bulk container";
    case Unit.Wickerbottle:
      return "Wickerbottle ";
    case Unit.IntermediateBulkContainerSteel:
      return "Intermediate bulk container, steel ";
    case Unit.IntermediateBulkContainerAluminium:
      return "Intermediate bulk container, aluminium ";
    case Unit.IntermediateBulkContainerMetal:
      return "Intermediate bulk container, metal ";
    case Unit.IntermediateBulkContainerSteelPressurised10Kpa:
      return "Intermediate bulk container, steel, pressurised > 10 kpa";
    case Unit.IntermediateBulkContainerAluminiumPressurised10Kpa:
      return "Intermediate bulk container, aluminium, pressurised > 10 kpa";
    case Unit.IntermediateBulkContainerMetalPressure10Kpa:
      return "Intermediate bulk container, metal, pressure 10 kpa ";
    case Unit.IntermediateBulkContainerSteelLiquid:
      return "Intermediate bulk container, steel, liquid ";
    case Unit.IntermediateBulkContainerAluminiumLiquid:
      return "Intermediate bulk container, aluminium, liquid ";
    case Unit.IntermediateBulkContainerMetalLiquid:
      return "Intermediate bulk container, metal, liquid ";
    case Unit.IntermediateBulkContainerWovenPlasticWithoutCoatLiner:
      return "Intermediate bulk container, woven plastic, without coat/liner ";
    case Unit.IntermediateBulkContainerWovenPlasticCoated:
      return "Intermediate bulk container, woven plastic, coated ";
    case Unit.IntermediateBulkContainerWovenPlasticWithLiner:
      return "Intermediate bulk container, woven plastic, with liner ";
    case Unit.IntermediateBulkContainerWovenPlasticCoatedAndLiner:
      return "Intermediate bulk container, woven plastic, coated and liner ";
    case Unit.IntermediateBulkContainerPlasticFilm:
      return "Intermediate bulk container, plastic film";
    case Unit.IntermediateBulkContainerTextileWithOutCoatLiner:
      return "Intermediate bulk container, textile with out coat/liner ";
    case Unit.IntermediateBulkContainerNaturalWoodWithInnerLiner:
      return "Intermediate bulk container, natural wood, with inner liner";
    case Unit.IntermediateBulkContainerTextileCoated:
      return "Intermediate bulk container, textile, coated ";
    case Unit.IntermediateBulkContainerTextileWithLiner:
      return "Intermediate bulk container, textile, with liner ";
    case Unit.IntermediateBulkContainerTextileCoatedAndLiner:
      return "Intermediate bulk container, textile, coated and liner ";
    case Unit.IntermediateBulkContainerPlywoodWithInnerLiner:
      return "Intermediate bulk container, plywood, with inner liner ";
    case Unit.IntermediateBulkContainerReconstitutedWoodWithInnerLiner:
      return "Intermediate bulk container, reconstituted wood, with inner liner";
    case Unit.BagWovenPlasticWithoutInnerCoatLiner:
      return "Bag, woven plastic, without inner coat/liner ";
    case Unit.BagWovenPlasticSiftProof:
      return "Bag, woven plastic, sift proof ";
    case Unit.BagWovenPlasticWaterResistant:
      return "Bag, woven plastic, water resistant";
    case Unit.BagPlasticsFilm:
      return "Bag, plastics film ";
    case Unit.BagTextileWithoutInnerCoatLiner:
      return "Bag, textile, without inner coat/liner ";
    case Unit.BagTextileSiftProof:
      return "Bag, textile, sift proof ";
    case Unit.BagTextileWaterResistant:
      return "Bag, textile, water resistant";
    case Unit.BagPaperMultiWall:
      return "Bag, paper, multi-wall ";
    case Unit.BagPaperMultiWallWaterResistant:
      return "Bag, paper, multi-wall, water resistant";
    case Unit.CompositePackagingPlasticReceptacleInSteelDrum:
      return "Composite packaging, plastic receptacle in steel drum";
    case Unit.CompositePackagingPlasticReceptacleInSteelCrateBox:
      return "Composite packaging, plastic receptacle in steel crate box";
    case Unit.CompositePackagingPlasticReceptacleInAluminiumDrum:
      return "Composite packaging, plastic receptacle in aluminium drum";
    case Unit.CompositePackagingPlasticReceptacleInAluminiumCrate:
      return "Composite packaging, plastic receptacle in aluminium crate";
    case Unit.CompositePackagingPlasticReceptacleInWoodenBox:
      return "Composite packaging, plastic receptacle in wooden box";
    case Unit.CompositePackagingPlasticReceptacleInPlywoodDrum:
      return "Composite packaging, plastic receptacle in plywood drum";
    case Unit.CompositePackagingPlasticReceptacleInPlywoodBox:
      return "Composite packaging, plastic receptacle in plywood box ";
    case Unit.CompositePackagingPlasticReceptacleInFibreDrum:
      return "Composite packaging, plastic receptacle in fibre drum";
    case Unit.CompositePackagingPlasticReceptacleInFibreboardBox:
      return "Composite packaging, plastic receptacle in fibreboard box";
    case Unit.CompositePackagingPlasticReceptacleInPlasticDrum:
      return "Composite packaging, plastic receptacle in plastic drum";
    case Unit.CompositePackagingPlasticReceptacleInSolidPlasticBox:
      return "Composite packaging, plastic receptacle in solid plastic box";
    case Unit.CompositePackagingGlassReceptacleInSteelDrum:
      return "Composite packaging, glass receptacle in steel drum";
    case Unit.CompositePackagingGlassReceptacleInSteelCrateBox:
      return "Composite packaging, glass receptacle in steel crate box";
    case Unit.CompositePackagingGlassReceptacleInAluminiumDrum:
      return "Composite packaging, glass receptacle in aluminium drum";
    case Unit.CompositePackagingGlassReceptacleInAluminiumCrate:
      return "Composite packaging, glass receptacle in aluminium crate";
    case Unit.CompositePackagingGlassReceptacleInWoodenBox:
      return "Composite packaging, glass receptacle in wooden box";
    case Unit.CompositePackagingGlassReceptacleInPlywoodDrum:
      return "Composite packaging, glass receptacle in plywood drum";
    case Unit.CompositePackagingGlassReceptacleInWickerworkHamper:
      return "Composite packaging, glass receptacle in wickerwork hamper";
    case Unit.CompositePackagingGlassReceptacleInFibreDrum:
      return "Composite packaging, glass receptacle in fibre drum";
    case Unit.CompositePackagingGlassReceptacleInFibreboardBox:
      return "Composite packaging, glass receptacle in fibreboard box ";
    case Unit.CompositePackagingGlassReceptacleInExpandablePlasticPack:
      return "Composite packaging, glass receptacle in expandable plastic pack";
    case Unit.CompositePackagingGlassReceptacleInSolidPlasticPack:
      return "Composite packaging, glass receptacle in solid plastic pack";
    case Unit.IntermediateBulkContainerPaperMultiWall:
      return "Intermediate bulk container, paper, multi-wall ";
    case Unit.BagLarge:
      return "Bag, large ";
    case Unit.IntermediateBulkContainerPaperMultiWallWaterResistant:
      return "Intermediate bulk container, paper, multi-wall, water resistant";
    case Unit.IntermediateBulkContainerRigidPlasticWithStructuralEquipmentSolids:
      return "Intermediate bulk container, rigid plastic, with structural equipment, solids";
    case Unit.IntermediateBulkContainerRigidPlasticFreestandingSolids:
      return "Intermediate bulk container, rigid plastic, freestanding, solids";
    case Unit.IntermediateBulkContainerRigidPlasticWithStructuralEquipmentPressurised:
      return "Intermediate bulk container, rigid plastic, with structural equipment, pressurised";
    case Unit.IntermediateBulkContainerRigidPlasticFreestandingPressurised:
      return "Intermediate bulk container, rigid plastic, freestanding, pressurised";
    case Unit.IntermediateBulkContainerRigidPlasticWithStructuralEquipmentLiquids:
      return "Intermediate bulk container, rigid plastic, with structural equipment, liquids ";
    case Unit.IntermediateBulkContainerRigidPlasticFreestandingLiquids:
      return "Intermediate bulk container, rigid plastic, freestanding, liquids";
    case Unit.IntermediateBulkContainerCompositeRigidPlasticSolids:
      return "Intermediate bulk container, composite, rigid plastic, solids";
    case Unit.IntermediateBulkContainerCompositeFlexiblePlasticSolids:
      return "Intermediate bulk container, composite, flexible plastic, solids";
    case Unit.IntermediateBulkContainerCompositeRigidPlasticPressurised:
      return "Intermediate bulk container, composite, rigid plastic, pressurised ";
    case Unit.IntermediateBulkContainerCompositeFlexiblePlasticPressurised:
      return "Intermediate bulk container, composite, flexible plastic, pressurised";
    case Unit.IntermediateBulkContainerCompositeRigidPlasticLiquids:
      return "Intermediate bulk container, composite, rigid plastic, liquids";
    case Unit.IntermediateBulkContainerCompositeFlexiblePlasticLiquids:
      return "Intermediate bulk container, composite, flexible plastic, liquids ";
    case Unit.IntermediateBulkContainerComposite:
      return "Intermediate bulk container, composite";
    case Unit.IntermediateBulkContainerFibreboard:
      return "Intermediate bulk container, fibreboard";
    case Unit.IntermediateBulkContainerFlexible:
      return "Intermediate bulk container, flexible";
    case Unit.IntermediateBulkContainerMetalOtherThanSteel:
      return "Intermediate bulk container, metal, other than steel";
    case Unit.IntermediateBulkContainerNaturalWood:
      return "Intermediate bulk container, natural wood";
    case Unit.IntermediateBulkContainerPlywood:
      return "Intermediate bulk container, plywood";
    case Unit.IntermediateBulkContainerReconstitutedWood:
      return "Intermediate bulk container, reconstituted wood";
    case Unit.MutuallyDefined_Dup:
      return "Mutually defined ";
  }
}
